export const sugtstunvideoarchivesubtitles = {
    "1": {
        "1": {
            "startTime": 39.028,
            "endTime": 47.835,
            "numberTitle": 1,
            "sug": [
                [
                    "Uksumi,",
                    "In the winter time,"
                ],
                [
                    "sun’araat pisu’aqata",
                    "when the young men were out hunting"
                ],
                [
                    "angutet katurlluteng.",
                    "the old men would gather."
                ]
            ],
            "fullEnglish": "In the winter time, when the young men were out hunting the old men would gather."
        },
        "2": {
            "startTime": 47.835,
            "endTime": 65.204,
            "sug": [
                [
                    "Qasgimi",
                    "In the gathering hut,"
                ],
                [
                    "aqum’aluteng",
                    "they would sit"
                ],
                [
                    "kenrem awatiini",
                    "around the fire"
                ],
                [
                    "qasgim qukaani",
                    "within the gathering hut"
                ],
                [
                    "quli’anguarluteng.",
                    "and tell stories."
                ],
                [
                    "Unut tak’sqat kiturluki.",
                    "They would while away these long [winter nights]."
                ]
            ],
            "fullEnglish": "In the gathering hut, they would sit around the fire within the gathering hut and tell stories. They would while away these long [winter nights]."
        },
        "3": {
            "startTime": 65.204,
            "endTime": 75.992,
            "sug": [
                [
                    "Tan’uraraat uksurkilnguut pisuryartaan’ilnguut",
                    "Boys that were not old enough to go hunting"
                ],
                [
                    "maliglluki",
                    "would go along"
                ],
                [
                    "nitniqiyaturluteng.",
                    "to listen."
                ]
            ],
            "fullEnglish": "Boys that were not old enough to go hunting would go along to listen."
        },
        "4": {
            "startTime": 75.992,
            "endTime": 88.121,
            "sug": [
                [
                    "Pingaklluku quli’anguat nitniqenrat pisurtet,",
                    "They liked to listen to the tales about great hunters,"
                ],
                [
                    "ellaita cai pisurtenguyuksaaqlluteng",
                    "because they all wanted to be great hunters"
                ],
                [
                    "anglikuneng.",
                    "when they grew up."
                ]
            ],
            "fullEnglish": "They liked to listen to the tales about great hunters, because they all wanted to be great hunters when they grew up."
        },
        "5": {
            "startTime": 88.121,
            "endTime": 99.97,
            "sug": [
                [
                    "Kesiin ar’ursulet quli’anguaqlluki aularnirngata",
                    "But when tales were told about the whale hunters,"
                ],
                [
                    "qumsugyugluteng pequit.",
                    "chills ran up and down their backs."
                ]
            ],
            "fullEnglish": "But when tales were told about the whale hunters, chills ran up and down their backs."
        },
        "6": {
            "startTime": 99.97,
            "endTime": 124.682,
            "numberTitle": 2,
            "sug": [
                [
                    "Tawarpiaq caqim qumcaayunguiqai qumsuuyugpakarluni,",
                    "A long, long time ago,"
                ],
                [
                    "allriluq angun quli’anguarluni aularnirluni,",
                    "one old man was telling,"
                ],
                [
                    "qangiq qangiq etaa’umallrai nuniitni ar’ursulek.",
                    "there lived in their village a great whale hunter."
                ]
            ],
            "fullEnglish": "A long, long time ago, one old man was telling, there lived in their village a great whale hunter."
        },
        "7": {
            "startTime": 124.682,
            "endTime": 137.571,
            "sug": [
                [
                    "Maaken qangiq cesten aularnillria ar’ursurluni",
                    "He hunted whale for so long"
                ],
                [
                    "kitum maani nunami umiaqegkunaku cami aularnillria.",
                    "that no one in the village could remember when he first started."
                ]
            ],
            "fullEnglish": "He hunted whale for so long that no one in the village could remember when he first started."
        },
        "8": {
            "startTime": 137.571,
            "endTime": 143.836,
            "sug": [
                [
                    "Tamaakerllainaq tamarluni ima’i piinani",
                    "He would disappear mysteriously and would be gone"
                ],
                [
                    "qaucin erneret.",
                    "for many days."
                ]
            ],
            "fullEnglish": "He would disappear mysteriously and would be gone for many days."
        },
        "9": {
            "startTime": 143.836,
            "endTime": 157.89,
            "sug": [
                [
                    "Tamaaken angiterainaqan",
                    "Every time he came back"
                ],
                [
                    "mulugkwarkunaku taug’um kingullrani,",
                    "after a few days later,"
                ],
                [
                    "ar’uq teplluku qutmen.",
                    "there would be a whale washed up on some beach."
                ]
            ],
            "fullEnglish": "Every time after he came back there would be a whale washed up on some beach a few days later."
        },
        "10": {
            "startTime": 157.89,
            "endTime": 167.346,
            "numberTitle": 3,
            "sug": [
                [
                    "Aa, nalluluku",
                    "No one knew"
                ],
                [
                    "cestun ar’uq tuqutaaqii.",
                    "how he killed the whale."
                ]
            ],
            "fullEnglish": "No one knew how he killed the whale."
        },
        "11": {
            "startTime": 167.346,
            "endTime": 179.02,
            "sug": [
                [
                    "Kesiin awa nallun’irluku",
                    "Only found out when"
                ],
                [
                    "tanura’armek kangiilltasqamek anglanasiigitasqamek",
                    "a boy who was full of curiousity and mischief"
                ],
                [
                    "angayungami,",
                    "he took as his partner,"
                ]
            ],
            "fullEnglish": "until he took for his partner a boy who was full of curiousity and mischief,"
        },
        "12": {
            "startTime": 179.02,
            "endTime": 184.946,
            "sug": [
                [
                    "ikna cali ar’ursurtenguyugluni",
                    "and who wanted to be a whale hunter too"
                ],
                [
                    "anglikuni.",
                    "when he grew up."
                ]
            ],
            "fullEnglish": "and who wanted to be a whale hunter too when he grew up."
        },
        "13": {
            "startTime": 184.946,
            "endTime": 193.724,
            "sug": [
                [
                    "Taug’um tanuraraam niitaa’umaluku",
                    "The boy heard"
                ],
                [
                    "ar’uq tuqutaarniluku ayaqumek,",
                    "that the whale was killed with a spear,"
                ]
            ],
            "fullEnglish": "The boy heard that the whale was killed with a spear,"
        },
        "14": {
            "startTime": 193.724,
            "endTime": 205.672,
            "sug": [
                [
                    "kesiin awa picingutegkunani",
                    "but he could not figure out"
                ],
                [
                    "cesten taaten angtasqaq ungwallriaq",
                    "how such a big animal"
                ],
                [
                    "tuqutekauluku ayaqungcugmek.",
                    "could be killed just by pricking it with a tiny spear."
                ]
            ],
            "fullEnglish": "but he could not figure out how such a big animal could be killed just by pricking it with a tiny spear."
        },
        "15": {
            "startTime": 205.672,
            "endTime": 215.51,
            "sug": [
                [
                    "Tawa umialinguq’umuuq",
                    "So he decided"
                ],
                [
                    "caqiq tamiin tang’rhniq’gkutarluku",
                    "to watch everything"
                ],
                [
                    "ar’ursulgem calicia.",
                    "the old whaler did."
                ]
            ],
            "fullEnglish": "So he decided to watch everything the old whaler did."
        },
        "16": {
            "startTime": 215.51,
            "endTime": 229.461,
            "numberTitle": 4,
            "sug": [
                [
                    "Qungu’ikaacata cami nunani",
                    "The day there was a burial in the village burial grounds,"
                ],
                [
                    "ar’ursulem tawa’i niu’ucimaa tan’uraq.",
                    "the whaler told the boy"
                ],
                [
                    "Tamaana akgua’aq ciqlluaminun taisq’lluku.",
                    "to come to his hut in the evening."
                ]
            ],
            "fullEnglish": "The day there was a burial in the village burial grounds, the whaler told the boy to come to his hut in the evening."
        },
        "17": {
            "startTime": 229.461,
            "endTime": 243.694,
            "sug": [
                [
                    "Tan’uraq agumaluni taumi",
                    "The boy went"
                ],
                [
                    "ar’ursulem niu’ucimaluku",
                    "and the whaler told him"
                ],
                [
                    "unuaquani unuami macaq suarpailan",
                    "that the next morning before the sun comes out"
                ],
                [
                    "aiwiciqniluni.",
                    "they will go away."
                ]
            ],
            "fullEnglish": "The boy went and the whaler told him that they will go away the next morning before the sun comes out."
        },
        "18": {
            "startTime": 243.694,
            "endTime": 261.487,
            "sug": [
                [
                    "Tawa’i niu’uluku tan’uraq",
                    "He told the boy"
                ],
                [
                    "unuk nangluku piiciiqniluni",
                    "that the would be gone all night,"
                ],
                [
                    "ciqlluaq uniceqegkunaku,",
                    "and that he must not leave the hut"
                ],
                [
                    "Tullgem mal’ugnek qaya’acia kesiin niskuniu.",
                    "until he hears a loon call twice."
                ]
            ],
            "fullEnglish": "He told the boy that the would be gone all night, and that he must not leave the hut until he hears a loon call twice."
        },
        "19": {
            "startTime": 261.487,
            "endTime": 278.105,
            "sug": [
                [
                    "Tawa pimaa,",
                    "He told the boy,"
                ],
                [
                    "“Niskugu tuullek mal’ugnek qay’aluku [Englartuq]",
                    "“When you hear the loon call twice,"
                ],
                [
                    "alli’anguan tuukiu",
                    "take your seal-skin bed"
                ],
                [
                    "qutem tawaken tailuten.",
                    "and come down to the beach."
                ],
                [
                    "Utaqaciqamken.”",
                    "I will be waiting for you.”"
                ]
            ],
            "fullEnglish": "“When you hear the loon call twice,” he told the boy, “take your seal-skin bed and come down to the beach. I will be waiting for you.”"
        },
        "20": {
            "startTime": 278.105,
            "endTime": 290.954,
            "sug": [
                [
                    "Qanganani at’ekaalluku",
                    "He put his qanganak (squirrel-skin parka) on"
                ],
                [
                    "amii’im piani nangarngaluni",
                    "and stood by the door"
                ],
                [
                    "tan’uraq mululuni ulutekegkaalluku pimaa.",
                    "looking at the boy for a long time."
                ]
            ],
            "fullEnglish": "He put his qanganak (squirrel-skin parka) on and stood by the door looking at him for a long time."
        },
        "21": {
            "startTime": 290.954,
            "endTime": 304.345,
            "sug": [
                [
                    "“Qungu’ikaataqata",
                    "(Then said), “After a burial"
                ],
                [
                    "caqit sulrayat unugmi kuingtaartut (tuqunrem)",
                    "evil spirits are always out at night"
                ],
                [
                    "tuqun’lleq iwa’iluku.”",
                    "looking for the body."
                ]
            ],
            "fullEnglish": "(Then said), “After a burial evil spirits are always out at night looking for the body."
        },
        "22": {
            "startTime": 304.345,
            "endTime": 313.644,
            "sug": [
                [
                    "Alingenillkina.",
                    "Don’t be afraid."
                ],
                [
                    "Ciqlluami ellkuut",
                    "If you stay in the hut"
                ],
                [
                    "cesten niu’ucimken",
                    "like I tell you,"
                ],
                [
                    "caqim piningaitaaten.",
                    "nothing will bother you."
                ]
            ],
            "fullEnglish": "Don’t be afraid. If you stay in the hut like I tell you, nothing will bother you."
        },
        "23": {
            "startTime": 313.644,
            "endTime": 324.118,
            "sug": [
                [
                    "Alingluten aularniquut",
                    "If you begin to feel creepy,"
                ],
                [
                    "kianit kenerkamek llii’iwiklluku",
                    "put wood on the coals"
                ],
                [
                    "pequn maqangcarluku.",
                    "and warm your back."
                ]
            ],
            "fullEnglish": "If you begin to feel creepy, put wood on the coals and warm your back."
        },
        "24": {
            "startTime": 324.118,
            "endTime": 336.093,
            "sug": [
                [
                    "Tamaani qumsuyuucin aw’arciquq.”",
                    "The creeps will go away.”"
                ],
                [
                    "Tawa tan’uraq aqumgaa’arluni,",
                    "The boy sat on the floor"
                ],
                [
                    "kianit ulutek[lluki],",
                    "watching the coals"
                ],
                [
                    "cesten niugtegkunani.",
                    "not saying a word."
                ]
            ],
            "fullEnglish": "The creeps will go away.” The boy sat on the floor watching the coals not saying a word."
        },
        "25": {
            "startTime": 336.093,
            "endTime": 342.358,
            "sug": [
                [
                    "Ar’ursulem ulutekgekaalluku",
                    "The whaler stood by the door and looked at him for a long time,"
                ],
                [
                    "anluni llaamen.",
                    "then went out."
                ]
            ],
            "fullEnglish": "The whaler stood by the door and looked at him for a long time, then went out."
        },
        "26": {
            "startTime": 342.358,
            "endTime": 352.947,
            "numberTitle": 5,
            "sug": [
                [
                    "Cikemyanrem angugkunaku",
                    "Faster than a wink"
                ],
                [
                    "tan’uraq amiigmen ageq’erlluni",
                    "the boy was at the door"
                ],
                [
                    "nasquni anlluku",
                    "and stuck his head out"
                ],
                [
                    "isu’im amian aciagun.",
                    "from under the seal-skin cover."
                ]
            ],
            "fullEnglish": "Faster than a wink the boy was at the door and stuck his head out from under the seal-skin cover."
        },
        "27": {
            "startTime": 352.947,
            "endTime": 369.311,
            "sug": [
                [
                    "Ugnerkarluni tamaani",
                    "It was spring time"
                ],
                [
                    "qilak akiqainarluni agyanek.",
                    "and the night was bright with stars."
                ],
                [
                    "Ar’ursulek agluni",
                    "The whaler was going"
                ],
                [
                    "qungut tungiitnun.",
                    "toward the burial grounds."
                ]
            ],
            "fullEnglish": "It was spring time and the night was bright with stars. The whaler was going toward the burial grounds."
        },
        "28": {
            "startTime": 369.311,
            "endTime": 380.356,
            "sug": [
                [
                    "Tawa’i aneq’erlluni",
                    "He slipped out"
                ],
                [
                    "maligcimaa,",
                    "and followed."
                ],
                [
                    "nepaillpiarluni maligcimaa tawa’i,",
                    "Very quietly he followed,"
                ],
                [
                    "awirluutengnaqegkunani.",
                    "trying not to make any noise."
                ]
            ],
            "fullEnglish": "He slipped out and followed. Very quietly he followed, trying not to make any noise."
        },
        "29": {
            "startTime": 380.356,
            "endTime": 392.837,
            "numberTitle": 6,
            "sug": [
                [
                    "Ar’ursulek tagqataa’arluni nunat, tamaagun ciqlluat ak[liitnun] (n)agtaarluni (or aku’inarpiarluni)",
                    "Slowly the whaler went through the village, stopping now and then"
                ],
                [
                    "ulutegluni",
                    "to look around"
                ],
                [
                    "nitniqiluni.",
                    "and listen,"
                ]
            ],
            "fullEnglish": "Slowly the whaler went through the village, stopping now and then to look around and listen,"
        },
        "30": {
            "startTime": 392.837,
            "endTime": 400.576,
            "sug": [
                [
                    "Iliini cikespiarluni acitmen,",
                    "sometimes stopping low"
                ],
                [
                    "ciqlluaq yaagiana[ku] kit’aqu[niu?]",
                    "when he had to pass close to a hut."
                ]
            ],
            "fullEnglish": "sometimes stopping low when he had to pass close to a hut."
        },
        "31": {
            "startTime": 400.576,
            "endTime": 413.714,
            "sug": [
                [
                    "Nunat kiturngami[ki]",
                    "When they passed the village"
                ],
                [
                    "nayanguarluni aularnirluni, kuinglluni",
                    "he started walking so fast"
                ],
                [
                    "taaten tan’uram angurarpiarluku kinguagun maliglluku.",
                    "the boy could hardly keep up with him."
                ]
            ],
            "fullEnglish": "When they passed the village he started walking so fast the boy could hardly keep up with him."
        },
        "32": {
            "startTime": 413.714,
            "endTime": 427.743,
            "sug": [
                [
                    "Taaten agluni ar’ursulek nagtegkunani",
                    "and he did not stop"
                ],
                [
                    "napasinaq acianun tawa tekinginaami",
                    "until he came to a big tree"
                ],
                [
                    "qunu’iwit caniatni.",
                    "not far from the burial grounds."
                ]
            ],
            "fullEnglish": "and he did not stop until he came to a big tree not far from the burial grounds."
        },
        "33": {
            "startTime": 427.743,
            "endTime": 439.572,
            "sug": [
                [
                    "Napam aciani taumi mululuni nangarngaluni,",
                    "He stood under the tree for a long time"
                ],
                [
                    "ulutegluni nitniqiluni,",
                    "looking around and listening,"
                ],
                [
                    "tawarpiaq kitumek utaqalillria.",
                    "as if he were waiting for someone."
                ]
            ],
            "fullEnglish": "He stood under the tree for a long time looking around and listening, as if he were waiting for someone."
        },
        "34": {
            "startTime": 439.572,
            "endTime": 449.717,
            "numberTitle": 7,
            "sug": [
                [
                    "Tamaakerllainaq tawa tan’uraraam tangqaarcimaa allakaq,",
                    "All at once the boy saw another form appear,"
                ],
                [
                    "kina nangarngaluni",
                    "someone standing"
                ],
                [
                    "ar’ursulgem caniani.",
                    "by the whaler."
                ]
            ],
            "fullEnglish": "All at once the boy saw another form appear by the whaler."
        },
        "35": {
            "startTime": 449.717,
            "endTime": 452.931,
            "sug": [
                [
                    "Cungasqa[g]nek iingalangq’rlluni.",
                    "It had green eyes."
                ]
            ],
            "fullEnglish": "It had green eyes."
        },
        "36": {
            "startTime": 452.931,
            "endTime": 468.743,
            "sug": [
                [
                    "Tawa’i takuyarngamiu iingalagnun,",
                    "When he looked at them"
                ],
                [
                    "tawarpiaq qaiqunasinak iluagnun ulutellria",
                    "he could see into deep caves"
                ],
                [
                    "nani kenret cungasqat akakainarluteng kuallriit.",
                    "where green flames were swirling around."
                ]
            ],
            "fullEnglish": "When he looked at them he could see into deep caves where green flames were swirling around."
        },
        "37": {
            "startTime": 468.743,
            "endTime": 474.683,
            "sug": [
                [
                    "Awa qama’ut tawarpiaq ing’im acianun pitallrek [?].",
                    "They seemed to lead way into the mountain."
                ]
            ],
            "fullEnglish": "They seemed to lead way into the mountain."
        },
        "38": {
            "startTime": 474.683,
            "endTime": 491.589,
            "sug": [
                [
                    "Tupagpakarluni",
                    "He was so frightened"
                ],
                [
                    "angitmen ciqlluamen qeceng’enitaqerluni.",
                    "he almost started to run back to the hut,"
                ],
                [
                    "Kesiin awa ar’ursulguyugpakarluni,",
                    "but he wanted to be a whaler so bad"
                ],
                [
                    "[...] tawa uulegteqainar[luni]. inarnga[luni]",
                    "he just lay quivering on the ground"
                ],
                [
                    "uluteklluk[ku].???",
                    "and watched."
                ]
            ],
            "fullEnglish": "He was so frightened he almost started to run back to the hut, but he wanted to be a whaler so bad he just lay quivering on the ground and watched."
        },
        "39": {
            "startTime": 491.589,
            "endTime": 505.055,
            "numberTitle": 8,
            "sug": [
                [
                    "Tawa tangerhngamiu",
                    "When he saw"
                ],
                [
                    "tangen’ilucini, [tangen’ilucini?]",
                    "that they did not notice him,"
                ],
                [
                    "alingucilleni awa’i kiturluni,",
                    "he got over his fright"
                ],
                [
                    "yaagiatmen taum[i] pangalagumuuq.",
                    "and crept closer."
                ]
            ],
            "fullEnglish": "When he saw that they did not notice him, he got over his fright and crept closer."
        },
        "40": {
            "startTime": 505.055,
            "endTime": 519.944,
            "sug": [
                [
                    "Taug’um caqim ar’ursulek nepainani caqimek niu’uqurlu[ku],",
                    "The thing was whispering something to the whaler"
                ],
                [
                    "ar’ursulek nasquni tawa’i aulateqaina[rluku]",
                    "and the whaler kept nodding his head"
                ],
                [
                    "cesten niugtegkunani.",
                    "without saying a word."
                ]
            ],
            "fullEnglish": "The thing was whispering something to the whaler and the whaler kept nodding his head without saying a word."
        },
        "41": {
            "startTime": 519.944,
            "endTime": 543.009,
            "sug": [
                [
                    "Tawa’i aigaminek kesiin, (--cesten pisiu?[?]) qungut tungiitnun aigaminek lliicaarluni,",
                    "Making a motion with his hand toward the burial grounds,"
                ],
                [
                    "tawa-llu ? tamartuq, tamarluni taugna sulrayaguaq cunga’iqerteqainarluni kingull[ra].",
                    "the thing disappeared in a green flash."
                ]
            ],
            "fullEnglish": "Making a motion with his hand toward the burial grounds, the thing disappeared in a green flash."
        },
        "42": {
            "startTime": 543.009,
            "endTime": 558.235,
            "numberTitle": 9,
            "sug": [
                [
                    "Ciminguan’ellpiarluni",
                    "Without hesitating"
                ],
                [
                    "ar’ursulek qungunun agluni,",
                    "the whaler went straight to the burial grounds"
                ],
                [
                    "naglluni gua’i nuta’am qungu’iwillrem / caniani.",
                    "and stepped besides the fresh mud"
                ]
            ],
            "fullEnglish": "Without hesitating the whaler went straight to the burial grounds and stepped besides the fresh mud"
        },
        "43": {
            "startTime": 558.235,
            "endTime": 587.112,
            "sug": [
                [
                    "Ulutekaalluni",
                    "and after looking around"
                ],
                [
                    "nitniqikaalluni,",
                    "and listening,"
                ],
                [
                    "nepuglluni aularnirluni, mampalluglluni, qunguq ii’uluku niu’a[luni], kuinglluni,",
                    "starting to chant and walk around the mound"
                ],
                [
                    "nayanguarkunani cuumi,",
                    "slowly at first,"
                ],
                [
                    "tawaken cukatmen, [nayanguarkunani?] cukatmen,",
                    "then faster and faster"
                ],
                [
                    "imani una kuingucia lliilesqatestun / pita’i[luni].",
                    "until his walk became a weird dance."
                ]
            ],
            "fullEnglish": "and after looking around and listening, starting to chant and walk around the mound slowly at first, then faster and faster until his walk became a weird dance."
        },
        "44": {
            "startTime": 587.112,
            "endTime": 601.145,
            "numberTitle": 10,
            "sug": [
                [
                    "Ulutekainanrani tawani tan’uraq,",
                    "As the boy watched,"
                ],
                [
                    "cungasqaq arillaq anluni / aularnirluni nunamek,",
                    "a green mist began to come out of the mound and spread out"
                ],
                [
                    "imani ar’ursulek patugaa.",
                    "until it covered the whaler."
                ]
            ],
            "fullEnglish": "As the boy watched, a green mist began to come out of the mound and spread out until it covered the whaler."
        },
        "45": {
            "startTime": 601.145,
            "endTime": 622.089,
            "sug": [
                [
                    "Aularnirluni akagluni (qungum) qunguq ii’uluku. Ar’ursulek ilakulluku tauna,",
                    "It began to spin around with the whaler,"
                ],
                [
                    "cuka’itmen, cuka’itmen,",
                    "getting faster and faster,"
                ],
                [
                    "caryarteqainarluni aqllatestun.",
                    "making a sound like a whirlwind."
                ]
            ],
            "fullEnglish": "It began to spin around with the whaler, getting faster and faster, making a sound like a whirlwind."
        },
        "46": {
            "startTime": 622.089,
            "endTime": 634.367,
            "sug": [
                [
                    "Tauna ar’ursulek akaglluku",
                    "It spun the whaler around the mound"
                ],
                [
                    "cuka’ingami,",
                    "so fast"
                ],
                [
                    "ar’ursulem itgaminek nuna agturarpiarluku.",
                    "he barely touched the ground with this toes."
                ]
            ],
            "fullEnglish": "It spun the whaler around the mound so fast he barely touched the ground with this toes."
        },
        "47": {
            "startTime": 634.367,
            "endTime": 646.021,
            "sug": [
                [
                    "Cuumi aularnirngami ar’ursulek akagluni taaten aigaminek lliicilinguarluni piluni.",
                    "At first the whaler spun around like a top making weird motions with his arms."
                ]
            ],
            "fullEnglish": "At first the whaler spun around like a top making weird motions with his arms."
        },
        "48": {
            "startTime": 646.021,
            "endTime": 659.702,
            "sug": [
                [
                    "Tawaken (aularnirluni) aulairluni akanermek,",
                    "Then he stopped spinning"
                ],
                [
                    "(agnguarlu--) lliilerluni,",
                    "and continued his dance"
                ],
                [
                    "tawa’i una qunguq kesiin caumaluku,",
                    "facing the mound."
                ]
            ],
            "fullEnglish": "Then he stopped spinning and continued his dance facing the mound."
        },
        "49": {
            "startTime": 659.702,
            "endTime": 676.05,
            "sug": [
                [
                    "itgak kesiin petaglutek.",
                    "Only his legs were moving."
                ],
                [
                    "Tawa’i nutaan lliilerluni aularnir[luni],",
                    "Now he danced around"
                ],
                [
                    "ipigni cuumini taani ang’allu[kek].",
                    "with his arms down before him holding his hands with palms up"
                ],
                [
                    "Tawarpiaq caqi tuukutaqii.",
                    "as if about to pick something up."
                ]
            ],
            "fullEnglish": "Only his legs were moving. Now he danced around with his arms down before him holding his hands with palms up as if about to pick something up."
        },
        "50": {
            "startTime": 676.05,
            "endTime": 681.956,
            "numberTitle": 11,
            "sug": [
                [
                    "Tawaken tan’uram niilluku",
                    "Then the boy heard"
                ],
                [
                    "suunia’aneq nunamek anluni.",
                    "moaning in the ground."
                ]
            ],
            "fullEnglish": "Then the boy heard moaning in the ground."
        },
        "51": {
            "startTime": 681.956,
            "endTime": 696.489,
            "sug": [
                [
                    "Ar’ursulgem taugna niicamiu,",
                    "When the whaler heard it,"
                ],
                [
                    "aularnirluni (tawarpiaq?) lliilerluni,",
                    "he broke into a wilder dance,"
                ],
                [
                    "iingalagni qungumek yun’illpiarlu[kek].",
                    "not once taking his eyes away from the mound."
                ]
            ],
            "fullEnglish": "When the whaler heard it, he broke into a wilder dance, not once taking his eyes away from the mound."
        },
        "52": {
            "startTime": 696.489,
            "endTime": 713.471,
            "sug": [
                [
                    "Awa’i nutaan taugna arillaq nunamek anesqaq nepuupakarlu[ni]",
                    "The whirling mist made so much noise now"
                ],
                [
                    "tan’uram ar’ursulek niitenirluku apallrucaa.",
                    "that the boy could hardly hear the whaler chant,"
                ]
            ],
            "fullEnglish": "The whirling mist made so much noise now that the boy could hardly hear the whaler chant,"
        },
        "53": {
            "startTime": 713.471,
            "endTime": 737.905,
            "sug": [
                [
                    "Tawaten nunamek anuucia[?] tukni’iluni",
                    "and it came out of the ground with such force"
                ],
                [
                    "taug’um cungasqam arillam iingalak um ar’ursulem ull’ukek,",
                    "that the boy could see in its green glow that the whaler’s eyelids were turned inside out"
                ],
                [
                    "qerllua taaten cali ull’uku ungai patuluki, nuyai naparlluki quletmen.",
                    "and his upper lip curled cover his mustache."
                ]
            ],
            "fullEnglish": "and it came out of the ground with such force that the boy could see in its green glow that the whaler’s eyelids were turned inside out and his upper lip curled cover his mustache."
        },
        "54": {
            "startTime": 737.905,
            "endTime": 748.301,
            "numberTitle": 12,
            "sug": [
                [
                    "Tawaken qunguq aularnirluni qus’i’itmen,",
                    "The mound began to rise"
                ],
                [
                    "Suunia’aciq cali emtu’itmen etu’i[tmen].",
                    "and the moaning became louder and louder."
                ]
            ],
            "fullEnglish": "The mound began to rise and the moaning became louder and louder."
        },
        "55": {
            "startTime": 748.301,
            "endTime": 769.916,
            "sug": [
                [
                    "Tawaken all’ingumek suunia’atmek emtusqamek anciluni,",
                    "Then, with one last moan,"
                ],
                [
                    "tuquneq akagluni nunamek,",
                    "the corpse rolled out of the ground"
                ],
                [
                    "tawarpiaq caqim cingkii,",
                    "as if pushed out by something,"
                ],
                [
                    "ar’ursulgem ipianun tull’uni.",
                    "right into the arms of the whaler."
                ]
            ],
            "fullEnglish": "Then, with one last moan, the corpse rolled out of the ground as if pushed out by something, right into the arms of the whaler."
        },
        "56": {
            "startTime": 769.916,
            "endTime": 776.083,
            "sug": [
                [
                    "tawaken arillaq tamarluni",
                    "The mist disappeared"
                ],
                [
                    "nepai’uspiarluni.",
                    "and it was suddenly quiet."
                ]
            ],
            "fullEnglish": "The mist disappeared and it was suddenly quiet."
        },
        "57": {
            "startTime": 776.083,
            "endTime": 783.633,
            "sug": [
                [
                    "Taumi tan’uraraam tawa kesiin niilluku ar’ursulgem / anertequcia.",
                    "The boy could hear only the panting of the whaler."
                ]
            ],
            "fullEnglish": "The boy could hear only the panting of the whaler."
        },
        "58": {
            "startTime": 783.633,
            "endTime": 795.1,
            "numberTitle": 13,
            "sug": [
                [
                    "Tawaken aqum’allakaalluni",
                    "After resting a while"
                ],
                [
                    "ar’ursulek aularnirluni",
                    "the whaler started"
                ],
                [
                    "tuquneq ipimini tuumiaq[lluku]",
                    "carrying the corpse in his arms"
                ],
                [
                    "qutem tungiinun esguar[luni].",
                    "down toward the beach."
                ]
            ],
            "fullEnglish": "After resting a while the whaler started down toward the beach carrying the corpse in his arms."
        },
        "59": {
            "startTime": 795.1,
            "endTime": 801.85,
            "sug": [
                [
                    "Tan’uram maligtegkunaku,",
                    "The boy did not follow,"
                ],
                [
                    "tawa[?] qecengqainarluni angitmen ciqlluamen",
                    "but ran to the hut as fast as he could,"
                ]
            ],
            "fullEnglish": "The boy did not follow, but ran to the hut as fast as he could,"
        },
        "60": {
            "startTime": 801.85,
            "endTime": 813.387,
            "sug": [
                [
                    "itqerlluni,",
                    "quickly entering"
                ],
                [
                    "alli’anguani tuuqainarlu[ku]",
                    "and grabbing his seal-skin bed"
                ],
                [
                    "qutmen esguarluni,",
                    "and ran down to the beach"
                ],
                [
                    "tep’am tunuanun nuuyaluni",
                    "and hid behind a big drift log"
                ],
                [
                    "utaqalirlu[ni].",
                    "and waited."
                ]
            ],
            "fullEnglish": "grabbing his seal-skin bed and ran down to the beach and hid behind a big drift log and waited."
        },
        "61": {
            "startTime": 813.387,
            "endTime": 824.016,
            "numberTitle": 14,
            "sug": [
                [
                    "Mulugkunani",
                    "Soon"
                ],
                [
                    "tawa niitaa niicimaa ar’ursulek",
                    "he heard the whaler"
                ],
                [
                    "qecengluni imaam seniigun.",
                    "running alongside the sea."
                ]
            ],
            "fullEnglish": "Soon he heard the whaler running alongside the sea."
        },
        "62": {
            "startTime": 824.016,
            "endTime": 839.749,
            "sug": [
                [
                    "Tuquneq taugna (lliiluku--) lliikaalluku",
                    "He put the corpse"
                ],
                [
                    "imaam seniinun,",
                    "close to the water’s edge"
                ],
                [
                    "qecengluni pama’ut qayaq esguaulluku,",
                    "and ran up to the kayak and carried it down"
                ],
                [
                    "tawaken tuquneq caqnerek akuliignun lliilu[ku].",
                    "and put the corpse between the two holes."
                ]
            ],
            "fullEnglish": "He put the corpse close to the water’s edge and ran up to the kayak and carried it down and put the corpse between the two holes."
        },
        "63": {
            "startTime": 839.749,
            "endTime": 852.505,
            "sug": [
                [
                    "Tawaken qutmen caukaalluni",
                    "Then facing toward the hut,"
                ],
                [
                    "aigani qanmi awatiinun lliikaallukek",
                    "he cupped his hands over his mouth"
                ],
                [
                    "tuullegt’stun mal’ugnek qaya’aluni.",
                    "and called twice like a loon."
                ]
            ],
            "fullEnglish": "Then facing toward the hut, he cupped his hands over his mouth and called twice like a loon."
        },
        "64": {
            "startTime": 852.505,
            "endTime": 864.603,
            "numberTitle": 15,
            "sug": [
                [
                    "Utaqaliqaalluni",
                    "After waiting a while"
                ],
                [
                    "tan’uraq, (utaqalir...ll[?]akaalluni] esguarluni",
                    "the boy went down"
                ],
                [
                    "iingalagni ulugua[r]ukek]",
                    "rubbing his eyes,"
                ],
                [
                    "qawarninguarluni.",
                    "pretending to be sleepy."
                ]
            ],
            "fullEnglish": "After waiting a while the boy went down rubbing his eyes, pretending to be sleepy."
        },
        "65": {
            "startTime": 864.603,
            "endTime": 882.666,
            "sug": [
                [
                    "Ar’ursulek atgurlluni,",
                    "The whaler was pleased"
                ],
                [
                    "tawaten tan’uram esgarngigtacia.",
                    "that he got down so soon"
                ],
                [
                    "Tawaken niu’ulluku",
                    "and told him"
                ],
                [
                    "cuqllirpaamen caqnermen aqumesqellu[ku].",
                    "to get in the front hole of the kayak."
                ]
            ],
            "fullEnglish": "The whaler was pleased that he got down so soon and told him to get in the front hole of the kayak."
        },
        "66": {
            "startTime": 882.666,
            "endTime": 892.321,
            "sug": [
                [
                    "Elliin ellminek tunumen eklluni,",
                    "Then he got in the hole behind"
                ],
                [
                    "patgutaminek cinguluku qayaq una.",
                    "and shoved out with his paddle."
                ]
            ],
            "fullEnglish": "Then he got in the hole behind and shoved out with his paddle."
        },
        "67": {
            "startTime": 892.321,
            "endTime": 908.473,
            "numberTitle": 16,
            "sug": [
                [
                    "Nepainatek tawaken pateglutek mululutek,",
                    "They paddled quietly for a long time."
                ],
                [
                    "cingiguaq qipkaalluku tawa’i,",
                    "When they rounded a point,"
                ],
                [
                    "ar’ursulem qayaq kangi’am iluanun caulluku",
                    "the whaler headed the kayak into a big bay"
                ],
                [
                    "[pigaa ta--] pimaa tan[‘uraq],",
                    "and said,"
                ]
            ],
            "fullEnglish": "They paddled quietly for a long time. When they rounded a point, the whaler headed the kayak into a big bay and said,"
        },
        "68": {
            "startTime": 908.473,
            "endTime": 923.92,
            "sug": [
                [
                    "“Kita!",
                    "“Now!"
                ],
                [
                    "Patgu (piug--) cesten pinrutaqainarcit!",
                    "Paddle as hard as you could!"
                ],
                [
                    "Kangiraam iluanun tut’engnaqciqu[kuk]",
                    "We must get to the head of the bay"
                ],
                [
                    "(erner--) (ernerupailan,) macaq suarpailan.",
                    "before daylight.”"
                ]
            ],
            "fullEnglish": "“Now! Paddle as hard as you could. We must get to the head of the bay before daylight.”"
        },
        "69": {
            "startTime": 923.92,
            "endTime": 941.635,
            "numberTitle": 17,
            "sug": [
                [
                    "Tawaken awa tan’uraq mernurluni,",
                    "At last, when the boy was so tired"
                ],
                [
                    "patgutani unakerarpiarluku,",
                    "that he could hardly raise up his paddle,"
                ],
                [
                    "tawa ar’ursulem pimaa,",
                    "the whaler said"
                ],
                [
                    "awa’i taaten pategpaka’asqegkunaku.",
                    "that he could paddle slower now."
                ]
            ],
            "fullEnglish": "At last, when the boy was so tired that he could hardly raise up his paddle, the whaler said that he could paddle slower now."
        },
        "70": {
            "startTime": 941.635,
            "endTime": 959.82,
            "sug": [
                [
                    "Cali tamlegluni,",
                    "It was still dark"
                ],
                [
                    "tawa natgun lurkilgnurkun penak akuliigkun, natmen kangi’armen iterya’armen tull’utek.",
                    "and they were going through a narrow passage between steep bluffs."
                ]
            ],
            "fullEnglish": "It was still dark and they were going through a narrow passage between steep bluffs."
        },
        "71": {
            "startTime": 959.82,
            "endTime": 968.408,
            "sug": [
                [
                    "Tamlegpakarluni",
                    "It got so dark now"
                ],
                [
                    "tan’u’araam (qayanguam cuung...) qayam cuungua’a tangerkaugkunaku.",
                    "the boy could not even see the bow of the kayak."
                ]
            ],
            "fullEnglish": "It got so dark now the boy could not even see the bow of the kayak."
        },
        "72": {
            "startTime": 968.408,
            "endTime": 981.48,
            "sug": [
                [
                    "Taaten ellma iluwaqaallu[tek]",
                    "After a short while going towards the back of the bay,"
                ],
                [
                    "ar’ursulem pimaa",
                    "the whaler told him"
                ],
                [
                    "nagceqlluku pat’nermek",
                    "to stop paddling"
                ],
                [
                    "nitniqisqelluku.",
                    "and listen."
                ]
            ],
            "fullEnglish": "After a short while the whaler told him to stop paddling and listen."
        },
        "73": {
            "startTime": 981.48,
            "endTime": 994.938,
            "sug": [
                [
                    "[?].",
                    "He stopped paddling and listened.[?]"
                ],
                [
                    "Awa nepaillpiarluni",
                    "It was so quiet"
                ],
                [
                    "tan’uraq umialinguarluni,",
                    "and he wondered,"
                ],
                [
                    "“Qaiqunam-qaa iluani et’ukuk?”",
                    "\"Did we enter a cave?\""
                ]
            ],
            "fullEnglish": "He stopped paddling and listened."
        },
        "74": {
            "startTime": 994.938,
            "endTime": 1000.022,
            "sug": [
                [
                    "Nitenerugkunani aqlla’aruaq.",
                    "There was not even a breath of air."
                ]
            ],
            "fullEnglish": "It was so quiet and dark he thought they were in a cave."
        },
        "75": {
            "startTime": 1000.022,
            "endTime": 1004.367,
            "sug": [
                [
                    "Qangyuguaq cali nitnerugkunani.",
                    "Nor a sound of a ripple."
                ]
            ],
            "fullEnglish": "There was not even a breath of air nor a sound of a ripple."
        },
        "76": {
            "startTime": 1004.367,
            "endTime": 1010.649,
            "sug": [
                [
                    "Umialinguarluni,",
                    "He wondered,"
                ],
                [
                    "“Naama-mi agyat akirpakasqat",
                    "\"What happened to the stars that were shining so brightly"
                ],
                [
                    "akgua’arpak?”",
                    "earlier in the night?\""
                ]
            ],
            "fullEnglish": "He wondered what happened to the stars that were shining so brightly earlier in the night."
        },
        "77": {
            "startTime": 1010.649,
            "endTime": 1033.873,
            "numberTitle": 18,
            "sug": [
                [
                    "Taani nepaipakarluku,",
                    "In the silence,"
                ],
                [
                    "umyugaanun tawa tai’uqaina tuquneq tawani tunukaa’armini,",
                    "he thought of the corpse in the kayak right behind the hole he was in"
                ],
                [
                    "cesten cali ar’ursulem giinaa tangqii,",
                    "and of how the whaler’s face looked,"
                ]
            ],
            "fullEnglish": "In the silence, he thought of the corpse in the kayak right behind the hole he was in and of how the whaler’s face looked,"
        },
        "78": {
            "startTime": 1033.873,
            "endTime": 1055.649,
            "sug": [
                [
                    "taug’umi cungasqami arillami",
                    "in the green glow"
                ],
                [
                    "iingalak taaten ullngalutek,",
                    "with the eyelids turned inside out"
                ],
                [
                    "qerllua, ungaan [..] patumalu[ni] cali ullngalu[ni] (..)",
                    "and the upper lip curled over his mustache"
                ],
                [
                    "lliilerngan",
                    "as he danced"
                ],
                [
                    "tawa’i qungum awatiini.",
                    "around the mound at the burial grounds."
                ]
            ],
            "fullEnglish": "in the green glow with the eyelids turned inside out and the upper lip curled over his mustache as he danced around the mound at the burial grounds."
        },
        "79": {
            "startTime": 1055.649,
            "endTime": 1064.501,
            "sug": [
                [
                    "Qumsuyugpakarluni",
                    "He began to feel so creepy"
                ],
                [
                    "umialinguarluni",
                    "he thought"
                ],
                [
                    "tuqunrem pat’shnasqaminek sua’aminek pequa qumcaayungiirluku.",
                    "the corpse was running its cold fingers up and down his back."
                ]
            ],
            "fullEnglish": "He began to feel so creepy he thought the corpse was running its cold fingers up and down his back."
        },
        "80": {
            "startTime": 1064.501,
            "endTime": 1078.689,
            "numberTitle": 19,
            "sug": [
                [
                    "Tamaakerllainaq",
                    "Then, so suddenly"
                ],
                [
                    "imarmen qetgeniterartestlluku",
                    "that it almost made him jump out of the kayak into the water,"
                ],
                [
                    "ar’ursulek nallugkuarluku",
                    "the whaler, without warning him,"
                ],
                [
                    "(tuullegnun) tuullegtestun qaya’aluni,",
                    "called out like a loon."
                ]
            ],
            "fullEnglish": "Then, so suddenly that it almost made him jump out of the kayak into the water, the whaler, without warning him, called out like a loon."
        },
        "81": {
            "startTime": 1078.689,
            "endTime": 1093.095,
            "sug": [
                [
                    "cali qetgeniterarluni imarmen akiurneret / angitmen taingata tungiitnun.",
                    "He almost jumped out again when echoes from every direction bounded back at them."
                ]
            ],
            "fullEnglish": "He almost jumped out again when echoes from every direction bounded back at them. He would have jumped out if he did not have his knees tightly braced against the sides of the kayak."
        },
        "82": {
            "startTime": 1093.095,
            "endTime": 1103.953,
            "sug": [
                [
                    "Tamaagun akiurneret tai’urluteng, yaatekaa’armek",
                    "The echoes were coming from so close"
                ],
                [
                    "tawarpiaq cuutiin iluani aularnillriit elliini.",
                    "he thought that they were starting right inside his ears."
                ]
            ],
            "fullEnglish": "The echoes were coming from so close he thought that they were starting right inside his ears."
        },
        "83": {
            "startTime": 1103.953,
            "endTime": 1117.387,
            "numberTitle": 20,
            "sug": [
                [
                    "Taaken akiurneret nagcata",
                    "When the echoes went away it was dead silent again."
                ],
                [
                    "naken (tunu--) yaatekaa’armek nunam tungiinek kiuluku cali tuullegt’stun.",
                    "Then there was an answering call from the darkness close ahead."
                ]
            ],
            "fullEnglish": "When the echoes went away it was dead silent again. Then there was an answering call from the darkness close ahead."
        },
        "84": {
            "startTime": 1117.387,
            "endTime": 1135.064,
            "sug": [
                [
                    "Awa cal[i] tan’uraq umialinguarluni",
                    "And then the boy thought"
                ],
                [
                    "akiurneret cali angiciiqut cali.",
                    "the echoes will come again."
                ],
                [
                    "Taaten qayamen cisqugminek angli tuumia[qeg]kaalluni,",
                    "He tightly braced his knees against the sides of the kayak,"
                ],
                [
                    "kesiin awa’i akiunret taigkunateng.",
                    "but the echoes didn't come."
                ]
            ],
            "fullEnglish": "The boy braced himself again and shut his eyes tight expecting the echoes to come, but there was none."
        },
        "85": {
            "startTime": 1135.064,
            "endTime": 1146.44,
            "numberTitle": 21,
            "sug": [
                [
                    "Ellma taatan patllakaalluteng",
                    "After paddling a short distance"
                ],
                [
                    "culurlluteng.",
                    "they landed."
                ],
                [
                    "Tan’uraq nalluluni nani et’a, natgun culurtak.",
                    "The boy did not have the slightest idea where he was."
                ]
            ],
            "fullEnglish": "After paddling a short distance they landed. The boy did not have the slightest idea where he was."
        },
        "86": {
            "startTime": 1146.44,
            "endTime": 1165.135,
            "sug": [
                [
                    "Taaten tamlegluni,",
                    "It was all darkness"
                ],
                [
                    "nepaillpairluni cali.",
                    "and quiet."
                ],
                [
                    "Qayaq cayugluku ar’ursulgem (...) nunatmen",
                    "The whaler yanked the kayak up"
                ],
                [
                    "tawa’i, niu’ucimaa tan’uraq; niu’ulluku tan’uraq maligceqlluni.",
                    "then told the boy to follow him."
                ]
            ],
            "fullEnglish": "It was all darkness and quiet. The whaler yanked the kayak up then told the boy to follow him."
        },
        "87": {
            "startTime": 1165.135,
            "endTime": 1182.089,
            "sug": [
                [
                    "Maliglluni tan'uraq ar'ursulgem nepii nitniqlluku. [?]",
                    "He followed by listening to his footsteps."
                ],
                [
                    "Tawa kelukaa’armi qutmek",
                    "A short distance from the beach"
                ],
                [
                    "ar’ursulek naglluni",
                    "the whaler stopped"
                ],
                [
                    "tan’uraq itresqelluku.",
                    "and told the boy to go in."
                ]
            ],
            "fullEnglish": "He followed by listening to his footsteps. A short distance from the beach the whaler stopped and told the boy to go in."
        },
        "88": {
            "startTime": 1182.089,
            "endTime": 1196.456,
            "sug": [
                [
                    "Tan’uraq nalluluni",
                    "The boy did not know"
                ],
                [
                    "nat’en iterta, ciqlluamen-qaa, qaiqunamen-qaa.",
                    "whether he was going into a cave or a hut"
                ],
                [
                    "Taaten tamlegpakarluni",
                    "since it was so dark"
                ],
                [
                    "umia[linguarluni]",
                    "and wondered"
                ],
                [
                    "cesten una ar’ursulek tangerta.",
                    "how the whaler could see."
                ]
            ],
            "fullEnglish": "The boy did not know whether he was going into a cave or a hut and wondered how the whaler could see."
        },
        "89": {
            "startTime": 1196.456,
            "endTime": 1210.28,
            "sug": [
                [
                    "Tawaken ar’ursulek kenliluni",
                    "After the whaler started a fire"
                ],
                [
                    "mal’uk (kenr--) qupuraak (ulug--) uluullukek.",
                    "by rubbing two sticks together,"
                ],
                [
                    "Taaten tangerluni,",
                    "he saw"
                ],
                [
                    "ciqlluami et’u(k).",
                    "that they were in a hut."
                ]
            ],
            "fullEnglish": "After the whaler started a fire by rubbing two sticks together, he saw that they were in a hut."
        },
        "90": {
            "startTime": 1210.28,
            "endTime": 1221.864,
            "numberTitle": 22,
            "sug": [
                [
                    "Keneq asirluni kuangan",
                    "When the fire was going good"
                ],
                [
                    "aqumuk iqallugturlutek,",
                    "they sat and ate dried fish"
                ],
                [
                    "tamuurturlutek isu’im uquanek / cali.",
                    "and seal blubber."
                ]
            ],
            "fullEnglish": "When the fire was going good they ate dried fish and seal blubber."
        },
        "91": {
            "startTime": 1221.864,
            "endTime": 1243.411,
            "sug": [
                [
                    "Nerngami",
                    "While they were eating,"
                ],
                [
                    "tan’uram ciqlluam tawa quliini puyum anguiagun tang’rluku",
                    "the boy could see through the opening on top of the hut for smoke to go out,"
                ],
                [
                    "awa’i ernia’artuq.",
                    "that it was beginning to dawn,"
                ],
                [
                    "Tawa’i neren’irngamek",
                    "and by the time they were finished"
                ],
                [
                    "awa’i erlluni tanqi’iluni.",
                    "it was daylight."
                ]
            ],
            "fullEnglish": "While they were eating, the boy could see through the opening on top of the hut for smoke to go out, that it was beginning to dawn, and by the time they were finished it was daylight."
        },
        "92": {
            "startTime": 1243.411,
            "endTime": 1255.248,
            "sug": [
                [
                    "Tanqi’ingan",
                    "With daylight"
                ],
                [
                    "suqani tatarcan",
                    "and with his stomach full"
                ],
                [
                    "awa tan’uraq alingenirluni.",
                    "the boy was not afraid anymore."
                ],
                [
                    "Tawa kangiiyukainarluni.",
                    "He was full of curiosity and amusement,"
                ]
            ],
            "fullEnglish": "With daylight and with his stomach full the boy was not afraid anymore."
        },
        "93": {
            "startTime": 1255.248,
            "endTime": 1273.026,
            "sug": [
                [
                    "Atam cali umialinguarluni aliasuutmek, caqimek aliasuutekciqau’u ar’ursulek caminguaqu",
                    "and entertained with something the whaler did another time."
                ],
                [
                    "[Englartuq]",
                    "[He laughs]"
                ]
            ],
            "fullEnglish": "He was full of curiosity and amusement, and entertained with something the whaler did another time. [He laughs]"
        },
        "94": {
            "startTime": 1273.026,
            "endTime": 1288.323,
            "numberTitle": 23,
            "sug": [
                [
                    "Qutmen esguarlutek.",
                    "They went down to the beach."
                ],
                [
                    "Tawaken tan’uraq kiarlluni tamiini,",
                    "The boy looked around,"
                ],
                [
                    "picingutegku[naku]",
                    "but he could not see"
                ],
                [
                    "natgun tawa’ut kangi’armen tut’ellriik.",
                    "where they came in from."
                ]
            ],
            "fullEnglish": "They went down to the beach. The boy looked around, but he could not see where they came in from."
        },
        "95": {
            "startTime": 1288.323,
            "endTime": 1296.011,
            "sug": [
                [
                    "Tep’anek tangruman’ellkuni qutmi",
                    "If it were not for the driftwood on the beach,"
                ],
                [
                    "nanwami ec’ukllu(ni).",
                    "he would have thought that they were in a lake."
                ]
            ],
            "fullEnglish": "If it were not for the driftwood on the beach, he would have thought that they were in a lake."
        },
        "96": {
            "startTime": 1296.011,
            "endTime": 1301.79,
            "sug": [
                [
                    "Taaten elngurmek nunamek cami tangeqsainani.",
                    "He never saw a place like that before."
                ]
            ],
            "fullEnglish": "He never saw a place like that before."
        },
        "97": {
            "startTime": 1301.79,
            "endTime": 1316.195,
            "sug": [
                [
                    "Taugna kesiin allriluq qutengcuk tawa’i,",
                    "Except for that one beach,"
                ],
                [
                    "tamaani awatii penarllainat,",
                    "there was nothing but steep bluffs all around"
                ],
                [
                    "taaten imarmen tusngaluteng.",
                    "going straight down to the water."
                ]
            ],
            "fullEnglish": "Except for that one beach, there was nothing but steep bluffs all around going straight down to the water."
        },
        "98": {
            "startTime": 1316.195,
            "endTime": 1338.307,
            "numberTitle": 24,
            "sug": [
                [
                    "Ar’ursulem ulutenillpiarluni",
                    "The whaler did not even look around."
                ],
                [
                    "tan’uraq tawa pimaa nayanguaraa’asqelluku,",
                    "He said to the boy,"
                ],
                [
                    "“Kita.",
                    "“Hurry now."
                ],
                [
                    "Qayak ciqlluam pianun tangutekutaraa.”",
                    "Let us carry the kayak by the hut.”"
                ],
                [
                    "Piluku,",
                    "He said,"
                ],
                [
                    "“Ellpet cuungau’akun tuukiu,",
                    "\"You pick up the front end,"
                ],
                [
                    "gui kingua tuuciqaqa.”",
                    "I will pick up the back end.”"
                ]
            ],
            "fullEnglish": "The whaler did not even look around. He said to the boy, “Hurry now. Let us carry the kayak by the hut. You pick up the front end, I will pick up the back end.”"
        },
        "99": {
            "startTime": 1338.307,
            "endTime": 1361.895,
            "sug": [
                [
                    "Qayaq-taqulwarlluku",
                    "They picked it up"
                ],
                [
                    "tan’uraq cali[?] (aliasuuteki--) aliasuuteklluku ar’ursulek",
                    "and the boy, with mischief,"
                ],
                [
                    "iquni aciwarlluku",
                    "let his end down"
                ],
                [
                    "apcimaa,",
                    "and asked,"
                ],
                [
                    "“Imaituq-qaa qayaq?”",
                    "“Is it empty?”"
                ],
                [
                    "Ar’ursulek aplluku.",
                    "he asked the whaler."
                ]
            ],
            "fullEnglish": "They picked it up and the boy, with mischief, let his end down and asked, “Is it empty?”"
        },
        "100": {
            "startTime": 1361.895,
            "endTime": 1376.603,
            "sug": [
                [
                    "(Taunga--) [Nagteraartuq]",
                    "[Stopping repeatedly]"
                ]
            ],
            "fullEnglish": "[Stopping repeatedly]"
        },
        "101": {
            "startTime": 1376.603,
            "endTime": 1384.74,
            "sug": [
                [
                    "Ar’ursulem cali elliin kinguangua’a qulwarngaluku",
                    "The whaler, still holding his end up,"
                ],
                [
                    "kiuluku imainiluku.",
                    "said that it was."
                ]
            ],
            "fullEnglish": "The whaler, still holding his end up, said that it was."
        },
        "102": {
            "startTime": 1384.74,
            "endTime": 1399.74,
            "sug": [
                [
                    "Taaken cali tan’uraraam cuunguaq qulwarlluku.",
                    "The boy picked his end up again,"
                ],
                [
                    "Taaken ar’ursulek takuyarluku,",
                    "and looking at the whaler,"
                ],
                [
                    "cali aplluku,",
                    "again asked,"
                ],
                [
                    "“Qayu-mi tamaani artunarpagta?”",
                    "“Then why is it so heavy?”"
                ]
            ],
            "fullEnglish": "The boy picked his end up again, and looking at the whaler, again asked, “Then why is it so heavy?”"
        },
        "103": {
            "startTime": 1399.74,
            "endTime": 1431.706,
            "sug": [
                [
                    "Ar’ursulek kigyangayagluni",
                    "Scowling, the whaler"
                ],
                [
                    "tuqllirluku pi[maa],",
                    "growled at him,"
                ],
                [
                    "“Apqau’itaan’ilu!",
                    "“Never ask any questions!"
                ],
                [
                    "Taaten calitaa’a cesten niu’utaten.",
                    "Just do what you are told."
                ],
                [
                    "Angayungiaraat liitut",
                    "Young hunting partners learn"
                ],
                [
                    "uluegluteng",
                    "by watching what is done"
                ],
                [
                    "cesten cali’at",
                    "and by doing what they are told to do."
                ],
                [
                    "apqau’igkunateng.”",
                    "But never by asking questions.”"
                ]
            ],
            "fullEnglish": "Scowling, the whaler growled at him, “Never ask any questions! Just do what you are told. Young hunting partners learn by watching what is done and by doing what they are told to do. But never by asking questions.”"
        },
        "104": {
            "startTime": 1431.706,
            "endTime": 1439.127,
            "sug": [
                [
                    "Tan’uraraam tawa’i cuunguaq qulwartekaa[lluku]",
                    "The boy picked his end up"
                ],
                [
                    "tagulluku ciqlluam pianun qayartek (sounds like katagte--)",
                    "and they carried the kayak up by the hut."
                ]
            ],
            "fullEnglish": "The boy picked his end up and they carried the kayak up by the hut."
        },
        "105": {
            "startTime": 1439.127,
            "endTime": 1451.157,
            "numberTitle": 25,
            "sug": [
                [
                    "Ciqlluam caniani,",
                    "By the hut,"
                ],
                [
                    "awatiini tawani, tan’uraq tamiini tawa’i ulutegluni, kiarlluni, nuna tang’rturluku.",
                    "the boy took a quick look around him."
                ]
            ],
            "fullEnglish": "By the hut, the boy took a quick look around him."
        },
        "106": {
            "startTime": 1451.157,
            "endTime": 1472.726,
            "sug": [
                [
                    "Nuna tawaten napanek patumaluni,",
                    "The ground was flat and covered with trees"
                ],
                [
                    "paagut penasinat tungiitnun [...]tengia’ar[luni?] napat akulii[tgun].",
                    "and went some ways back up there toward another steep bluff."
                ]
            ],
            "fullEnglish": "The ground was flat and covered with trees and went some ways back up there toward another steep bluff."
        },
        "107": {
            "startTime": 1472.726,
            "endTime": 1493.191,
            "sug": [
                [
                    "Tawa’i ulutenrani [.]",
                    "While he was looking around,"
                ],
                [
                    "ar’ursulem cali kigyangayagluni [Englartuq]",
                    "the whaler, still scowling, [He laughs]"
                ],
                [
                    "niu’ulluku tan’uraq",
                    "told him"
                ],
                [
                    "piiciiqniluni, (aa,)",
                    "that he would be gone for a while"
                ],
                [
                    "ciqlluami ec’eqlluku (.)",
                    "and that he must stay in the hut"
                ],
                [
                    "keneq kuagkwarluku",
                    "and keep the fire going"
                ],
                [
                    "angihnatminun.",
                    "until he came back."
                ]
            ],
            "fullEnglish": "While he was looking around, the whaler, still scowling, told him that he would be gone for a while and that he must stay in the hut and keep the fire going until he came back."
        },
        "108": {
            "startTime": 1496.006,
            "endTime": 1511.561,
            "numberTitle": 26,
            "sug": [
                [
                    "Tawaken tan’uraq ciqlluamen (iterluni) itrutmini",
                    "The boy went in the hut"
                ],
                [
                    "tawa weg’et / akuliitgun sua’ani iterlluki caqneliluni",
                    "and as soon as he got in poked a hole with his finger through the straw between the slats"
                ],
                [
                    "teriklluku ar’ursulek.",
                    "and peeked out."
                ]
            ],
            "fullEnglish": "The boy went in the hut and as soon as he got in poked a hole with his finger through the straw between the slats and peeked out."
        },
        "109": {
            "startTime": 1511.561,
            "endTime": 1521.406,
            "sug": [
                [
                    "Nepaillpiarluni",
                    "Quietly"
                ],
                [
                    "tawaken ar’ursulgem tuquneq qayamek anlluku.",
                    "the whaler was getting the corpse out of the kayak."
                ]
            ],
            "fullEnglish": "The whaler was quietly getting the corpse out of the kayak."
        },
        "110": {
            "startTime": 1521.406,
            "endTime": 1537.609,
            "sug": [
                [
                    "Tawaken ancamiu",
                    "When he got it out"
                ],
                [
                    "ciqlluam tungiinun ulutekaalluni",
                    "he looked toward the hut"
                ],
                [
                    "nitniqikaalluni",
                    "and after listening"
                ],
                [
                    "qulwarlluku tuquneq",
                    "picked up the corpse on his shoulder"
                ],
                [
                    "paaguut penam tungiinun tagulluku aularnir[luni].",
                    "and began carrying it up to towards the bluff."
                ]
            ],
            "fullEnglish": "When he got it out he looked toward the hut and after listening picked up the corpse on his shoulder."
        },
        "111": {
            "startTime": 1537.609,
            "endTime": 1548.869,
            "sug": [
                [
                    "Taaten cukaluni kuinglluni",
                    "He walking so fast"
                ],
                [
                    "qeceng’enitarluni tagluni",
                    "he was almost running,"
                ],
                [
                    "napat akuliitgun",
                    "went through the woods"
                ],
                [
                    "tawa’ut penanun.",
                    "toward the bluff."
                ]
            ],
            "fullEnglish": "He walking so fast he was almost running, went through the woods toward the bluff."
        },
        "112": {
            "startTime": 1548.869,
            "endTime": 1565.166,
            "sug": [
                [
                    "Tan’uraq tawa’i kinguagun maliglluku mulugkunani talu’utellranun",
                    "Like a shadow the boy was right behind him,"
                ],
                [
                    "napanun napat tunuatnun nuuyaqurluku maliglluku.",
                    "going from one tree to another."
                ]
            ],
            "fullEnglish": "Like a shadow the boy was right behind him, going from one tree to another."
        },
        "113": {
            "startTime": 1565.166,
            "endTime": 1571.028,
            "sug": [
                [
                    "Ar’ursulek tawaken aprutruaq maliglluku tagluni.",
                    "The whaler was following a path."
                ]
            ],
            "fullEnglish": "The whaler was following a path."
        },
        "114": {
            "startTime": 1571.028,
            "endTime": 1599.256,
            "numberTitle": 27,
            "sug": [
                [
                    "Tawaken penat caniatni",
                    "Close to the bluff"
                ],
                [
                    "napanguat eqnasqat tekilluki",
                    "they came to a thick stand of young spruce."
                ],
                [
                    "taugkut tunuatgun tawa’i aciatgun tan’uraq pangalegluni",
                    "The boy went to one side of the path and crawled under them,"
                ],
                [
                    "umialinguarluni",
                    "figuring"
                ],
                [
                    "ar’ursulek taugna penam acianun nagciiquq.",
                    "that the whaler would stop at the bluff."
                ],
                [
                    "Napat aciitgun-ta pangalegluni,",
                    "He crawled under the trees,"
                ],
                [
                    "penat tungiitnun agluni.",
                    "and headed towards the bluffs."
                ]
            ],
            "fullEnglish": "Close to the bluff they came to a thick stand of young spruce. The boy, figuring that the whaler would stop at the bluff, went to one side of the path and crawled under them."
        },
        "115": {
            "startTime": 1599.256,
            "endTime": 1611.323,
            "sug": [
                [
                    "Peturcamiki,",
                    "When he got through them"
                ],
                [
                    "tawaten caillquruangcugmen tekilluni penam (aku--) awatiini tawani.",
                    "he came to a narrow clearing running along the bluff."
                ]
            ],
            "fullEnglish": "When he got through them he came to a narrow clearing running along the bluff."
        },
        "116": {
            "startTime": 1611.323,
            "endTime": 1620.94,
            "sug": [
                [
                    "Tawani, akikaaraani tawani napanguat aciatnek",
                    "A short distance across from him"
                ],
                [
                    "tawa’i tangerluku",
                    "he saw"
                ],
                [
                    "lurtusqaq qaiqunaq.",
                    "a wide cave."
                ]
            ],
            "fullEnglish": "A short distance across from him was a wide cave."
        },
        "117": {
            "startTime": 1620.94,
            "endTime": 1631.906,
            "sug": [
                [
                    "Kuiguaq tawagun penam awatiigun carwarluni.",
                    "A little creek ran along the edge of the bluff"
                ],
                [
                    "Qaiqunam ketiini tawa’i nanwaruangcuk ell’uni.",
                    "forming a peel in front of the cave."
                ]
            ],
            "fullEnglish": "A little creek ran along the edge of the bluff forming a peel in front of the cave."
        },
        "118": {
            "startTime": 1631.906,
            "endTime": 1643.69,
            "sug": [
                [
                    "Awa’i ar’ursulek tawani nangarngaluni taug’um nanwaruam caniani",
                    "The whaler was standing beside it"
                ],
                [
                    "tuquqneq itgain pianii tawani ell’uni.",
                    "with the corpse at his feet."
                ]
            ],
            "fullEnglish": "The whaler was standing beside it with the corpse at his feet."
        },
        "119": {
            "startTime": 1643.69,
            "endTime": 1655.71,
            "numberTitle": 28,
            "sug": [
                [
                    "Macaq suarngan akirluni",
                    "The sun was shining"
                ],
                [
                    "qaiqunam iluani,",
                    "into the cave"
                ],
                [
                    "tan’uraraam caqit tamaita elngut tawani tang’rluki.",
                    "and the boy could see everything there was in it."
                ]
            ],
            "fullEnglish": "The sun was shining into the cave and the boy could see everything there was in it."
        },
        "120": {
            "startTime": 1655.71,
            "endTime": 1677.406,
            "sug": [
                [
                    "Tawani yaamarni lliilua’umangia’arluteng suu’ut nasqullrit,",
                    "There was ledges like shelves and on one were several human skulls, neatly arranged."
                ],
                [
                    "ilaitni ayaqut, ilaitni tamaani ayaqut cingiit cali ell’uteng.",
                    "On other ledges were spear shafts and spear points."
                ]
            ],
            "fullEnglish": "There was ledges like shelves and on one were several human skulls, neatly arranged. On other ledges were spear shafts and spear points."
        },
        "121": {
            "startTime": 1677.406,
            "endTime": 1687.911,
            "sug": [
                [
                    "Ilait iquit qup’arqumalu[teng], yug’arngaluteng, tawarpiaq caqimek kepeng’ia’allret.",
                    "Some of the points had their tips broken off."
                ]
            ],
            "fullEnglish": "Some of the points had their tips broken off."
        },
        "122": {
            "startTime": 1687.911,
            "endTime": 1701.933,
            "numberTitle": 29,
            "sug": [
                [
                    "Tawaken ar’ursulek akuliitnek tamaaken cali yaamarmek, nuusimek tuull[uni], yaaamarmek canamasqaq nuusiq.",
                    "The whaler reached up on one of the shelves and got several knives made of slate rock."
                ]
            ],
            "fullEnglish": "The whaler reached up on one of the shelves and got several knives made of slate rock."
        },
        "123": {
            "startTime": 1701.933,
            "endTime": 1734.102,
            "sug": [
                [
                    "Tawaken, ipgucia tamluminek ellpekegkaalluku",
                    "After feeling the edges with his thumb,"
                ],
                [
                    "tawa’i all’iluq (ellpekeq...kegkaalluku) tuuluku,",
                    "he picked one out"
                ],
                [
                    "cisqumiglluni tuqunrem piani",
                    "and, getting on his knees astride the corpse,"
                ],
                [
                    "tawa’i aqsaagun kapuruaqaalluku qaugcinek nuusiq",
                    "poked it in the belly a few times with the knife,"
                ],
                [
                    "tawa’i iterllu[ku] all’ilumek segyanermek ikirlluku aqsaa.",
                    "then jabbed it in and slashed the belly open with one stroke."
                ]
            ],
            "fullEnglish": "After feeling the edges with his thumb, he picked one out and, getting on his knees astride the corpse, poked it in the belly a few times with the knife, then jabbed it in and slashed the belly open with one stroke."
        },
        "124": {
            "startTime": 1734.102,
            "endTime": 1743.966,
            "numberTitle": 30,
            "sug": [
                [
                    "Tuquneq aularnirluni qalriurluni suunia’luni",
                    "The corpse moaned and screamed"
                ],
                [
                    "ar’ursulgem qiluirngani.",
                    "while the whaler was cutting its insides out."
                ]
            ],
            "fullEnglish": "The corpse moaned and screamed while the whaler was cutting its insides out."
        },
        "125": {
            "startTime": 1743.966,
            "endTime": 1761.085,
            "sug": [
                [
                    "Tawaken qilullri ant’kaalluki,",
                    "After getting the insides out"
                ],
                [
                    "tawa’i lliiluku tawa’ut nanwaruam canianun,",
                    "he put it in the pool"
                ],
                [
                    "yaamarnek nigluku,",
                    "and put rocks over it"
                ],
                [
                    "wegnek patukaalluku.",
                    "and covered it with straw."
                ]
            ],
            "fullEnglish": "After getting the insides out he put it in the pool and put rocks over it and covered it with straw."
        },
        "126": {
            "startTime": 1761.085,
            "endTime": 1774.361,
            "sug": [
                [
                    "Tawaken suqaa anlluku,",
                    "Then he cut the stomach out"
                ],
                [
                    "perirtuqaalluku urturluku,",
                    "and after cleaning it out"
                ],
                [
                    "cuplluku tatarlluku.",
                    "blew it full of air."
                ]
            ],
            "fullEnglish": "Then he cut the stomach out and after cleaning it out blew it full of air."
        },
        "127": {
            "startTime": 1774.361,
            "endTime": 1790.775,
            "sug": [
                [
                    "Cupenrani taaten",
                    "While he was blowing it,"
                ],
                [
                    "tan’uraq englacinguarluni aularnirluni,",
                    "the boy was amazed and started to giggle,"
                ],
                [
                    "umialingua[rluni],",
                    "wondering,"
                ],
                [
                    "“Qai-tuq-gua ar’ursulek pinayarta",
                    "“What is the whaler going to do"
                ],
                [
                    "ruu’amek qup’a’askum[ku] / (ai)?”",
                    "if he popped it with an arrow?”"
                ]
            ],
            "fullEnglish": "While he was blowing it, the boy was amazed and started to giggle, wondering, “What is the whaler going to do if he popped it with an arrow?”"
        },
        "128": {
            "startTime": 1790.775,
            "endTime": 1803.794,
            "sug": [
                [
                    "A’aklluku [?] cup’urluku (um) suquq, ar’ursulem qup’artengnaqegkuna[ku].",
                    "He blew the stomach very carefully."
                ],
                [
                    "Ellma cupkaalluku uyaquagun taugna suqaq",
                    "He would blow a little, then, holding the neck of the stomach"
                ]
            ],
            "fullEnglish": "He blew the stomach very carefully. He would blow a little, then, holding the neck of the stomach"
        },
        "129": {
            "startTime": 1803.794,
            "endTime": 1820.077,
            "sug": [
                [
                    "sua’ami akuliggkun tuumiqlluku.",
                    "between his fingers."
                ],
                [
                    "Cuutmi pianun tuumiaqlluku",
                    "He would hold it next to his ear"
                ],
                [
                    "sua’aminek kaugturuarluku nitniqlluku,",
                    "and tap it with his fingers and listen,"
                ],
                [
                    "tawaken cali cuplluni.",
                    "then he would blow again."
                ]
            ],
            "fullEnglish": "between his fingers. He would hold it next to his ear and tap it with his fingers and listen, then he would blow again."
        },
        "130": {
            "startTime": 1820.077,
            "endTime": 1842.388,
            "sug": [
                [
                    "Awa’i, pitaciqegingan nemqaalluku, cuumini tawani,",
                    "Finally, satisfied that it was blown just right,"
                ],
                [
                    "giinami cuuqaani qipurluku (uluteklluku) ulutekegkaalluku",
                    "he tied the neck and after holding it and turning it around before him"
                ],
                [
                    "tawa’i qaiqunamen itrulluku",
                    "took it in the cave"
                ],
                [
                    "iniluku.",
                    "and hung it up to dry."
                ]
            ],
            "fullEnglish": "Finally, satisfied that it was blown just right, he tied the neck and after holding it and turning it around before him took it in the cave and hung it up to dry."
        },
        "131": {
            "startTime": 1842.388,
            "endTime": 1863.477,
            "numberTitle": 31,
            "sug": [
                [
                    "Qaiqunamek anngami",
                    "Coming out of the cave"
                ],
                [
                    "tawa’i, aigami imaanek augmek tuulluni,",
                    "he scooped a handful of blood"
                ],
                [
                    "angilluni",
                    "and went back in"
                ],
                [
                    "ayaqum taugna cingia augmek mingugluku",
                    "then took a spearpoint that did not have its point broken off and began to smear the tip with blood."
                ]
            ],
            "fullEnglish": "Coming out of the cave he scooped a handful of blood and went back in then took a spearpoint that did not have its point broken off and began to smear the tip with blood."
        },
        "132": {
            "startTime": 1863.477,
            "endTime": 1872.941,
            "sug": [
                [
                    "Mampalluglluni mingunerminiu caqimek",
                    "He was mumbling something"
                ],
                [
                    "kesiin tan’uraraam kangircigkunani.",
                    "the boy could not understand."
                ]
            ],
            "fullEnglish": "He was mumbling something the boy could not understand."
        },
        "133": {
            "startTime": 1872.941,
            "endTime": 1892.423,
            "sug": [
                [
                    "Tawa’i tan’uram tang’rluku,",
                    "The boy noticed"
                ],
                [
                    "ayaqum taugna cingia ster’umaluni,",
                    "the spear was grooved"
                ],
                [
                    "iquanek, allrak staamen sua’at lurtutaciitnek.",
                    "on each side about the width of four fingers from the tip."
                ]
            ],
            "fullEnglish": "The boy noticed the spear was grooved on each side about the width of four fingers from the tip."
        },
        "134": {
            "startTime": 1892.423,
            "endTime": 1903.726,
            "sug": [
                [
                    "Taugna iqukaaraa kesiin augmek mingugluku,",
                    "He smeared the blood as far as the groove only,"
                ],
                [
                    "ilii taug’um ayaqum cingia mingugkunaku.",
                    "but he didn’t smear it on the spear’s point."
                ]
            ],
            "fullEnglish": "He smeared the blood as far as the groove only, but he didn’t smear it on the spear’s point."
        },
        "135": {
            "startTime": 1903.726,
            "endTime": 1918.558,
            "numberTitle": 32,
            "sug": [
                [
                    "Awa mampallugtenirluni",
                    "He stopped mumbling, got up"
                ],
                [
                    "allakaq. Allakat tamaakut ayaqut cingiata akuliitnun lliiluku.",
                    "and put the spear point on another ledge away from the others."
                ]
            ],
            "fullEnglish": "He stopped mumbling, got up and put the spear point on another ledge away from the others."
        },
        "136": {
            "startTime": 1918.558,
            "endTime": 1941.373,
            "sug": [
                [
                    "Qaiqunamen iterluni,",
                    "He went into the cave"
                ],
                [
                    "tawaken anluni",
                    "and came out"
                ],
                [
                    "ayaquq taugna qupuraa naparlluku",
                    "with a long spear shaft and stood it"
                ],
                [
                    "tawa’ut ayaqum cingian canianun.",
                    "next to the point."
                ]
            ],
            "fullEnglish": "He went into the cave and came out with a long spear shaft and stood it next to the point."
        },
        "137": {
            "startTime": 1941.373,
            "endTime": 1963.744,
            "sug": [
                [
                    "Angitmen iterluni qama’ut iterluni",
                    "He went back in and came into there"
                ],
                [
                    "ar’ungcugmek qupuramek piliangq[erlluni]...ang’atangqerlluni all’ilumi,",
                    "with a small wooden whale in one hand,"
                ],
                [
                    "aipaani ayaqungcuk miktesaasqaq cali tawaten cingingqerlluni yaamarmek, aipaani tuumia[qlluku].",
                    "and a small spear shaft with a point made also of slate rock in the other."
                ]
            ],
            "fullEnglish": "He went back in and came into there with a small wooden whale in one hand, and a small spear shaft with a point made also of slate rock in the other."
        },
        "138": {
            "startTime": 1963.744,
            "endTime": 1988.378,
            "sug": [
                [
                    "Cali cesten mampalluglluni,",
                    "Mumbling something again,"
                ],
                [
                    "cali taug’um ayaqungcuum cingia mingugluku mingukaalluku augmek,",
                    "he smeared the tiny tip with blood"
                ],
                [
                    "ar’um caniqaanun, taug’um qupuraam ar’um caniqaanun iterlluku.",
                    "and stuck it on the side of the wooden whale"
                ],
                [
                    "Tawa’ut ayaqut awatiitnun lliiluku.",
                    "and put it on the ledge next to the big spearpoint."
                ]
            ],
            "fullEnglish": "Mumbling something again, he smeared the tiny tip with blood and stuck it on the side of the wooden whale and put it on the ledge next to the big spearpoint."
        },
        "139": {
            "startTime": 1988.378,
            "endTime": 2006.285,
            "sug": [
                [
                    "Tawaken tunutmen amlliqaalluni qaugcinek,",
                    "He stepped back and looked at them for some time"
                ],
                [
                    "ulutekegkaalluki, awa’i tunulluni",
                    "then turned around"
                ],
                [
                    "nanwaruamen, aigani cingaruaqaalluki",
                    "and went to the pool and after sniffing his hands"
                ],
                [
                    "urturluki aularnir[luni].",
                    "started washing them."
                ]
            ],
            "fullEnglish": "He stepped back and looked at them for some time then turned around and went to the pool and after sniffing his hands started washing them."
        },
        "140": {
            "startTime": 2006.285,
            "endTime": 2014.413,
            "sug": [
                [
                    "Wegnek allegtuqaalluki",
                    "After wiping them dry with straw,"
                ],
                [
                    "tawa’i angitmen ciqlluam tungiinun esguar[luni].",
                    "he started down the path back to the sod house."
                ]
            ],
            "fullEnglish": "After wiping them dry with straw, he started down the path back to the sod house."
        },
        "141": {
            "startTime": 2014.413,
            "endTime": 2023.723,
            "numberTitle": 33,
            "sug": [
                [
                    "Tan’uraraam angitmen pangalegluni",
                    "The boy crawled back"
                ],
                [
                    "napanguat aciitgun,",
                    "through the sprucelings"
                ],
                [
                    "qecengluni aularnirluni ciqlluamen.",
                    "and started to run down to the hut."
                ]
            ],
            "fullEnglish": "The boy crawled back through the sprucelings and started to run down to the hut."
        },
        "142": {
            "startTime": 2023.723,
            "endTime": 2034.656,
            "sug": [
                [
                    "Ar’ursulgem cuungani tull’uni,",
                    "[?]"
                ],
                [
                    "kianit cupu’aqaall[uk]i kenirkirluki,",
                    "The whaler put wood on the coals and blew"
                ],
                [
                    "keneq kuagkwarlu[ku].",
                    "until the wood began to flame."
                ]
            ],
            "fullEnglish": "The whaler put wood on the coals and blew until the wood began to flame."
        },
        "143": {
            "startTime": 2034.656,
            "endTime": 2051.703,
            "sug": [
                [
                    "Tawaken aqumgaa’arluni ar’ursulek",
                    "Then the whaler sat on the ground"
                ],
                [
                    "utaqalirluku.",
                    "and waited."
                ],
                [
                    "Ar’ursulek angitmen ciqlluamen tuc’ami ilanirluni.",
                    "When the whaler returned to the hut he seemed to be in a good mood."
                ]
            ],
            "fullEnglish": "Then the whaler sat on the ground and waited. When the whaler returned to the hut he seemed to be in a good mood."
        },
        "144": {
            "startTime": 2051.703,
            "endTime": 2058.76,
            "sug": [
                [
                    "Tan’uraq pigaa,",
                    "He said to the boy,"
                ],
                [
                    "“Nunami kuingpakarlua",
                    "“I walked in the woods so much,"
                ],
                [
                    "kaitegkuartua.",
                    "I got hungry."
                ],
                [
                    "Nerlinuk.”",
                    "Let us eat.”"
                ]
            ],
            "fullEnglish": "“I walked in the woods so much,” he said, “I got hungry. Let us eat.”"
        },
        "145": {
            "startTime": 2058.76,
            "endTime": 2066.861,
            "sug": [
                [
                    "Tawaken cali tamuulutek",
                    "After that they ate dried fish"
                ],
                [
                    "isu’im uquanek ilalu[ku].",
                    "with seal blubber added."
                ]
            ],
            "fullEnglish": "After that they ate dried fish with seal blubber added."
        },
        "146": {
            "startTime": 2066.861,
            "endTime": 2080.875,
            "numberTitle": 34,
            "sug": [
                [
                    "Nernemegtegni,",
                    "While they were eating,"
                ],
                [
                    "ar’ursulem tan’uraq tawa niu’uqu[rluku]",
                    "the whaler was telling the boy"
                ],
                [
                    "cesten elliin cali tan’uraunermini aularnillria",
                    "how he too started early as a boy"
                ],
                [
                    "litnaurluni ar’ursulgunermek.",
                    "learning to be a whaler."
                ]
            ],
            "fullEnglish": "While they were eating, the whaler was telling the boy how he too started early as a boy to be a whaler."
        },
        "147": {
            "startTime": 2080.875,
            "endTime": 2092.973,
            "sug": [
                [
                    "Cuumi cali elliin alingtaallruniluni,",
                    "He said that the first time he went out he was so scared"
                ],
                [
                    "aglleq angitmen",
                    "that he would have gone back home"
                ],
                [
                    "nallumanillkuniu anginayallruniluni.",
                    "if he knew the way back."
                ]
            ],
            "fullEnglish": "He said that the first time he went out he was so scared that he would have gone back home if he knew the way back."
        },
        "148": {
            "startTime": 2092.973,
            "endTime": 2097.345,
            "sug": [
                [
                    "Nalluluku",
                    "He did not know"
                ],
                [
                    "nani et’a tamaani elliin cali.",
                    "where he was."
                ]
            ],
            "fullEnglish": "He did not know where he was."
        },
        "149": {
            "startTime": 2097.345,
            "endTime": 2114.009,
            "sug": [
                [
                    "“Iliini,”",
                    "“Sometimes,”"
                ],
                [
                    "tawa’i niuglluni,",
                    "he said,"
                ],
                [
                    "“Ayuqenilgnut nepet emtusqat nitneruluteng.",
                    "“There were so many loud and different noises."
                ],
                [
                    "Iliini taaten alingnar[luni].",
                    "It would be frightening."
                ]
            ],
            "fullEnglish": "“Sometimes,” he said, “There were so many loud and different noises. It would be frightening."
        },
        "150": {
            "startTime": 2114.009,
            "endTime": 2122.455,
            "sug": [
                [
                    "“Iliini nepaipakarluni",
                    "“Sometimes it was so quiet"
                ],
                [
                    "cali qumsugnarluni.",
                    "it was even more frightening."
                ],
                [
                    "Taaten et’aallria.",
                    "That is how it was."
                ]
            ],
            "fullEnglish": "“Sometimes it was so quiet it was even more frightening. That is how it was."
        },
        "151": {
            "startTime": 2122.455,
            "endTime": 2127.76,
            "sug": [
                [
                    "“Iliini emtuwakarluteng nepet,",
                    "“Sometimes it is too noisy,"
                ],
                [
                    "iliini nepaipaka[rluteng].",
                    "and sometimes it is too quiet."
                ]
            ],
            "fullEnglish": "“Sometimes it is too noisy, and sometimes it is too quiet."
        },
        "152": {
            "startTime": 2127.76,
            "endTime": 2133.634,
            "sug": [
                [
                    "“Kesiin lii’uciiqan,",
                    "“But you will get used to it,"
                ],
                [
                    "gui cesten lii’uskeg[ka].",
                    "like I did."
                ]
            ],
            "fullEnglish": "“But you will get used to it, like I did."
        },
        "153": {
            "startTime": 2133.634,
            "endTime": 2156.162,
            "sug": [
                [
                    "Alingellriaten-qaa",
                    "Were you afraid"
                ],
                [
                    "cuumi gut iterngamnuk kangi’aruangcugmen",
                    "when we first came in this lagoon this morning"
                ],
                [
                    "tamlenran,",
                    "when it was so dark"
                ],
                [
                    "nepaillpianrani",
                    "and quiet"
                ],
                [
                    "taaten qaya’angama, ukut akiurneret angitmen angicata",
                    "and all of the noise the echoes made"
                ],
                [
                    "tuullegtestun qal’iqaaca[ma]?”",
                    "after I called out like a loon?”"
                ]
            ],
            "fullEnglish": "Were you afraid when we first came in this lagoon this morning when it was so dark and quiet and all of the noise the echoes made after I called out like a loon?”"
        },
        "154": {
            "startTime": 2156.162,
            "endTime": 2160.282,
            "sug": [
                [
                    "Tan’uraraam iqlluluku,",
                    "The boy lied,"
                ],
                [
                    "“Gui aling’taanitua.”",
                    "“I never get afraid.”"
                ]
            ],
            "fullEnglish": "The boy lied, “I never get afraid.”"
        },
        "155": {
            "startTime": 2160.282,
            "endTime": 2164.627,
            "sug": [
                [
                    "Allayugluni",
                    "Surprised,"
                ],
                [
                    "tawa’i ar’ursulgem uluteklluku",
                    "the whaler looked at him"
                ],
                [
                    "pimaa,",
                    "and says,"
                ],
                [
                    "“Qaa?”",
                    "“Really?”"
                ]
            ],
            "fullEnglish": "Surprised, the whaler looked at him and says, “Really?”"
        },
        "156": {
            "startTime": 2164.627,
            "endTime": 2168.227,
            "sug": [
                [
                    "“Aa’a,”",
                    "“Yes,”"
                ],
                [
                    "tan’uram cali iqlluluku.",
                    "the boy lied again."
                ]
            ],
            "fullEnglish": "“Yes,” the boy lied again."
        },
        "157": {
            "startTime": 2168.227,
            "endTime": 2175.677,
            "numberTitle": 35,
            "sug": [
                [
                    "Tawaken ar’ursulek awa nepainani cesten niugtegkunani.",
                    "After the whaler was quiet."
                ]
            ],
            "fullEnglish": "After the whaler was quiet."
        },
        "158": {
            "startTime": 2175.677,
            "endTime": 2190.778,
            "sug": [
                [
                    "Neren’irngamek",
                    "When they finished eating"
                ],
                [
                    "awa ayaquni tuuluku",
                    "he took his spear"
                ],
                [
                    "anluni,",
                    "and went out,"
                ],
                [
                    "tan’uraq piluku",
                    "he told the boy"
                ],
                [
                    "utaqasqelluni ciqlluami,",
                    "to stay in the hut,"
                ],
                [
                    "elliin isu’imek ayaquyaturciqniluni.",
                    "he would go spear a seal."
                ]
            ],
            "fullEnglish": "When they finished eating he said that he would go spear a seal and went out telling the boy to stay in the hut."
        },
        "159": {
            "startTime": 2190.778,
            "endTime": 2197.473,
            "numberTitle": 36,
            "sug": [
                [
                    "Mulun’illpiarluni,",
                    "Shortly"
                ],
                [
                    "taug’um tan’uraq qaya’aluku",
                    "he called to the boy"
                ],
                [
                    "qutmen esguasqelluku.",
                    "to come down to the beach."
                ]
            ],
            "fullEnglish": "Shortly he called to the boy to come down to the beach."
        },
        "160": {
            "startTime": 2197.473,
            "endTime": 2209.46,
            "sug": [
                [
                    "Esguarngami",
                    "When he got down"
                ],
                [
                    "tan’uraraam tangru[maluku] awa’i isu’iq",
                    "he saw that the seal"
                ],
                [
                    "pilakaacimaluku.",
                    "was already cleaned"
                ],
                [
                    "Kemga awa’i cai segumangia’arlu[ni].",
                    "and the meat was cut in strips."
                ]
            ],
            "fullEnglish": "When he got down he saw that the seal was already cleaned and the meat was cut in strips."
        },
        "161": {
            "startTime": 2209.46,
            "endTime": 2215.778,
            "sug": [
                [
                    "Macaq kal’u[lu]ni iteryarluni tamaani cali awa’i.",
                    "The sun was beginning to set."
                ]
            ],
            "fullEnglish": "The sun was beginning to set."
        },
        "162": {
            "startTime": 2215.778,
            "endTime": 2226.621,
            "sug": [
                [
                    "Tawa’i ar’ursulem tan’urani pimaa",
                    "The whaler told the boy"
                ],
                [
                    "kenlisqelluku tawaken",
                    "to build a fire on the beach"
                ],
                [
                    "kemegmek paaniisqelluku. (asgiisqelluku)",
                    "and broil some meat."
                ]
            ],
            "fullEnglish": "The whaler told the boy to build a fire on the beach and broil some meat."
        },
        "163": {
            "startTime": 2226.621,
            "endTime": 2236.007,
            "sug": [
                [
                    "Niuglluni",
                    "He said"
                ],
                [
                    "elliin qutem iquanun agciqniluni,",
                    "that he would go to the end of the beach for a while"
                ],
                [
                    "angiciiqniluni",
                    "and that he would be back"
                ],
                [
                    "kemek uucukegkuniu.",
                    "when he thought the meat was done."
                ]
            ],
            "fullEnglish": "He said that he would go to the end of the beach for a while and that he would be back when he thought the meat was done."
        },
        "164": {
            "startTime": 2236.007,
            "endTime": 2247.607,
            "numberTitle": 37,
            "sug": [
                [
                    "Mulugkuarkunaku ar’ursulem agucillra,",
                    "Not long after the whaler left,"
                ],
                [
                    "tamlek taaten cukaluni tamlegiluni tawarpiaq qilagmek katallria.",
                    "darkness just fell."
                ]
            ],
            "fullEnglish": "Not long after the whaler left, darkness just fell."
        },
        "165": {
            "startTime": 2247.607,
            "endTime": 2254.674,
            "sug": [
                [
                    "Tan’uraq",
                    "The boy"
                ],
                [
                    "kianit ciplluki",
                    "beyond the glow of the coals"
                ],
                [
                    "yatmen tang’rkaugkunani.",
                    "could not see."
                ]
            ],
            "fullEnglish": "The boy could not see beyond the glow of the coals."
        },
        "166": {
            "startTime": 2254.674,
            "endTime": 2260.52,
            "sug": [
                [
                    "Awa cali nepaillpiarluni,",
                    "It was all quiet now,"
                ],
                [
                    "nepai’uspiar[luni].",
                    "really quiet."
                ]
            ],
            "fullEnglish": "It was all quiet now, really quiet."
        },
        "167": {
            "startTime": 2260.52,
            "endTime": 2276.858,
            "sug": [
                [
                    "Tawaken niicimaa tumet,",
                    "Soon he heard soft footsteps"
                ],
                [
                    "tawarpiaq suk taillria",
                    "like a person coming"
                ],
                [
                    "qutem mengliigun tungiinun, atunem qutem iquanek, tamarkegnek.",
                    "along the bank in his direction from both sides."
                ]
            ],
            "fullEnglish": "Soon he heard soft footsteps coming along the bank in his direction from both sides."
        },
        "168": {
            "startTime": 2276.858,
            "endTime": 2283.286,
            "sug": [
                [
                    "Keluani tawani naglluni",
                    "They stopped behind him."
                ],
                [
                    "nitniqiluni,",
                    "He listened,"
                ],
                [
                    "caqimek niitekaugkunaku.",
                    "but he could not hear a thing."
                ]
            ],
            "fullEnglish": "They stopped behind him. He listened, but he could not hear a thing."
        },
        "169": {
            "startTime": 2283.286,
            "endTime": 2292.174,
            "sug": [
                [
                    "Tawaken umiali[nguarluni] ellminek,",
                    "He was beginning to think to himself"
                ],
                [
                    "tamaakut cuutemini alingwakar[luni] niicuklluki ta[wa]’i.",
                    "that he imagined hearing the footsteps."
                ]
            ],
            "fullEnglish": "He was beginning to think to himself that he imagined hearing the footsteps."
        },
        "170": {
            "startTime": 2292.174,
            "endTime": 2300.342,
            "sug": [
                [
                    "Nepailngua’arluteng kinkut niu’aluteng",
                    "He heard someone whispering, talking,"
                ],
                [
                    "englacinguarluteng",
                    "and giggling"
                ],
                [
                    "tawani tunukaaraa[ni].",
                    "right there behind him."
                ]
            ],
            "fullEnglish": "He heard someone whispering, talking, and giggling right there behind him."
        },
        "171": {
            "startTime": 2300.342,
            "endTime": 2309.126,
            "sug": [
                [
                    "Awa’i nutaan pequa cali aularnirluni p’tagluni",
                    "And now his back was starting to crawl"
                ],
                [
                    "qumsugyugpakarluni.",
                    "with the creeps."
                ]
            ],
            "fullEnglish": "And now his back was starting to crawl with the creeps."
        },
        "172": {
            "startTime": 2309.126,
            "endTime": 2318.253,
            "sug": [
                [
                    "Taaten nepailngua’arluteng niu’aciat",
                    "The whispering"
                ],
                [
                    "iliini englaci[ngua’uciat]",
                    "or giggling"
                ],
                [
                    "aulairtaarluni,",
                    "would stop for a while"
                ],
                [
                    "aularnirtaarluni.",
                    "and start again."
                ]
            ],
            "fullEnglish": "The whispering or giggling would stop for a while and start again."
        },
        "173": {
            "startTime": 2318.253,
            "endTime": 2324.24,
            "sug": [
                [
                    "Tawaken awa’i aulairluteng nepai’uspiarluni.",
                    "At last they stopped altogether."
                ]
            ],
            "fullEnglish": "At last they stopped altogether."
        },
        "174": {
            "startTime": 2324.24,
            "endTime": 2333.29,
            "sug": [
                [
                    "Tawaken nepa taug’um kingullrani niillu[ku] taug’um,",
                    "Then he heard a sound"
                ],
                [
                    "cali ana’ulluku awa alingegkuarluku.",
                    "that made him even more creepy."
                ]
            ],
            "fullEnglish": "Then he heard a sound that made him even more creepy."
        },
        "175": {
            "startTime": 2333.29,
            "endTime": 2348.87,
            "sug": [
                [
                    "Taugna nepa, maani sul’egmi kina sum takuyaasqegkuniu aturtaaqengaat.",
                    "It was a sound made to attract one’s attention around there."
                ]
            ],
            "fullEnglish": "It was a sound made to attract one’s attention around there."
        },
        "176": {
            "startTime": 2348.87,
            "endTime": 2361.283,
            "sug": [
                [
                    "Aaniin kesiin niu’utellruluku,",
                    "His mother had told him"
                ],
                [
                    "nani suilngurmi taugna nepa niskuniu",
                    "that when he heard that sound when he was away from the village,"
                ],
                [
                    "anangaq anangaq takuyaasqegkunaku.",
                    "whatever he did to never to look."
                ]
            ],
            "fullEnglish": "His mother had told him that whatever he did to never to look when he heard that sound when he was away from the village."
        },
        "177": {
            "startTime": 2361.283,
            "endTime": 2374.875,
            "sug": [
                [
                    "Tamaani nani suita",
                    "Where there were no people,"
                ],
                [
                    "kesiin caqillraiyagnek taimakauluni tamaakuciq nepa.",
                    "it could only come from evil spirits craving."
                ]
            ],
            "fullEnglish": "Where there were no people, it could only come from evil spirits craving."
        },
        "178": {
            "startTime": 2374.875,
            "endTime": 2393.717,
            "sug": [
                [
                    "Awa nutaan niilluku tawa’i,",
                    "He heard the sound now,"
                ],
                [
                    "“T’st’st!”",
                    "“Cheeh! Cheeh!”"
                ],
                [
                    "Emkitengraan nepaipakarluku",
                    "The sound was made very softly,"
                ],
                [
                    "elliini emtuluni tamaakuciq, nepa.",
                    "but he heard it very plainly in the dead silence."
                ]
            ],
            "fullEnglish": "He heard the sound now, “Cheeh! Cheeh!” The sound was made very softly, but he heard it very plainly in the dead silence."
        },
        "179": {
            "startTime": 2393.717,
            "endTime": 2402.483,
            "sug": [
                [
                    "Niitengqigtaa’aluku",
                    "He heard it again and again,"
                ],
                [
                    "kesiin angitmen takuyarsaaqegkuna[ni].",
                    "but he dared not look back."
                ],
                [
                    "Tunutmen takuyarsaa.",
                    "He didn’t look behind him."
                ]
            ],
            "fullEnglish": "He heard it again and again, but he dared not look back. He didn’t look behind him."
        },
        "180": {
            "startTime": 2402.483,
            "endTime": 2408.411,
            "sug": [
                [
                    "Tawakenun nepai’uspia[rluni] taug’um kingullra[ni].",
                    "Then it was quiet again."
                ]
            ],
            "fullEnglish": "Then it was quiet again."
        },
        "181": {
            "startTime": 2408.411,
            "endTime": 2420.155,
            "numberTitle": 38,
            "sug": [
                [
                    "Tawaken nepaipakarluni kianit qupuramek pekagqelluki aularnirluni.",
                    "While he sat there trying to break the silence by stirring the coals with the stick,"
                ]
            ],
            "fullEnglish": "While he sat there trying to break the silence by stirring the coals with the stick,"
        },
        "182": {
            "startTime": 2420.155,
            "endTime": 2427.811,
            "sug": [
                [
                    "Tawaken taug’um kingullrani allat nepet penanek aularnirluteng.",
                    "Other noises began coming from the bluffs."
                ]
            ],
            "fullEnglish": "Other noises began coming from the bluffs."
        },
        "183": {
            "startTime": 2427.811,
            "endTime": 2435.356,
            "sug": [
                [
                    "Taaten ellmangia’aq aularniqaalluteng",
                    "Like that they were getting"
                ],
                [
                    "emtu’itmen emtu’itmen,",
                    "louder and louder"
                ],
                [
                    "tailuteng.",
                    "as they came."
                ]
            ],
            "fullEnglish": "Like that they were getting louder and louder as they came."
        },
        "184": {
            "startTime": 2435.356,
            "endTime": 2449.589,
            "sug": [
                [
                    "Akiurneret angitmen tamaaken penanek angitaqualuteng,",
                    "As the echoes bounced back and forth"
                ],
                [
                    "cesten unuami tamaani niskai",
                    "like they did early that morning"
                ],
                [
                    "ar’ursulek tuullegtestun qaya’angan.",
                    "when the whaler called out like a loon."
                ]
            ],
            "fullEnglish": "As the echoes bounced back and forth like they did early that morning when the whaler called out like a loon."
        },
        "185": {
            "startTime": 2449.589,
            "endTime": 2456.477,
            "sug": [
                [
                    "Tamaaken suunia’anret,",
                    "There was moaning,"
                ],
                [
                    "qayagauneq,",
                    "screaming,"
                ],
                [
                    "englaruaneq.",
                    "and laughing."
                ]
            ],
            "fullEnglish": "There was moaning, screaming, and laughing."
        },
        "186": {
            "startTime": 2456.477,
            "endTime": 2461.572,
            "sug": [
                [
                    "Awa tawa’i kinguqllirpaaq nepaq",
                    "The last sound there"
                ],
                [
                    "kesiin awa’i asiilkelluku.",
                    "was the worst."
                ]
            ],
            "fullEnglish": "The last sound there was the worst."
        },
        "187": {
            "startTime": 2461.572,
            "endTime": 2472.005,
            "sug": [
                [
                    "Taaten ipegluni nepa taugna",
                    "Like that the sound was so sharp"
                ],
                [
                    "tawarpiaq suu’um nenri kenirtuuqai,",
                    "it seemed to go even into his bones"
                ],
                [
                    "keligtuqai.",
                    "and scrape at them."
                ]
            ],
            "fullEnglish": "Like that the sound was so sharp it seemed to go even into and scrape at his bones."
        },
        "188": {
            "startTime": 2472.005,
            "endTime": 2483.435,
            "sug": [
                [
                    "Tamaana nepa",
                    "The sound"
                ],
                [
                    "tawarpiaq suu’um mal’uk salak keligtuuskek tawani.",
                    "was like that made by scraping two shells against each other."
                ]
            ],
            "fullEnglish": "The sound was like that made by scraping two shells against each other."
        },
        "189": {
            "startTime": 2483.435,
            "endTime": 2501.363,
            "sug": [
                [
                    "Tawa emtu’iwakar[luni]",
                    "When it got so loud"
                ],
                [
                    "alingwakarlluni",
                    "and he was so scared,"
                ],
                [
                    "iingalagni taaten patulukek,",
                    "he shut his eyes tight"
                ],
                [
                    "cuutegni aigaminek patulukek",
                    "and put his hands over his ears"
                ],
                [
                    "aqum’aluni,",
                    "as he sat,"
                ],
                [
                    "nepet tamaakut aulairnatiitnun.",
                    "until the noises were coming to an end."
                ]
            ],
            "fullEnglish": "When it got so loud, he shut his eyes tight and put his hands over his ears as he sat, until the noises were coming to an end."
        },
        "190": {
            "startTime": 2501.363,
            "endTime": 2514.572,
            "numberTitle": 39,
            "sug": [
                [
                    "Iingalagni tawa’i ikircam,",
                    "When he opened his eyes,"
                ],
                [
                    "tangerluku kenrem akiani tawani ar’ursulek aqum’aluni",
                    "he saw the whaler sitting across the coals from him,"
                ],
                [
                    "englaruarluni,",
                    "laughing,"
                ],
                [
                    "cesten kesiin niugtegkunani.",
                    "but he did not say anything."
                ]
            ],
            "fullEnglish": "When he opened his eyes, he saw the whaler sitting across the coals from him, laughing, but he did not say anything."
        },
        "191": {
            "startTime": 2514.572,
            "endTime": 2524.372,
            "sug": [
                [
                    "Tan’u-llu?",
                    "Boy?"
                ],
                [
                    "Tan’uraq kaigniluni,",
                    "He told the boy that he was hungry"
                ],
                [
                    "aularnirlutek tawaken isu’im kemganek nerlu[tek].",
                    "and they started eating the broiled seal meat."
                ]
            ],
            "fullEnglish": "Boy? He told the boy that he was hungry and they started eating the broiled seal meat."
        },
        "192": {
            "startTime": 2524.372,
            "endTime": 2533.756,
            "numberTitle": 40,
            "sug": [
                [
                    "Nernermegtegni tamaani",
                    "While they were eating,"
                ],
                [
                    "ar’ursulgem tan’uraq ulutekaa",
                    "the whaler would look at the boy"
                ],
                [
                    "englarluni aularnir[luni].",
                    "and start laughing."
                ]
            ],
            "fullEnglish": "While they were eating, the whaler would look at the boy and start laughing."
        },
        "193": {
            "startTime": 2533.756,
            "endTime": 2548.106,
            "sug": [
                [
                    "Tamaani tan’uraq kangirciluni",
                    "The boy knew then"
                ],
                [
                    "taug’um ar’ursulgem ukgueqen’ellkii",
                    "that the whaler did not believe him"
                ],
                [
                    "unuami tamaani niu’ucamiu,",
                    "when he told him in the morning"
                ],
                [
                    "aling’taan’iniluni.",
                    "he never got scared."
                ]
            ],
            "fullEnglish": "The boy knew then that the whaler did not believe him when he told him he never got scared."
        },
        "194": {
            "startTime": 2548.106,
            "endTime": 2563.433,
            "sug": [
                [
                    "Tawaten kii’an unilluku",
                    "And he had left him alone"
                ],
                [
                    "caqill’uayat tamaani akgua’ami taigkuar[luki] tupagcaturluku.",
                    "that evening and sent the spirits to frighten him"
                ],
                [
                    "Tawaken alingpianrani pitaqlluku.",
                    "so he could catch him when he really was scared."
                ]
            ],
            "fullEnglish": "And he had left him alone that evening and sent the spirits to frighten him so he could catch him when he really was scared."
        },
        "195": {
            "startTime": 2563.433,
            "endTime": 2568.208,
            "sug": [
                [
                    "Nutaan gua’i englarauteklluku tawaten.",
                    "He was making fun of him now."
                ]
            ],
            "fullEnglish": "He was making fun of him now."
        },
        "196": {
            "startTime": 2568.208,
            "endTime": 2588.114,
            "sug": [
                [
                    "Tawa umia[linguarluni]",
                    "He thought then"
                ],
                [
                    "caminguaqu niskuniu cesten ar’rusurtaartut",
                    "that as soon as he learned the old whaler’s secrets of how to kill the whale"
                ],
                [
                    "anglanasiiklluku aularniutekutarluku umiangulluku ar’ursulegni tama (all in all)",
                    "he would start playing tricks on him and get even with him."
                ]
            ],
            "fullEnglish": "He thought then that as soon as he learned the old whaler’s secrets of how to kill the whale he would start playing tricks on him and get even with him."
        },
        "197": {
            "startTime": 2588.114,
            "endTime": 2595.283,
            "numberTitle": 41,
            "sug": [
                [
                    "Tawaken ner’kaacamek",
                    "After they ate"
                ],
                [
                    "ciqlluamen taglutek.",
                    "they went up to the hut."
                ]
            ],
            "fullEnglish": "After they ate they went up to the hut."
        },
        "198": {
            "startTime": 2595.283,
            "endTime": 2613.13,
            "sug": [
                [
                    "Tawa’i inarqu[rngamek]",
                    "When they went to bed"
                ],
                [
                    "ar’ursulgem tan’uraq piluku",
                    "the whaler said"
                ],
                [
                    "unuami tawa’ut kani’aruam painganun anciqnilutek",
                    "that they would be going out to the mouth of the lagoon"
                ],
                [
                    "kangi’armi angesqami tawaten ar’ungqertacia takuluku.",
                    "to see if there were any whale in the bay."
                ]
            ],
            "fullEnglish": "When they went to bed the whaler said that they would be going out to the mouth of the lagoon to see if there were any whale in the bay."
        },
        "199": {
            "startTime": 2613.13,
            "endTime": 2621.52,
            "sug": [
                [
                    "Cali awa’i ar’ursuryarnia’arnilutek (“kiinia’arlutek ar’rusuryarlutek the kiilutek - they started off)",
                    "He said that they would be going whale hunting in a few more days."
                ]
            ],
            "fullEnglish": "He said that they would be going whale hunting in a few more days."
        },
        "200": {
            "startTime": 2621.52,
            "endTime": 2632.547,
            "numberTitle": 42,
            "sug": [
                [
                    "Unuami tawa’i unuaquani",
                    "At dawn the next morning"
                ],
                [
                    "anlutek tawaken kangi’angcugmek",
                    "they went out of the lagoon"
                ],
                [
                    "angesqamen kangi’armen.",
                    "into a narrow bay."
                ]
            ],
            "fullEnglish": "At dawn the next morning they went out of the lagoon into a narrow bay."
        },
        "201": {
            "startTime": 2632.547,
            "endTime": 2639.447,
            "sug": [
                [
                    "Tawani qaugcin ar’ut sua’aluteng",
                    "They could hear several whale blowing out"
                ],
                [
                    "kangiraam qukaani.",
                    "in the middle."
                ]
            ],
            "fullEnglish": "They could hear several whale blowing out in the middle."
        },
        "202": {
            "startTime": 2639.447,
            "endTime": 2650.104,
            "sug": [
                [
                    "Tawaken ar’rusulgem tan’uraq aplluku,",
                    "The whaler asked the boy"
                ],
                [
                    "nallun’itaa-qaa",
                    "if he knew"
                ],
                [
                    "cesten ar’ut tangartaartat.",
                    "how the whales drank water."
                ]
            ],
            "fullEnglish": "The whaler asked the boy if he knew how the whales drank water."
        },
        "203": {
            "startTime": 2650.104,
            "endTime": 2673.114,
            "sug": [
                [
                    "Tan’uraraam tawa’i niu’ulluku",
                    "When the boy said"
                ],
                [
                    "nalluniluku",
                    "that he did not know,"
                ],
                [
                    "tawa’i, ar’ursulem pimaa,",
                    "the whaler said"
                ],
                [
                    "ikani nani (kuigam) kuiguangqertaarniluku cingiguam tunuani anqerca’am tawa’i yaateraani",
                    "that there was a little waterfall behind a point not far from the mouth of the lagoon"
                ],
                [
                    "nat’en ar’ut taangaryaturetaartat unuakaa’armi.",
                    "where whale come to drink water at dawn."
                ]
            ],
            "fullEnglish": "When the boy said that he did not know, the whaler said that there was a little waterfall behind a point not far from the mouth of the lagoon where whale come to drink water at dawn."
        },
        "204": {
            "startTime": 2673.114,
            "endTime": 2680.514,
            "sug": [
                [
                    "Tawa’i tawa’ut aiwilluku",
                    "He took him [by boat] there"
                ],
                [
                    "tang’rtesaturluku.",
                    "to show him."
                ]
            ],
            "fullEnglish": "He took him [by boat] there to show him."
        },
        "205": {
            "startTime": 2680.514,
            "endTime": 2688.886,
            "numberTitle": 43,
            "sug": [
                [
                    "Tawaken ar’uq keluwarluni",
                    "Soon a whale came to the surface close in"
                ],
                [
                    "kelukaa’ame kuimarluni",
                    "and swam on the surface"
                ],
                [
                    "nunam tungiinun.",
                    "toward shore."
                ]
            ],
            "fullEnglish": "Soon a whale came to the surface close in and swam on the surface toward shore."
        },
        "206": {
            "startTime": 2688.886,
            "endTime": 2696.251,
            "sug": [
                [
                    "Culurnginaqaalluni tamaakerllainaq",
                    "After almost touching the shore"
                ],
                [
                    "angllurluni angitmen ima",
                    "it turned around suddenly and went under"
                ],
                [
                    "tamarluni.",
                    "and disappeared."
                ]
            ],
            "fullEnglish": "After almost touching the shore it turned around suddenly and went under and disappeared."
        },
        "207": {
            "startTime": 2696.251,
            "endTime": 2700.519,
            "sug": [
                [
                    "Allakat cali tawaterluteng.",
                    "The others did the same."
                ]
            ],
            "fullEnglish": "The others did the same."
        },
        "208": {
            "startTime": 2700.519,
            "endTime": 2714.744,
            "sug": [
                [
                    "Ar’ursulek taugna awa’i giinaa allangaluni nallunainani ugayun’ilami.",
                    "The whaler was frowning [because he wasn’t satisfied]."
                ],
                [
                    "Tan’uraq pimaa[?],",
                    "He said to the boy,"
                ],
                [
                    "“Angitmen ciqlluamen aglinuk.”",
                    "“Let us go back to the hut.”"
                ]
            ],
            "fullEnglish": "The whaler was frowning [because he wasn’t satisfied]. He said to the boy, “Let us go back to the hut.”"
        },
        "209": {
            "startTime": 2714.744,
            "endTime": 2727.547,
            "numberTitle": 44,
            "sug": [
                [
                    "Angicamek",
                    "On the way back to the hut,"
                ],
                [
                    "tawa’i ar’ursulgem tan’uraq niu’ulluku,",
                    "the whaler was telling the boy"
                ],
                [
                    "suu’ut ana’uspiaq arnat, cali (ta--) qenasqat [?]",
                    "that people especially women and the sick,"
                ],
                [
                    "arillangqerniluki.",
                    "give out vapors."
                ]
            ],
            "fullEnglish": "On the way back to the hut, the whaler was telling the boy that people especially women and the sick, give out vapors."
        },
        "210": {
            "startTime": 2727.547,
            "endTime": 2743.504,
            "sug": [
                [
                    "Tamaakut tamaa’i suu’um atkuanun, qainganun, neplluteng,",
                    "That the vapors cling to the clothes and to the body"
                ],
                [
                    "ung’wallriat, ana’uspiaq ar’ut,",
                    "and that the animals, especially whales,"
                ],
                [
                    "tamaakut tamaa’i arillat pingaketaan’inilu[ki]. (pingake...taan...ninilu--)",
                    "are very sensitive to these vapors."
                ]
            ],
            "fullEnglish": "That the vapors cling to the clothes and to the body and that the animals, especially whales, are very sensitive to these vapors."
        },
        "211": {
            "startTime": 2743.504,
            "endTime": 2766.841,
            "sug": [
                [
                    "Niugllu[ni],",
                    "He said,"
                ],
                [
                    "“Tawaten suk pisuryarpailarmi",
                    "\"That is why before one hunts,"
                ],
                [
                    "nat’en / allamen, napani et’eraarluni,",
                    "one had to stay away in the woods from other people for many days,"
                ],
                [
                    "ana’uspiaq ar’ursuqutaquni,",
                    "especially before going out after the whale,"
                ],
                [
                    "tepet tamaakut pii’unateklluki et’eraarluni. (pii’unatiitnun)",
                    "so that the smells disappear."
                ]
            ],
            "fullEnglish": "That is why one had to stay away from other people for many days before going out after the whale."
        },
        "212": {
            "startTime": 2766.841,
            "endTime": 2780.689,
            "numberTitle": 45,
            "sug": [
                [
                    "Ciqlluamen angitmen tuc’amek",
                    "When they got back to the hut"
                ],
                [
                    "alliqatek anlluki,",
                    "they took out the old straw bedding"
                ],
                [
                    "nuta’anek wegnek itrullutek",
                    "and brought in some fresh straw"
                ],
                [
                    "alli’anguatek llaami anesngaluki.",
                    "and hung their seal-skin beds outside to air out."
                ]
            ],
            "fullEnglish": "When they got back to the hut they took out the old straw bedding and brought in some fresh straw and hung their seal-skin beds outside to air out."
        },
        "213": {
            "startTime": 2780.689,
            "endTime": 2801.986,
            "sug": [
                [
                    "Tawaken kuiguami maqilutek.",
                    "Then they bathed in the creek."
                ],
                [
                    "Taug’um kingullrani",
                    "After that"
                ],
                [
                    "ar’ursulem tan’uraq piluku",
                    "the whaler said to the boy"
                ],
                [
                    "napanun tagciqniluni kuingqaa’aryaturluni.",
                    "that he was going in the woods for a walk"
                ],
                [
                    "Tan'uraq [?].",
                    "and told the boy to stay in the hut until he got back."
                ]
            ],
            "fullEnglish": "Then they bathed in the creek. After that the whaler said he was going in the woods for a walk and told the boy to stay in the hut until he got back."
        },
        "214": {
            "startTime": 2801.986,
            "endTime": 2821.406,
            "sug": [
                [
                    "Tan’uraq utaqalill’akaalluni",
                    "The boy waited a while"
                ],
                [
                    "ar’ursulek maligtepiarluku,",
                    "before the whaler followed,"
                ],
                [
                    "naparuangcugnun tamaa’ut tagluni",
                    "then went straight to the sprucelings"
                ],
                [
                    "uluteksaturluku",
                    "and crawled"
                ],
                [
                    "naken cuumi uluteketacia.",
                    "through the same place he crawled through the day before."
                ]
            ],
            "fullEnglish": "The boy waited a while before the whaler followed, then went straight to the sprucelings and crawled through the same place he crawled through the day before."
        },
        "215": {
            "startTime": 2821.406,
            "endTime": 2836.543,
            "numberTitle": 46,
            "sug": [
                [
                    "Tawa’i napat aciatgun suarngami",
                    "When he got through,"
                ],
                [
                    "tangerluku",
                    "he saw"
                ],
                [
                    "tuquneq taugna awa’i anesngaluni",
                    "that the corpse was already out"
                ],
                [
                    "nanwaruam taug’um caniani.",
                    "of the water."
                ]
            ],
            "fullEnglish": "When he got through, he saw that the corpse was already out of the water."
        },
        "216": {
            "startTime": 2836.543,
            "endTime": 2846.975,
            "sug": [
                [
                    "Ar’ursulek qaiqunamek anluni.",
                    "The whaler was coming out of the cave"
                ],
                [
                    "Asumek yaamarmek piliamek ang’atangqerlluni.",
                    "with a big vessel hallowed out of stone."
                ]
            ],
            "fullEnglish": "The whaler was coming out of the cave with a big vessel hallowed out of stone."
        },
        "217": {
            "startTime": 2846.975,
            "endTime": 2860.912,
            "sug": [
                [
                    "Yaamak mal’uk lliingia’arlukek",
                    "He put two flat rocks a little apart from each other"
                ],
                [
                    "tawa’ut asuq taugna qainganun lliiluku,",
                    "and set the vessel on them"
                ],
                [
                    "aciani tawaken kenengcugmek kuarciluni.",
                    "and started a small fire under it."
                ]
            ],
            "fullEnglish": "He put two flat rocks a little apart from each other and set the vessel on them and started a small fire under it."
        },
        "218": {
            "startTime": 2860.912,
            "endTime": 2888.208,
            "numberTitle": 47,
            "sug": [
                [
                    "Tawaken kemek segertaarluku, asumen kata’agkuarluku,",
                    "Then he cut all the flesh from the corpse, [?]"
                ],
                [
                    "nenratnek yuularluku kemek.",
                    "and removed the flesh from the bones."
                ],
                [
                    "Nasqullra taug’um tuqunrem lliiluku",
                    "He put the skull"
                ],
                [
                    "allakat nasqut akuliitnun.",
                    "on the ledge with the others"
                ],
                [
                    "Nenret tamaa’ut qaiqunam natranun egteqainarlu[ki].",
                    "and just threw the bones on the ground in the cave."
                ]
            ],
            "fullEnglish": "Then he cut all the flesh from the corpse and took the bones and the skull in the cave, throwing the bones on the ground and putting the skull on the ledge with the others."
        },
        "219": {
            "startTime": 2888.208,
            "endTime": 2911.043,
            "sug": [
                [
                    "Anluni tawaken",
                    "He came out"
                ],
                [
                    "kemga segertaarluku,",
                    "and started cutting the flesh in strips"
                ],
                [
                    "asumen kata’agkuarluku.",
                    "and put them in the pot."
                ],
                [
                    "Tan’uraraam niilluku",
                    "The boy could hear"
                ],
                [
                    "kemek tawa asumen katagtes[nerani]",
                    "the flesh put in the pot"
                ],
                [
                    "cesten carya’arqaanguaqainarluni. (carya’arqaanguaq...qainarluni).",
                    "how it sizzled."
                ]
            ],
            "fullEnglish": "He came out and started cutting the flesh in strips and put them next to the fire."
        },
        "220": {
            "startTime": 2911.043,
            "endTime": 2939.862,
            "sug": [
                [
                    "Tawaken uqiun’irngamiu uqua taugna suqamen, taug’um suu’um suqaanun qupuramek patgutamek tawa kugturluku",
                    "When he finished frying the flesh he poured the oil into the dried stomach with a wooden spoon and took it in the cave."
                ],
                [
                    "tan’uraq umialinguarluni",
                    "The boy wondered"
                ],
                [
                    "cesten caqimen-mi-gua una suu’um uqua atuqutartau.",
                    "what the whaler was going to do with the oil."
                ]
            ],
            "fullEnglish": "Then he sat down and cut the strips in small pieces and dropped them into the stone vessel. As he dropped the flesh into the hot vessel the boy could hear it sizzle."
        },
        "221": {
            "startTime": 2939.862,
            "endTime": 2958.42,
            "sug": [
                [
                    "Isu’it suqait (atur--) nallugkunaku aturaat isu’im uqua tuumiaqlluku tawani,",
                    "Dried seal stomachs were used as containers for seal oil,"
                ],
                [
                    "tawaken isu’im uqua pitur[luku] iqalluk-llu, neqet-llu, cali allakat neqkat-llu.",
                    "and the oil was used with fish and roots and other foods."
                ]
            ],
            "fullEnglish": "When he finished frying the flesh he poured the oil into the dried stomach with a wooden spoon and took it in the cave."
        },
        "222": {
            "startTime": 2958.42,
            "endTime": 2967.798,
            "sug": [
                [
                    "Tawaken kesiin picingegkunani",
                    "But he never heard"
                ],
                [
                    "cesten, caqimen suu’um uqua aturciq[au].",
                    "of anyone eating human oil."
                ]
            ],
            "fullEnglish": "The boy wondered what the whaler was going to do with the oil. Dried seal stomachs were used as containers for seal oil, and the oil was used with fish and roots and other foods, but he never heard of anyone eating human oil."
        },
        "223": {
            "startTime": 2974.203,
            "endTime": 3000.417,
            "numberTitle": 48,
            "sug": [
                [
                    "Tawaken qaiqunamek anngami,",
                    "When the whaler came out"
                ],
                [
                    "suqaq inikaacamiu tawa’ut,",
                    "[?]"
                ],
                [
                    "anngami tawa’i ayaqum cingia tuuluku",
                    "he took the spearpoint"
                ],
                [
                    "cesten-llu cali mampalluglluni aularnirluni,",
                    "and, mumbling something again,"
                ],
                [
                    "ayaqum taugna puunga tuuluku,",
                    "took the shaft"
                ],
                [
                    "cingia nemrulluku iwalunek.",
                    "and tied the spearpoint to the shaft with sinew."
                ]
            ],
            "fullEnglish": "When the whaler came out he took the spearpoint and, mumbling something again, tied it to the shaft with sinew and stood it back where it was."
        },
        "224": {
            "startTime": 3000.417,
            "endTime": 3009.827,
            "sug": [
                [
                    "Taug’um [kingu]llrani",
                    "After that"
                ],
                [
                    "qaiqunami nepaillpiarluni aqumgaa’arluni.",
                    "he just sat quietly in the cave."
                ]
            ],
            "fullEnglish": "After that he just sat quietly in the cave."
        },
        "225": {
            "startTime": 3009.827,
            "endTime": 3018.985,
            "numberTitle": 49,
            "sug": [
                [
                    "Macaq kal’ukutarngan",
                    "As the sun was beginning to set,"
                ],
                [
                    "nangarlluni, nangartekaacan",
                    "he got up"
                ],
                [
                    "tawaken ngayanguarkunani esguaqataa’arluni",
                    "and started slowly down"
                ],
                [
                    "ciqlluam tungiinun.",
                    "the path."
                ]
            ],
            "fullEnglish": "As the sun was beginning to set, he got up and started slowly down the path."
        },
        "226": {
            "startTime": 3018.985,
            "endTime": 3025.282,
            "sug": [
                [
                    "Nasquni taaten cikesnga[luku]",
                    "He was holding his head down"
                ],
                [
                    "tawarpiaq angli umiarteqellria.",
                    "as if in deep thought."
                ]
            ],
            "fullEnglish": "He was holding his head down as if in deep thought."
        },
        "227": {
            "startTime": 3025.282,
            "endTime": 3035.498,
            "sug": [
                [
                    "Tan’uraq tawa awa’i, awa’i ciqlluami etaa’arluni",
                    "The boy was already in the hut."
                ],
                [
                    "kianit piatni aqum’aluni",
                    "He sat by the coals"
                ],
                [
                    "utaqaluku.",
                    "and waited."
                ]
            ],
            "fullEnglish": "The boy was already in the hut. He sat by the coals and waited."
        },
        "228": {
            "startTime": 3035.498,
            "endTime": 3044.798,
            "sug": [
                [
                    "Awa ar’ursulek tawa’i iterngami",
                    "When the whaler came in"
                ],
                [
                    "tan’uraq niu’ulluku",
                    "he told the boy"
                ],
                [
                    "cali maqiciqnilutek",
                    "that they would bathe again"
                ],
                [
                    "inarqurpailarmek.",
                    "before they went to bed."
                ]
            ],
            "fullEnglish": "When the whaler came in he told the boy that they would bathe again before they went to bed."
        },
        "229": {
            "startTime": 3044.798,
            "endTime": 3055.168,
            "sug": [
                [
                    "“Inarqurngigciqukuk akgua’arpak. (inarqur...ngigciqukuk)",
                    "“We will go to bed early."
                ],
                [
                    "Unuami tangerciqarpek",
                    "In the morning we will see"
                ],
                [
                    "cesten ar’ut piciqat",
                    "how the whale act"
                ],
                [
                    "taangaryatuquneng.",
                    "when they come in to drink water."
                ]
            ],
            "fullEnglish": "“We will go to bed early,” he said. “In the morning we will see how the whale act when they come in to drink water."
        },
        "230": {
            "startTime": 3055.168,
            "endTime": 3070.418,
            "sug": [
                [
                    "Asirluten qawakina. (Elliin)",
                    "Sleep good"
                ],
                [
                    "Unuami erneq nangluku unuami erneq nangluku eciiqu[kuk]",
                    "because we will be out all day"
                ],
                [
                    "ar’ut qiman’illkata.",
                    "if the whale act right."
                ]
            ],
            "fullEnglish": "Sleep good because we will be out all day if the whale act right."
        },
        "231": {
            "startTime": 3070.418,
            "endTime": 3077.535,
            "sug": [
                [
                    "Esgarngigciqua",
                    "I will get up early,"
                ],
                [
                    "ellpet inarngakina",
                    "but you will not get up"
                ],
                [
                    "qayu niu’unatemnun.”",
                    "until I call you.”"
                ]
            ],
            "fullEnglish": "I will get up early, but you will not get up until I call you.”"
        },
        "232": {
            "startTime": 3077.535,
            "endTime": 3085.748,
            "numberTitle": 50,
            "sug": [
                [
                    "Cali tamlenrani",
                    "It was still dark"
                ],
                [
                    "tan’uraraam unuami niilluku",
                    "when the boy heard"
                ],
                [
                    "ar’ursulek makcan.",
                    "the whaler getting up."
                ]
            ],
            "fullEnglish": "It was still dark when the boy heard the whaler getting up."
        },
        "233": {
            "startTime": 3085.748,
            "endTime": 3094.432,
            "sug": [
                [
                    "Nepaillpiarluni anqataa’arluni.",
                    "He went out quietly"
                ],
                [
                    "Qakma niilluku",
                    "and he heard him"
                ],
                [
                    "aprutekun qaiqunam tungiinun tagluni.",
                    "going up the path toward the cave."
                ]
            ],
            "fullEnglish": "He went out quietly and he heard him going up the path toward the cave."
        },
        "234": {
            "startTime": 3094.432,
            "endTime": 3101.769,
            "sug": [
                [
                    "Mulun’illpiarluni",
                    "He was back in a short while"
                ],
                [
                    "niilluku",
                    "and he heard him"
                ],
                [
                    "tawa’i cali esguarluni",
                    "going down"
                ],
                [
                    "qayam awatiini caliluni.",
                    "and doing something by the kayak."
                ]
            ],
            "fullEnglish": "He was back in a short while and he heard him doing something by the kayak."
        },
        "235": {
            "startTime": 3101.769,
            "endTime": 3108.544,
            "sug": [
                [
                    "Taaken amiigmek tan’uraq qaya’aluku,",
                    "Then he called the boy from the door"
                ],
                [
                    "awa’i / elgarnganiluni.",
                    "[?]."
                ]
            ],
            "fullEnglish": "Then he called the boy from the door."
        },
        "236": {
            "startTime": 3108.544,
            "endTime": 3119.97,
            "numberTitle": 51,
            "sug": [
                [
                    "Cali llaami tamlegluni.",
                    "It was still very dark outside."
                ],
                [
                    "Qayartek esguaulluku qutmen,",
                    "They carried the kayak down to the beach"
                ],
                [
                    "aiwilutek",
                    "and started out"
                ],
                [
                    "neren’illpiarlutek.",
                    "without eating."
                ]
            ],
            "fullEnglish": "It was still very dark outside. They carried the kayak down to the beach and started out without eating."
        },
        "237": {
            "startTime": 3119.97,
            "endTime": 3134.034,
            "sug": [
                [
                    "Tawaten ar’ursulek nepaillpiarluni",
                    "The whaler was silent"
                ],
                [
                    "tawa’ut kuiguamen naken penamek katagta tung’inaam[ek] ta[wa’i] aularnirluni niu’aluni.",
                    "all the way until they got to the little waterfall, [?]."
                ]
            ],
            "fullEnglish": "The whaler was silent all the way until they got to the little waterfall."
        },
        "238": {
            "startTime": 3134.034,
            "endTime": 3145.553,
            "sug": [
                [
                    "Tamaani tawa’i tan’uraq pimaa,",
                    "When they got there he said,"
                ],
                [
                    "“Nutaan-gua tang’rciqan",
                    "“Now you will see"
                ],
                [
                    "cesten ar’uq taangartaarta",
                    "how the whale drinks water"
                ],
                [
                    "qiman’illkuni.",
                    "if it doesn't run away."
                ]
            ],
            "fullEnglish": "When they got there he said, “Now we will see how the whaler will act."
        },
        "239": {
            "startTime": 3145.553,
            "endTime": 3153.603,
            "sug": [
                [
                    "P’rillkumnuk",
                    "If we are clean,"
                ],
                [
                    "taangarciqut.",
                    "they will come in to drink."
                ],
                [
                    "Tawaken pisuryarciqarpek.”",
                    "Then we will go on the hunt.”"
                ]
            ],
            "fullEnglish": "If we are clean, they will come in to drink. Then we will go on the hunt.”"
        },
        "240": {
            "startTime": 3153.603,
            "endTime": 3163.736,
            "numberTitle": 52,
            "sug": [
                [
                    "Erqaa’arutiini",
                    "At daybreak"
                ],
                [
                    "ar’uq suarluni",
                    "a whale came to the surface"
                ],
                [
                    "kuiguam tawa ketiini natmen kuimarluni.",
                    "and swam toward shore."
                ]
            ],
            "fullEnglish": "At daybreak a whale came to the surface and swam toward shore."
        },
        "241": {
            "startTime": 3163.736,
            "endTime": 3175.498,
            "sug": [
                [
                    "Kenauluni tawaten,",
                    "The tide was low [and the waterfall was up some ways from the sea.]"
                ],
                [
                    "taumi umialinguarluni tawa,",
                    "The boy wondered"
                ],
                [
                    "cesten-gua ar’uq paaguut tagciqa taangam katagguianun?",
                    "how it could get up there to drink."
                ]
            ],
            "fullEnglish": "The tide was low and the waterfall was up some ways from the sea."
        },
        "242": {
            "startTime": 3175.498,
            "endTime": 3197.665,
            "sug": [
                [
                    "Taaten umialinguanrani",
                    "As he was thinking that,"
                ],
                [
                    "ar’uq culurlluni",
                    "the whale slowly shoved its head up the beach"
                ],
                [
                    "qan’i aitarllu[ku]",
                    "and opened its mouth"
                ],
                [
                    "tawaken sungcuk anluni qanranek,",
                    "and a little man came out from its mouth,"
                ],
                [
                    "taanga’utegnek ang’atangqerlluni,",
                    "with a bucket in each hand"
                ],
                [
                    "isu’im amianek canamalutek.",
                    "made out of leather."
                ]
            ],
            "fullEnglish": "The boy wondered how it could get up there to drink."
        },
        "243": {
            "startTime": 3197.665,
            "endTime": 3212.775,
            "sug": [
                [
                    "Tawa’i anluni mill’ukek [?].",
                    "He came out and went up to the waterfall."
                ],
                [
                    "Tawaken taangaq nani katagta, tawaken imiqaallukek",
                    "He filled the buckets with water"
                ],
                [
                    "angilluni",
                    "and went back down"
                ],
                [
                    "ar’um qanranun angitmen iterlluni.",
                    "and into the whale’s mouth."
                ]
            ],
            "fullEnglish": "As he watched, the whale slowly shoved its head up the beach and opened its mouth and a little man, with a leather bucket in each hand, came out and went up to the waterfall. He filled the buckets with water and went back down and into the whale’s mouth."
        },
        "244": {
            "startTime": 3212.775,
            "endTime": 3220.397,
            "sug": [
                [
                    "Ar’um qan’i patukaalluku",
                    "The whale closed its mouth"
                ],
                [
                    "angitmen imarmen caulluni",
                    "and turned out to sea"
                ],
                [
                    "imangllurluni. (angllurluni)",
                    "and disappeared."
                ]
            ],
            "fullEnglish": "The whale closed its mouth and turned out to sea and disappeared."
        },
        "245": {
            "startTime": 3220.397,
            "endTime": 3232.662,
            "sug": [
                [
                    "Tawa ar’ursulgem tan’uraq piluku,",
                    "The whaler said to the boy,"
                ],
                [
                    "“Gua’i nallun’itan",
                    "“You know now"
                ],
                [
                    "cesten ar’ut taangartaartat.",
                    "how the whales drink water."
                ],
                [
                    "Nutaan gua’i tang’rciqan",
                    "Now you will see"
                ],
                [
                    "cesten pisurtaaraat.”",
                    "how they are hunted.”"
                ]
            ],
            "fullEnglish": "“You know now how the whales drink water,” the whaler said. “Now you will see how they are hunted.”"
        },
        "246": {
            "startTime": 3232.662,
            "endTime": 3240.981,
            "sug": [
                [
                    "Qayaq tawa una caulluku",
                    "He turned the kayak around"
                ],
                [
                    "kangi’am painganun, taug’um angesqam kangi’am paingan tungii[nun]. (Angitmen--)",
                    "and headed it toward the mouth of the bay."
                ]
            ],
            "fullEnglish": "He turned the kayak around and headed it toward the mouth of the bay."
        },
        "247": {
            "startTime": 3240.981,
            "endTime": 3256.216,
            "numberTitle": 53,
            "sug": [
                [
                    "Anitmen",
                    "On the way back"
                ],
                [
                    "tan’uraraam tawa’i tangraa",
                    "the boy noticed"
                ],
                [
                    "taugna ayaqum cingia",
                    "a spearpoint"
                ],
                [
                    "tawani caqnem piani.",
                    "next to the hatch he was in."
                ]
            ],
            "fullEnglish": "On the way back the boy noticed a spearpoint next to the hatch he was in."
        },
        "248": {
            "startTime": 3256.216,
            "endTime": 3264.832,
            "sug": [
                [
                    "Iqua taugna,",
                    "Its tip,"
                ],
                [
                    "Cingia taugna",
                    "its point"
                ],
                [
                    "augmek kinerngasqamek patuman,",
                    "was covered with dried blood"
                ],
                [
                    "pitanist’r’uma’a.",
                    "as far as the groove."
                ]
            ],
            "fullEnglish": "Its tip, its point was covered with dried blood as far as the groove."
        },
        "249": {
            "startTime": 3264.832,
            "endTime": 3274.097,
            "sug": [
                [
                    "Angitmen takuyarluni,",
                    "He glanced back"
                ],
                [
                    "tawani tang’rluku",
                    "and saw"
                ],
                [
                    "cali taugna ar’um puunga",
                    "that it was the same point and whale’s (spear) shaft"
                ],
                [
                    "qaiqunam piani et’lleq.",
                    "he saw at the cave."
                ]
            ],
            "fullEnglish": "He glanced back and saw that it was the same point and whale’s (spear) shaft he saw at the cave."
        },
        "250": {
            "startTime": 3274.097,
            "endTime": 3293.673,
            "sug": [
                [
                    "Awa’i elgarngaluni taugna ar’um puunga taqumapiarlu[ni].",
                    "The whale’s (spear) shaft was on the rack now ready for the hunt."
                ]
            ],
            "fullEnglish": "The whale’s (spear) shaft was on the rack now ready for the hunt."
        },
        "251": {
            "startTime": 3293.673,
            "endTime": 3301.805,
            "numberTitle": 54,
            "sug": [
                [
                    "Tawani kangi’am paingani lurkinani,",
                    "The bay was narrow at the mouth."
                ],
                [
                    "tuc’amek tawa’ut",
                    "When they got there"
                ],
                [
                    "nagllutek.",
                    "they stopped."
                ]
            ],
            "fullEnglish": "The bay was narrow at the mouth. When they got there they stopped."
        },
        "252": {
            "startTime": 3301.805,
            "endTime": 3307.66,
            "sug": [
                [
                    "Ar’ursulek ta[wa] kangi’am qitganun takuya’aluni.",
                    "The whaler kept looking toward the head of the bay."
                ]
            ],
            "fullEnglish": "The whaler kept looking toward the head of the bay."
        },
        "253": {
            "startTime": 3307.66,
            "endTime": 3315.588,
            "sug": [
                [
                    "Ar’umek tangerngami",
                    "When he saw a whale in there"
                ],
                [
                    "tan’uraq (pigaa,) piluku,",
                    "he said to the boy,"
                ],
                [
                    "“Ellpet akitmen pat’gciquten kii’ut.”",
                    "“You will paddle to the other side alone."
                ]
            ],
            "fullEnglish": "When he saw a whale in there he said to the boy, “You will paddle to the other side alone."
        },
        "254": {
            "startTime": 3315.588,
            "endTime": 3324.642,
            "sug": [
                [
                    "Pitacirpetun patkina,",
                    "Paddle as hard as you can"
                ],
                [
                    "angitmen takuyarsaaq’gkunak",
                    "and don’t look back"
                ],
                [
                    "akitmen tun’atemtegnun.",
                    "until you get across.”"
                ]
            ],
            "fullEnglish": "Paddle as hard as you can and don’t look back until you get across.”"
        },
        "255": {
            "startTime": 3324.642,
            "endTime": 3338.492,
            "numberTitle": 55,
            "sug": [
                [
                    "Tawa’i ar’ursulgem niu’ucani angitmen takuyaasq[‘gkunani]",
                    "Since the whaler told him not to look back,"
                ],
                [
                    "tan’uraq umialinguarluni,",
                    "the boy figured"
                ],
                [
                    "cali’uq tawani tunuani, caqimek tangsqenitau taug’um[en] tanurarmen.",
                    "that the whaler was doing something that he did not want him to see."
                ]
            ],
            "fullEnglish": "Since the whaler told him not to look back, the boy figured that the whaler was doing something that he did not want him to see."
        },
        "256": {
            "startTime": 3338.492,
            "endTime": 3349.891,
            "sug": [
                [
                    "Awa epsayugluni",
                    "He was full of curiousity now"
                ],
                [
                    "taaten picingengnaqlluni",
                    "and was trying to figure out"
                ],
                [
                    "cesten angitmen takuyarnayarta",
                    "how he could look back"
                ],
                [
                    "tang’rluku cali’a ar’ursulek taunumini.",
                    "to see what the whaler was doing behind him."
                ]
            ],
            "fullEnglish": "He was full of curiousity now and was trying to figure out how he could look back to see what the whaler was doing behind him when he heard a whale blowing behind them."
        },
        "257": {
            "startTime": 3349.891,
            "endTime": 3381.897,
            "sug": [
                [
                    "Tawaken niilluku ar’uq suarluni tunumeg[tegni],",
                    "When he heard a whale blowing behind them."
                ],
                [
                    "umialingua[rluni]",
                    "Figuring"
                ],
                [
                    "ar’ursulem ulutekaa (.),",
                    "that the whaler was looking back at it,"
                ],
                [
                    "tunutmen takus’aarlluni [?],",
                    "he took a quick look back"
                ],
                [
                    "tangerluku",
                    "and saw"
                ],
                [
                    "ar’ursulgem taugna suu’um (suqua tuumiaqlluk--) suqaa tuumiaqlluku,",
                    "that the whaler was holding the human stomach"
                ],
                [
                    "qayam caniqaagun",
                    "over the side of the kayak"
                ],
                [
                    "uquq kuci’agkuarluku.",
                    "and was letting the oil drip out of it"
                ],
                [
                    "Tawaten / kingumegtegni uquaq unilluku kangi’am / akianek tawa akianun nat’en ayugiak.",
                    "and they were leaving a shiny oil slick behind them."
                ]
            ],
            "fullEnglish": "Figuring that the whaler was looking back at it, he took a quick look back and saw that the whaler was holding the human stomach over the side of the kayak and was letting the oil drip out of it and they were leaving a shiny oil slick behind them."
        },
        "258": {
            "startTime": 3381.897,
            "endTime": 3393.572,
            "numberTitle": 56,
            "sug": [
                [
                    "Akitmen tawa tull’utek",
                    "They got across at last"
                ],
                [
                    "tawa’i ar’ursulem tan’uraq piluku",
                    "and the whaler told the boy"
                ],
                [
                    "qutem culurceqlluku,",
                    "to land on the beach"
                ],
                [
                    "mernuirciraa’asq’lluku.",
                    "and rest for a while."
                ]
            ],
            "fullEnglish": "They got across at last and the whaler told the boy to land on the beach and rest for a while."
        },
        "259": {
            "startTime": 3393.572,
            "endTime": 3408.859,
            "sug": [
                [
                    "Qutmek",
                    "From the beach"
                ],
                [
                    "tan’uraraam tawa’i uquaq tangerluku",
                    "he could see that the oil slick (ook-wak)"
                ],
                [
                    "kangi’am akianun tusngaluni.",
                    "stretched all the way across the bay"
                ],
                [
                    "Umialingua[rluni:]",
                    "and wondered"
                ],
                [
                    "qayu-mi-gua tawaten una lliigau?",
                    "what it could be for."
                ]
            ],
            "fullEnglish": "From the beach he could see that the oil slick (ook-wak) stretched all the way across the bay and wondered what it could be for."
        },
        "260": {
            "startTime": 3408.859,
            "endTime": 3422.311,
            "numberTitle": 57,
            "sug": [
                [
                    "Mulugkunani nallun’irluku",
                    "Soon he found out."
                ],
                [
                    "awa tang’rngamiu",
                    "[?]"
                ],
                [
                    "ar’uq tawa’ut, uquamen pitakaalluni angitmen kangi’am qitganun",
                    "The whale would head out toward the mouth of the bay, but when he got close to it,"
                ],
                [
                    "angiqaqlluki.",
                    "it would turn back."
                ]
            ],
            "fullEnglish": "Soon he found out. The whale would head out toward the mouth of the bay, but when he got close to it, it would turn back."
        },
        "261": {
            "startTime": 3422.311,
            "endTime": 3436.588,
            "sug": [
                [
                    "Tawaken nallugkunani, nallun’irluku",
                    "He knew that"
                ],
                [
                    "ar’um alikumaa suu’um uqua.",
                    "the whale was afraid to get near the human oil."
                ],
                [
                    "Awa pitaqumaluni tawani kangi’armi ankaugkunani.",
                    "It was trapped in the bay."
                ]
            ],
            "fullEnglish": "He knew that the whale was afraid to get near the human oil. It was trapped in the bay."
        },
        "262": {
            "startTime": 3436.588,
            "endTime": 3446.888,
            "numberTitle": 58,
            "sug": [
                [
                    "Tan’uraq tawa mernuirtunrani",
                    "While the boy was resting"
                ],
                [
                    "ar’ursulek qungalluni,",
                    "the whaler was getting ready."
                ],
                [
                    "ayaquq taugna cutmen lliiluku.",
                    "He moved the spear farther ahead on rack"
                ]
            ],
            "fullEnglish": "While the boy was resting the whaler was getting ready. He moved the spear farther ahead on rack"
        },
        "263": {
            "startTime": 3446.888,
            "endTime": 3454.273,
            "sug": [
                [
                    "Misuuguaq tawaken kingumek caqnermek anlluku",
                    "He took a leather pouch out of the after hatch"
                ],
                [
                    "cuunguamen tawa’ut lliiluku.",
                    "and put it in the front hatch."
                ]
            ],
            "fullEnglish": "He took a leather pouch out of the after hatch and put it in the front hatch."
        },
        "264": {
            "startTime": 3454.273,
            "endTime": 3462.688,
            "sug": [
                [
                    "Tawa’i elgarcami, qayaluku,",
                    "When he was ready, he called,"
                ],
                [
                    "“Kita tai-gut!”",
                    "“Come now.”"
                ],
                [
                    "Kingutmen aqumegkuarluku.",
                    "He let him get in the aft hatch."
                ]
            ],
            "fullEnglish": "When he was ready, he called, “Come now.” He let him get in the aft hatch."
        },
        "265": {
            "startTime": 3462.688,
            "endTime": 3490.024,
            "sug": [
                [
                    "Elliin ellminek ekguailarmi",
                    "Before getting in,"
                ],
                [
                    "tan’uraq niu’ulluku,",
                    "he told the boy,"
                ],
                [
                    "“Ellpet kii’ut pat’gciquten,",
                    "“You will do the paddling"
                ],
                [
                    "ar’um canianun tuskuma ayaqukumku [?]",
                    "when we get close enough to the whale for me to strike. I will be standing when I strike"
                ],
                [
                    "ellpet patgutarpenun tuumiaq’gkiu qayaq (kitngunilngukuk,) kitngukuarkunanuk.",
                    "and you must steady the kayak so I can sink the spear deep."
                ]
            ],
            "fullEnglish": "Before getting in, he told the boy, “You will do the paddling when we get close enough to the whale for me to strike. I will be standing when I strike and you must steady the kayak so I can sink the spear deep."
        },
        "266": {
            "startTime": 3490.024,
            "endTime": 3495.479,
            "sug": [
                [
                    "Tunumek tang’rciqan cesten lliicaarciqamken.",
                    "From the back you will see every signal I give you."
                ]
            ],
            "fullEnglish": "From the back you will see every signal I give you."
        },
        "267": {
            "startTime": 3495.479,
            "endTime": 3506.337,
            "sug": [
                [
                    "Angli asircaullua tan’rhniq’gkia,",
                    "Watch me closely"
                ],
                [
                    "tawaten cesten niu’ucimken piluten.”",
                    "and do everything I tell you."
                ],
                [
                    "Cuunguamen-ta eklluni taangatmen",
                    "Getting in the front hatch,”"
                ],
                [
                    "qaya[luni].",
                    "he called back."
                ]
            ],
            "fullEnglish": "Watch me closely and do everything I tell you. Getting in the front hatch,” he called back."
        },
        "268": {
            "startTime": 3506.337,
            "endTime": 3513.558,
            "sug": [
                [
                    "“Kita! Awa!”",
                    "“Kita. Now.”"
                ],
                [
                    "Anguar[lutek] una’ut ketmen",
                    "And they paddled out"
                ],
                [
                    "kangiraam qukaanun.",
                    "to the middle of the bay."
                ]
            ],
            "fullEnglish": "“Kita. Now.” And they paddled out to the middle of the bay."
        },
        "269": {
            "startTime": 3513.558,
            "endTime": 3526.882,
            "numberTitle": 59,
            "sug": [
                [
                    "Nunamek",
                    "When they were ashore"
                ],
                [
                    "tan’uraraam tangerluku",
                    "the boy noticed"
                ],
                [
                    "ar’uq uquamek angiqaq’gkuni all’ilugmi tawani sua’aluni, angitmen kangi’armen angitaqua[luni].",
                    "that the whale came out at the same place each time it turned away from the oil slick."
                ]
            ],
            "fullEnglish": "When they were ashore the boy noticed that the whale came out at the same place each time it turned away from the oil slick."
        },
        "270": {
            "startTime": 3526.882,
            "endTime": 3532.315,
            "sug": [
                [
                    "Tawa’i tawani tawa utaqaluku.",
                    "They were now waiting for it at the same place."
                ]
            ],
            "fullEnglish": "They were now waiting for it at the same place."
        },
        "271": {
            "startTime": 3532.315,
            "endTime": 3542.132,
            "sug": [
                [
                    "Ar’ursulek tawa’i uquam tungiinun tawa ulutegluni,",
                    "The whaler kept toward the oil slick."
                ],
                [
                    "tawaken qaya[lu]ni,",
                    "Then he cried out,"
                ],
                [
                    "“Ika’iya!”",
                    "“Help!”"
                ]
            ],
            "fullEnglish": "The whaler kept toward the oil slick. Then he cried out, “Help!”"
        },
        "272": {
            "startTime": 3542.132,
            "endTime": 3548.834,
            "sug": [
                [
                    "Tan’uraraam tawa niilluku,",
                    "There it is! The boy heard it"
                ],
                [
                    "ar’uq suarngan",
                    "blowing behind"
                ],
                [
                    "angitmen takuyar[luni] ta[wa] tuqsiirluku.",
                    "and looked back."
                ]
            ],
            "fullEnglish": "There it is! The boy heard it blowing behind and looked back."
        },
        "273": {
            "startTime": 3548.834,
            "endTime": 3555.208,
            "sug": [
                [
                    "Ar’ursulem nepainani [piluku,]",
                    "The whaler said to him quietly,"
                ],
                [
                    "“Angitmen takuyarkunaku,",
                    "“Don’t look back."
                ],
                [
                    "gui kiima uluteknga!”",
                    "Just watch me!”"
                ]
            ],
            "fullEnglish": "The whaler said to him quietly, “Don’t look back. Just watch me!”"
        },
        "274": {
            "startTime": 3555.208,
            "endTime": 3567.608,
            "numberTitle": 60,
            "sug": [
                [
                    "Tawaken qayaq patkaalluku",
                    "After paddling the kayak"
                ],
                [
                    "nani ar’um sua’aguianun",
                    "in the right position,"
                ],
                [
                    "patgutani lliiluku",
                    "he put his paddle or the rack,"
                ],
                [
                    "ayaquni tuuluku.",
                    "and picked up his spear."
                ]
            ],
            "fullEnglish": "After paddling the kayak in the right position, he put his paddle or the rack, stood up."
        },
        "275": {
            "startTime": 3567.608,
            "endTime": 3582.995,
            "sug": [
                [
                    "Ar’um tungiinun caulluku",
                    "He pointed it at (toward) the whale,"
                ],
                [
                    "aularnirluni mampalluglluni.",
                    "and began to mumble."
                ],
                [
                    "Tawa ayaqum caumacia uluteklluku",
                    "By watching where the spear was pointing,"
                ],
                [
                    "tan’urar[aam] nallugkunaku",
                    "the boy could tell"
                ],
                [
                    "cesten yaa’igta’i[‘a] ar’uq. (yaa’igta’i...lluta)",
                    "where the whale was."
                ]
            ],
            "fullEnglish": "He picking up the spear, pointed it at (toward) the whale, and began to mumble. By watching where the spear was pointing, the boy could tell where the whale was."
        },
        "276": {
            "startTime": 3582.995,
            "endTime": 3609.242,
            "sug": [
                [
                    "Tawa’i qayam canianun causngangan,",
                    "It was pointing in the watch almost beside him"
                ],
                [
                    "tawa canikaaraanun imaq tamaakerllainaq qangyugt’stun qa’arluni,",
                    "when he saw the water swell up and break like surf right next to him"
                ],
                [
                    "tawaken cali ar’um anersaucia kallit’stun mengqurlluni, taaten alingnarluni nepa.",
                    "and there was shattering noise as the whale blew the air out."
                ]
            ],
            "fullEnglish": "It was pointing in the watch almost beside him when he saw the water swell up and break like surf right next to him and there was shattering noise as the whale blew the air out."
        },
        "277": {
            "startTime": 3609.242,
            "endTime": 3622.676,
            "numberTitle": 61,
            "sug": [
                [
                    "Tawa nepum akuliini",
                    "Through all the noise"
                ],
                [
                    "tan’uraraam niilluku",
                    "the boy heard"
                ],
                [
                    "ar’ursulek qayaluni,",
                    "the whaler yell,"
                ],
                [
                    "“Angli!”",
                    "“Hard!”"
                ],
                [
                    "Tawa pitacimitun awa pategluni tan’uraq.",
                    "He paddled as hard as he could."
                ]
            ],
            "fullEnglish": "Through all the noise the boy heard the whaler yell, “Hard!” He paddled as hard as he could."
        },
        "278": {
            "startTime": 3622.676,
            "endTime": 3629.931,
            "sug": [
                [
                    "Ar’uq taaten yaagiapakarluni",
                    "The whale was so close now"
                ],
                [
                    "patgutaminek agturnayar[luku].",
                    "he could touch it with his paddle."
                ]
            ],
            "fullEnglish": "The whale was so close now he could touch it with his paddle."
        },
        "279": {
            "startTime": 3629.931,
            "endTime": 3646.294,
            "sug": [
                [
                    "Ar’ursulek nangarlluni",
                    "The whaler stood up"
                ],
                [
                    "tawa tan’urarmen lliicaaqaalluni",
                    "and, after motioning to the boy"
                ],
                [
                    "angli ilutuluku patgutani imarmen iterceqlluku,",
                    "to dip his paddle deep to steady the kayak,"
                ],
                [
                    "tawaken pitacimitun",
                    "struck with all his might,"
                ],
                [
                    "ayaquq ar’um caniqaanun tawa kapulluku.",
                    "sinking the spearpoint deep into the whale."
                ]
            ],
            "fullEnglish": "The whaler stood up and, after motioning to the boy to dip his paddle deep to steady the kayak, struck with all his might, sinking the spearpoint deep into the whale."
        },
        "280": {
            "startTime": 3646.294,
            "endTime": 3651.098,
            "sug": [
                [
                    "Awa canitmen cingq’rhnguaqaalluku",
                    "Then he pushed the shaft hard to the side"
                ],
                [
                    "angitmen cayugluku.",
                    "and jerked it loose."
                ]
            ],
            "fullEnglish": "Then he pushed the shaft hard to the side and jerked it loose."
        },
        "281": {
            "startTime": 3651.098,
            "endTime": 3668.608,
            "sug": [
                [
                    "Ar’um",
                    "The whale,"
                ],
                [
                    "tawa’i ayaquq ellpeklluku",
                    "feeling the spear"
                ],
                [
                    "awa’i caniqamini,",
                    "in its side,"
                ],
                [
                    "pamyuni pam’ut’sinaq eglluku,",
                    "threw its fluke high in the air,"
                ],
                [
                    "piqrulluku,",
                    "[?],"
                ],
                [
                    "ima angllurluni tam[...]",
                    "and went down in a steep dive."
                ]
            ],
            "fullEnglish": "The whale, feeling the spear in its side, threw its fluke high in the air and went down in a steep dive."
        },
        "282": {
            "startTime": 3668.608,
            "endTime": 3680.578,
            "numberTitle": 62,
            "sug": [
                [
                    "Tawaken ar’ursulek nangarngaluni",
                    "The whaler was still standing,"
                ],
                [
                    "cali p’tenglluku ayaqum cingia puunganek.",
                    "untying the spearpoint from the shaft."
                ]
            ],
            "fullEnglish": "The whaler was still standing, untying the spearpoint from the shaft."
        },
        "283": {
            "startTime": 3680.578,
            "endTime": 3693.388,
            "sug": [
                [
                    "Tan’uraraam tang’rhniqlluku,",
                    "The boy [?],"
                ],
                [
                    "tawa umialinguarluni",
                    "believing"
                ],
                [
                    "all’ilumek ayaumek ar’uq tuqutaaryuklluku",
                    "that the whale was killed with one thrust of the spear,"
                ],
                [
                    "ar’ursu[lek pimaa,]",
                    "said,"
                ]
            ],
            "fullEnglish": "The boy, believing that the whale was killed with one thrust of the spear, said,"
        },
        "284": {
            "startTime": 3693.388,
            "endTime": 3701.485,
            "sug": [
                [
                    "“Ana’i’arpek!”",
                    "“We lost it.”"
                ],
                [
                    "Ar’ursulek englaryugluni pikaa[lluku,]",
                    "The whaler grinned,"
                ],
                [
                    "“Qang'a,",
                    "“No,"
                ],
                [
                    "una taman’itarpek,",
                    "we did not lose it."
                ],
                [
                    "um pitaqciqaa.”",
                    "This one will get it.”"
                ]
            ],
            "fullEnglish": "“We lost it.” The whaler grinned, “No, we did not lose it. This one will get it.”"
        },
        "285": {
            "startTime": 3701.485,
            "endTime": 3712.041,
            "sug": [
                [
                    "Tamaani tawa tan’uraraam tangraa",
                    "The boy noticed then"
                ],
                [
                    "ayaqum cingian iqua,",
                    "that the tip of the spearpoint"
                ],
                [
                    "qup’arngangia’a[rluni]",
                    "was broken off"
                ],
                [
                    "natgun st’r’umallria.",
                    "at the groove."
                ]
            ],
            "fullEnglish": "The boy noticed then that the tip of the spearpoint was broken off at the groove."
        },
        "286": {
            "startTime": 3712.041,
            "endTime": 3720.401,
            "sug": [
                [
                    "Tawa’ut taug’um tang’rt’staarluku elwillra ar’ursulgem.",
                    "The whaler was pointing where it had been."
                ]
            ],
            "fullEnglish": "The whaler was pointing where it had been."
        },
        "287": {
            "startTime": 3720.401,
            "endTime": 3732.107,
            "sug": [
                [
                    "Tawa petengcamiu[?] ayaqum cingia,",
                    "When he got the point untied,"
                ],
                [
                    "misuuguaminun tawa’ut lliiluku,",
                    "he put it in the pouch,"
                ],
                [
                    "angitmen ciqlluam tungiinun aiwilutek.",
                    "and the headed back to the hut."
                ]
            ],
            "fullEnglish": "When he got the point untied, he put it in the pouch, and the headed back to the hut."
        },
        "288": {
            "startTime": 3732.107,
            "endTime": 3741.02,
            "numberTitle": 63,
            "sug": [
                [
                    "Qayaq ciqlluam / pianun tawa tagut’kaacam[egtegnegu]",
                    "After they carried the kayak by the hut"
                ],
                [
                    "ar’ursule[m] niu’ulluku tan’uraq,",
                    "the whaler told the boy,"
                ]
            ],
            "fullEnglish": "After they carried the kayak by the hut the whaler said that he would stay outside for a while."
        },
        "289": {
            "startTime": 3741.02,
            "endTime": 3750.739,
            "sug": [
                [
                    "“Maani cali et’raarciqukuk",
                    "\"We will stay here"
                ],
                [
                    "qaugcin[ek] ernernek.” [ New Tape]",
                    "for several days.\""
                ],
                [
                    "Itresq’lluku qama’ut",
                    "He told the boy to go in the hut"
                ],
                [
                    "kenliyaturluku.",
                    "and get the fire going and not to go out."
                ]
            ],
            "fullEnglish": "He told the boy to go in the hut and get the fire going and not to go out."
        },
        "290": {
            "startTime": 3750.739,
            "endTime": 3770.237,
            "sug": [
                [
                    "Tawaken caqneruangcu[gkun] weg’et akuliitgun",
                    "Through the hole in the straw"
                ],
                [
                    "t’riklluku cai tang’rniqlluku,",
                    "he peeked out"
                ],
                [
                    "ar’ursulek tagngan aprut’kun, (misuunguaq petam[?]--)",
                    "and saw the whaler going up the path"
                ],
                [
                    "misuuguaq cali ayaquq tagulluk[ek].",
                    "carrying the spear and the pouch."
                ]
            ],
            "fullEnglish": "Through the hole in the straw he peeked out and saw the whaler going up the path carrying the spear and the pouch."
        },
        "291": {
            "startTime": 3770.237,
            "endTime": 3778.604,
            "numberTitle": 64,
            "sug": [
                [
                    "Keneq kenerkiqaalluku",
                    "He threw wood on the coals"
                ],
                [
                    "q’cengluni cali elliin",
                    "and ran up"
                ],
                [
                    "qaiqunam tungiinun.",
                    "to the cave."
                ]
            ],
            "fullEnglish": "He threw wood on the coals and ran up to the cave."
        },
        "292": {
            "startTime": 3778.604,
            "endTime": 3789.643,
            "sug": [
                [
                    "Tawa’ut tuc’ami",
                    "When he got there"
                ],
                [
                    "ar’ursulek tang’rluku,",
                    "he saw the whaler,"
                ],
                [
                    "suu’um taugna suqallra anlluku",
                    "he was just getting the stomach out"
                ],
                [
                    "misuuguamek,",
                    "of the pouch."
                ],
                [
                    "awa’i imainani.",
                    "It was empty."
                ]
            ],
            "fullEnglish": "When he got there the whaler was just getting the stomach out of the pouch. It was empty."
        },
        "293": {
            "startTime": 3789.643,
            "endTime": 3795.707,
            "sug": [
                [
                    "Qaiqunamen itrut’kaalluku",
                    "He took it in the cave"
                ],
                [
                    "tawa’i nunamen qungurluku.",
                    "and buried it in the sand."
                ]
            ],
            "fullEnglish": "He took it in the cave and buried it in the sand."
        },
        "294": {
            "startTime": 3795.707,
            "endTime": 3812.739,
            "sug": [
                [
                    "Taug’um ayaqum cingia",
                    "Then he got the spearpoint"
                ],
                [
                    "cali anlluku misuuguamek,",
                    "out of the pouch"
                ],
                [
                    "tawa’ut allakat akuliitnun lliiluku,",
                    "and put it on the ledge"
                ],
                [
                    "nani cali ayaqut (.) cingiit iquit (kep’ar--) qup’arnga[luteng].",
                    "with the other points that had their points broken off."
                ]
            ],
            "fullEnglish": "Then he got the spearpoint out of the pouch and put it on the ledge with the other points that had their points broken off."
        },
        "295": {
            "startTime": 3812.739,
            "endTime": 3826.474,
            "sug": [
                [
                    "Tawa ayaqum puunga qaiqunamen itrut’kaalluku",
                    "After taking the shaft in the cave"
                ],
                [
                    "naparlluku allakat-llu,",
                    "and stood it up with the others,"
                ],
                [
                    "tawa’i esguarluni angitmen ciqlluamen.",
                    "he came out and went back down the trail."
                ]
            ],
            "fullEnglish": "After taking the shaft in the cave he came out and went back down the trail."
        },
        "296": {
            "startTime": 3826.474,
            "endTime": 3834.57,
            "numberTitle": 65,
            "sug": [
                [
                    "Cali tan’uraq awa’i keneq kuagkualua[rluku]",
                    "The boy had the fire going good"
                ],
                [
                    "aqumgaa’arluni",
                    "and sitting down"
                ],
                [
                    "ar’ursulek iterngan.",
                    "when the whaler came in the hut."
                ]
            ],
            "fullEnglish": "The boy had the fire going good when the whaler came in the hut."
        },
        "297": {
            "startTime": 3834.57,
            "endTime": 3838.821,
            "sug": [
                [
                    "Cali atgurngaluni englaryugluni.",
                    "He was smiling now."
                ]
            ],
            "fullEnglish": "He was smiling now."
        },
        "298": {
            "startTime": 3838.821,
            "endTime": 3848.303,
            "sug": [
                [
                    "Taaten ilaniruanrani",
                    "While he was in a good mood,"
                ],
                [
                    "tan’ura’aq umialinguarluni",
                    "the boy thought"
                ],
                [
                    "apqauqutarluku caqinek: (apqau...qutarluku)",
                    "that he would ask him some questions."
                ]
            ],
            "fullEnglish": "The boy thought that he would ask him some questions while he was in a good mood."
        },
        "299": {
            "startTime": 3848.303,
            "endTime": 3864.204,
            "sug": [
                [
                    "Cesten ar’uq tuquciqa?",
                    "How will the whale die?"
                ],
                [
                    "Nat’en taugna suk taangart’lleq ar’umek,",
                    "What happened to the man that came out of the whale to get the water,"
                ],
                [
                    "nat’en agciqa",
                    "where will he go"
                ],
                [
                    "ar’uq tuqukan?",
                    "when the whale dies?"
                ]
            ],
            "fullEnglish": "He asked what made the shiny streak across the bay when they crossed the bay."
        },
        "300": {
            "startTime": 3864.204,
            "endTime": 3875.622,
            "sug": [
                [
                    "Qai-cali taugna uquaq kangi’am akianun cali (ar’um--) lliillertek",
                    "He asked what made the shiny streak across the bay when they crossed the bay."
                ],
                [
                    "ar’um aliklluku angiqaqlluni tekitaquniu?",
                    "Why that whale turned back every time it got close to it?"
                ]
            ],
            "fullEnglish": "Why that whale turned back every time it got close to it?"
        },
        "301": {
            "startTime": 3875.622,
            "endTime": 3885.685,
            "sug": [
                [
                    "Cesten cali taaten yaamangcu[gmek] mikelngu[rmek]",
                    "And how could a tiny piece of rock"
                ],
                [
                    "ar’uq tuquciiqau.",
                    "kill the whale."
                ]
            ],
            "fullEnglish": "And how could a tiny piece of rock kill the whale and what happened to the man that came out of the whale to get the water when the whale got killed."
        },
        "302": {
            "startTime": 3885.685,
            "endTime": 3898.851,
            "sug": [
                [
                    "Tawa ar’ursulek englarluni",
                    "The whaler just laughed"
                ],
                [
                    "kiuluku tawa’i,",
                    "and answered,"
                ],
                [
                    "“Ca!”",
                    "“Ca!”"
                ],
                [
                    "Awa’i nepairluni taug’um kingullran[i]",
                    "He got quiet after that"
                ],
                [
                    "kiuyugkunaku.",
                    "(Didn’t want to give an answer.)"
                ]
            ],
            "fullEnglish": "The whaler just laughed and answered, “Ca.” He didn’t know (Didn’t want to give an answer.)"
        },
        "303": {
            "startTime": 3898.851,
            "endTime": 3915.307,
            "numberTitle": 66,
            "sug": [
                [
                    "Tawa’i unuaquani",
                    "Next morning"
                ],
                [
                    "aglutek takuluku cali’a kangi’asinamen,",
                    "they went out of the lagoon to the bay."
                ],
                [
                    "nani ar’uq ayaquq[ii], cali tawani ell’uni,",
                    "The whale was still there,"
                ],
                [
                    "angitaqualuni uquarmek,",
                    "going back and forth from the oil slick"
                ],
                [
                    "kangi’am qitganun.",
                    "to the head of the bay."
                ]
            ],
            "fullEnglish": "Next morning they went out of the lagoon to the bay. The whale was still there, going back and forth from the oil slick to the head of the bay."
        },
        "304": {
            "startTime": 3915.307,
            "endTime": 3922.89,
            "numberTitle": 67,
            "sug": [
                [
                    "Qaugcin ernet kingullratni",
                    "After several days"
                ],
                [
                    "tawa’i tang’rluku tuknii’ulluni ar’uq.",
                    "the whale appeared to be getting weak."
                ]
            ],
            "fullEnglish": "After several days the whale appeared to be getting weak."
        },
        "305": {
            "startTime": 3922.89,
            "endTime": 3933.868,
            "sug": [
                [
                    "Angitaquan’irluni",
                    "Instead of going back and forth,"
                ],
                [
                    "awa’i pugtaqainarluni qaimi, imaam qaingani.",
                    "it was floating on the surface most of the time, going around in circles."
                ]
            ],
            "fullEnglish": "Instead of going back and forth, it was floating on the surface most of the time, going around in circles."
        },
        "306": {
            "startTime": 3933.868,
            "endTime": 3938.838,
            "numberTitle": 68,
            "sug": [
                [
                    "Tawa’i all’ilumek unuaka’armi",
                    "Then one morning"
                ],
                [
                    "anngamek tang’rluku awa piinani.",
                    "it was nowhere in sight."
                ]
            ],
            "fullEnglish": "Then one morning it was nowhere in sight."
        },
        "307": {
            "startTime": 3938.838,
            "endTime": 3951.53,
            "sug": [
                [
                    "Ar’ursulek tamiini kiart’kaalluni [...],",
                    "After looking around, the whaler smiled and mumbled,"
                ],
                [
                    "“Mm-m.”",
                    "“Um um!”"
                ],
                [
                    "Angitmen angillutek qayakun tawa’i.",
                    "and headed the kayak back into the lagoon."
                ]
            ],
            "fullEnglish": "After looking around, the whaler smiled and mumbled, “Um um!” and headed the kayak back into the lagoon. They got their sealskin beds from the hut and went back out of the lagoon."
        },
        "308": {
            "startTime": 3951.53,
            "endTime": 3966.642,
            "sug": [
                [
                    "Tawaken",
                    "At the entrance"
                ],
                [
                    "kangi’am qitganun (qayani) qayaq caut’kaalluku",
                    "the whaler turned the kayak toward the head of the bay"
                ],
                [
                    "tan’uraq piluku,",
                    "and told the boy,"
                ],
                [
                    "“Kangi’am qitganun causngakiu qayaq.”",
                    "\"Keep the kayak headed toward the head of the bay.\""
                ]
            ],
            "fullEnglish": "At the entrance the whaler turned the kayak toward the head of the bay and told the boy to stop paddling and keep the kayak headed the way it was."
        },
        "309": {
            "startTime": 3966.642,
            "endTime": 3969.939,
            "sug": [
                [
                    "Tawaken aularnirluni mampalluglluni.",
                    "Then he began mumbling."
                ]
            ],
            "fullEnglish": "Then he began mumbling."
        },
        "310": {
            "startTime": 3969.939,
            "endTime": 3976.371,
            "sug": [
                [
                    "Mulgkunani aqlla’aq",
                    "Soon a light breeze"
                ],
                [
                    "qamaken kangi’am qitganek aularnirluni cuplluni.",
                    "began to blow from the bay."
                ]
            ],
            "fullEnglish": "Soon a light breeze began to blow from the bay."
        },
        "311": {
            "startTime": 3976.371,
            "endTime": 4003.217,
            "sug": [
                [
                    "Awa t’kicatek",
                    "When the breeze reached them"
                ],
                [
                    "aulairluni (mam--) [Laughs, Stops Tape]",
                    "he stopped mumbling"
                ],
                [
                    "apallurt’nirluni (sounds like qapallurt’nirluni) qayaq ang’sqam kangi’am painganun caulluku,",
                    "and turned the kayak around and started out of the bay"
                ],
                [
                    "aqllaq maliglluku.",
                    "with the breeze."
                ]
            ],
            "fullEnglish": "When the breeze reached them he stopped mumbling and turned the kayak around and started out of the bay with the breeze."
        },
        "312": {
            "startTime": 4003.217,
            "endTime": 4015.445,
            "numberTitle": 69,
            "sug": [
                [
                    "Kang’iam paingani",
                    "At the mouth of the bay,"
                ],
                [
                    "tan’urar[aam] awa tangerluku",
                    "the boy noticed"
                ],
                [
                    "uquaq, awa qup’arqumaluni,",
                    "that the oil slick was now broken up"
                ],
                [
                    "kangi’armek taaten at’rlluku awa una’ut.",
                    "by the breeze and was drifting out (of the bay) in patches."
                ]
            ],
            "fullEnglish": "At the mouth of the bay, the boy noticed that the oil slick was now broken up by the breeze and was drifting out (of the bay) in patches."
        },
        "313": {
            "startTime": 4015.445,
            "endTime": 4027.306,
            "sug": [
                [
                    "Tawaken caullutek",
                    "They paddled on with the breeze"
                ],
                [
                    "nunat tungiitnun.",
                    "towards land"
                ],
                [
                    "Macaq kal’utiini",
                    "and at sundown,"
                ],
                [
                    "tull’utek.",
                    "they were back at the village."
                ]
            ],
            "fullEnglish": "They paddled on with the breeze and were back at the village at sundown."
        },
        "314": {
            "startTime": 4027.306,
            "endTime": 4040.677,
            "numberTitle": 70,
            "sug": [
                [
                    "Nunami",
                    "(At the village the boy stayed)"
                ],
                [
                    "tawa ar’ursulem tan’uraq piluku,",
                    "The whaler told the boy"
                ],
                [
                    "allakaat tan’uraraat ila’asq’gkunaki,",
                    "that he was not to mingle with the other boys in the village"
                ],
                [
                    "kii’an etaa’asq’[lluku].",
                    "and to stay with him in his hut."
                ]
            ],
            "fullEnglish": "(At the village the boy stayed) The whaler told the boy that he was to stay with him in his hut and not to mingle with the other boys in the village."
        },
        "315": {
            "startTime": 4040.677,
            "endTime": 4056.739,
            "sug": [
                [
                    "All’iluq unuk",
                    "One night"
                ],
                [
                    "tawa’i tan’uraq unugmi esgartuq,",
                    "he woke up"
                ],
                [
                    "niilluku",
                    "when he heard"
                ],
                [
                    "ar’ursulek qalriurluni",
                    "the whaler screaming"
                ],
                [
                    "suunia’aluni",
                    "and moaning"
                ],
                [
                    "cesten tuquneq pillria segertaarngani.",
                    "just like the corpse did when he was cutting its insides out."
                ]
            ],
            "fullEnglish": "One night he woke up when he heard the whaler screaming and moaning just like the corpse did when he was cutting its insides out."
        },
        "316": {
            "startTime": 4056.739,
            "endTime": 4061.826,
            "sug": [
                [
                    "Awa tang’rluku uqamai’a’uq.",
                    "He was having a nightmare."
                ]
            ],
            "fullEnglish": "He was having a nightmare."
        },
        "317": {
            "startTime": 4061.826,
            "endTime": 4074.58,
            "sug": [
                [
                    "Tawa’i ar’ursulem patuni eglluki",
                    "He threw the straw mat he used for a cover"
                ],
                [
                    "mak’arlluni,",
                    "and sat up"
                ],
                [
                    "tan’uraq qaya’anit’rar[luku]",
                    "and almost shouted at the boy,"
                ],
                [
                    "“Naama?! Naama?!”",
                    "“Where is he? Where is he?”"
                ]
            ],
            "fullEnglish": "He threw the straw mat he used for a cover and sat up and almost shouted at the boy, “Where is he? Where is he?”"
        },
        "318": {
            "startTime": 4074.58,
            "endTime": 4085.762,
            "sug": [
                [
                    "Tawa’i kianit akinratgun",
                    "In the glow of the coals"
                ],
                [
                    "tan’uraraam giinaa tang’rluku cesten alinguma’a.",
                    "the boy could see the look of fright in his face."
                ]
            ],
            "fullEnglish": "In the glow of the coals the boy could see the look of fright in his face."
        },
        "319": {
            "startTime": 4085.762,
            "endTime": 4089.899,
            "sug": [
                [
                    "Tawa aptaa,",
                    "He asked him,"
                ],
                [
                    "“Naama kina?”",
                    "“Where is who?”"
                ]
            ],
            "fullEnglish": "“Where is who?” he asked him."
        },
        "320": {
            "startTime": 4089.899,
            "endTime": 4098.276,
            "sug": [
                [
                    "Ar’ursulem piluku,",
                    "The whaler said to him,"
                ],
                [
                    "“Una suk",
                    "“The person"
                ],
                [
                    "ar’um qanranek anlleq",
                    "that came out of the whale’s mouth"
                ],
                [
                    "taangarcaturluni.",
                    "to get water."
                ]
            ],
            "fullEnglish": "The whaler looked around him and whispered, “The person that came out of the whale’s mouth to get water."
        },
        "321": {
            "startTime": 4098.276,
            "endTime": 4107.559,
            "sug": [
                [
                    "“Tawa’i ayaquminek tawa gaatemkun kapuqiinga.",
                    "“There he drove a spear straight through my chest."
                ]
            ],
            "fullEnglish": "“There he drove a spear straight through his chest."
        },
        "322": {
            "startTime": 4107.559,
            "endTime": 4112.236,
            "sug": [
                [
                    "Tawaten-gua qalriurtua.”",
                    "Like that I kept crying out.”"
                ]
            ],
            "fullEnglish": "Like that I kept crying out.”"
        },
        "323": {
            "startTime": 4112.236,
            "endTime": 4121.052,
            "numberTitle": 71,
            "sug": [
                [
                    "Awa unuami,",
                    "So in the morning,"
                ],
                [
                    "tan’uraq unani qutmi aqumraa’arluni.",
                    "the boy was just sitting on this beach."
                ]
            ],
            "fullEnglish": "So in the morning, the boy was just sitting on this beach."
        },
        "324": {
            "startTime": 4121.052,
            "endTime": 4132.3,
            "sug": [
                [
                    "Tan’uraraat tang’rhniqlluki",
                    "He saw the boys"
                ],
                [
                    "kangitgun lluu’anguarluteng,",
                    "surfing on the waves,"
                ],
                [
                    "kuimarua[rluteng]",
                    "swimming"
                ],
                [
                    "qutmi wamluteng,",
                    "and playing  around at the beach,"
                ],
                [
                    "aya’iluki.",
                    "and he wanted to joined them."
                ]
            ],
            "fullEnglish": "He saw the boys surfing on the waves, playing and swimming around at the beach, and he wanted to joined them."
        },
        "325": {
            "startTime": 4132.3,
            "endTime": 4141.221,
            "sug": [
                [
                    "Tawa umialingua’umuuq",
                    "He tried to stop thinking"
                ],
                [
                    "angitmen",
                    "about going back there"
                ],
                [
                    "tawa’ut kangi’armen elwillermegtenun angicugkunani.",
                    "to the bay to the place he didn’t want to return to."
                ]
            ],
            "fullEnglish": "He tried to stop thinking about going back there to the bay to the place he didn’t want to return to."
        },
        "326": {
            "startTime": 4141.221,
            "endTime": 4152.737,
            "sug": [
                [
                    "Umialinguarluni",
                    "He thought"
                ],
                [
                    "uumi tuqunermek qunguwigmek",
                    "of that dead body from the graveyard"
                ],
                [
                    "angcikan",
                    "and how if he went back there"
                ],
                [
                    "englanasiik’gkutarluku.",
                    "that he (the whaler) was going to make fun of him."
                ]
            ],
            "fullEnglish": "He thought of that dead body from the graveyard and how if he went back there that he (the whaler) was going to make fun of him."
        },
        "327": {
            "startTime": 4152.737,
            "endTime": 4163.189,
            "sug": [
                [
                    "Mulugkunani taug’um kingullrani",
                    "He didn’t stay long after at that one spot,"
                ],
                [
                    "yaat’rami nunangcugmi tuquiluteng",
                    "as he felt bad that they had killed someone"
                ],
                [
                    "qungurluku.",
                    "and then buried him."
                ]
            ],
            "fullEnglish": "He didn’t stay long after at that one spot, as he felt bad that they had killed someone and then buried him."
        },
        "328": {
            "startTime": 4163.189,
            "endTime": 4179.004,
            "sug": [
                [
                    "Tamaana akgua’aq aglutek,",
                    "Yesterday we went up there"
                ],
                [
                    "tagkutarngami qungut tungiitnun ar’ursulem.",
                    "to the grave, behind where the whaler was going to raise it up."
                ],
                [
                    "Tan’uraq piluku,",
                    "He told the boy,"
                ],
                [
                    "“Ellpet qayam utaqakia,",
                    "“Your kayak is waiting for you,"
                ],
                [
                    "muluningaitua gui pamani.”",
                    "but I won’t be long up there.”"
                ]
            ],
            "fullEnglish": "Yesterday we went up there to the grave, behind where the whaler was going to raise it up. He told the boy, “Your kayak is waiting for you, but I won’t be long up there.”"
        },
        "329": {
            "startTime": 4179.004,
            "endTime": 4192.403,
            "sug": [
                [
                    "Tan’uraq nallugkunani",
                    "The boy knew"
                ],
                [
                    "qungunun tag’uq ar’ursulek,",
                    "where the whaler went to the grave,"
                ],
                [
                    "tuquneq ancaturluku.",
                    "to take out the corpse."
                ]
            ],
            "fullEnglish": "The boy knew where the whaler went to the grave, to take out the corpse."
        },
        "330": {
            "startTime": 4192.403,
            "endTime": 4205.668,
            "numberTitle": 72,
            "sug": [
                [
                    "Kinguakun tawa maliglluku",
                    "After that he followed him,"
                ],
                [
                    "nallunaruarluni",
                    "covertly"
                ],
                [
                    "qupuramek qutmek tuulluni,",
                    "he took some wood from the beach"
                ],
                [
                    "yaamarmek cali.",
                    "and some rock too."
                ]
            ],
            "fullEnglish": "After that he followed him, he took some wood covertly from the beach and some rock too."
        },
        "331": {
            "startTime": 4205.668,
            "endTime": 4221.599,
            "sug": [
                [
                    "Tawa’i awa t’killuni,",
                    "And then he arrived,"
                ],
                [
                    "awa’i ar’ursulek (agnguarluni) lliilerluni",
                    "as the whaler motioned"
                ],
                [
                    "tawani nani qunguqiit taugna tuqulleq.",
                    "for the corpse among the graves there where they had buried the corpse."
                ]
            ],
            "fullEnglish": "And then he arrived, as the whaler motioned for the corpse among the graves there where they had buried the corpse."
        },
        "332": {
            "startTime": 4226.552,
            "endTime": 4241.264,
            "numberTitle": 73,
            "sug": [
                [
                    "Tawaken awa qunguq qulwarluni qus’i’iluni",
                    "From down there the grave rises up above"
                ],
                [
                    "ar’ursulek taugna awa’i agnguarluni lliilerluni tawa’i.",
                    "as the whaler dances and motions there."
                ]
            ],
            "fullEnglish": "From down there the grave rises up above as the whaler dances and motions there."
        },
        "333": {
            "startTime": 4241.264,
            "endTime": 4256.4,
            "sug": [
                [
                    "Tunucan",
                    "As he turns around"
                ],
                [
                    "taugna yaamaq tuuqainarluku pequagun milurluku",
                    "he throws a rock from behind his back that he’d been holding to hit it,"
                ],
                [
                    "tupagpakarluni ar’ursulek",
                    "then the whaler hopped"
                ],
                [
                    "qetgerluni tawa, cesten caumallria.",
                    "and was really surprised when it made the noise."
                ]
            ],
            "fullEnglish": "As he turns around he throws a rock from behind his back that he’d been holding to hit it, then the whaler hopped and was really surprised when it made the noise."
        },
        "334": {
            "startTime": 4256.4,
            "endTime": 4262.77,
            "sug": [
                [
                    "Nat’en caumallria napanguamen puukaryarat.",
                    "He ran to the young spruce to where something made a noise."
                ],
                [
                    "Napanguaq peglluku taugna.",
                    "He let go of that sprucling."
                ]
            ],
            "fullEnglish": "He ran to the young spruce to where something made a noise. He let go of that sprucling."
        },
        "335": {
            "startTime": 4262.77,
            "endTime": 4271.714,
            "sug": [
                [
                    "Napanguaq angitmen [sagngami?]",
                    "Returning to the spruceling..."
                ],
                [
                    "ar’ursulinek p’tgerlluku tunutmen,",
                    "the whaler leapt backwards"
                ],
                [
                    "nuupia’an tull’uku.",
                    "and stepped on where he was hiding."
                ]
            ],
            "fullEnglish": "Returning to the spruceling... the whaler leapt backwards and stepped on where he was hiding."
        },
        "336": {
            "startTime": 4271.714,
            "endTime": 4279.436,
            "sug": [
                [
                    "Tan’uraq tunut’qainarlluni",
                    "Turning around,"
                ],
                [
                    "q’cengluni qayam tungiinun aularnir[luni].",
                    "the boy ran back to go get the kayak."
                ]
            ],
            "fullEnglish": "Turning around, the boy ran back to go get the kayak."
        },
        "337": {
            "startTime": 4279.436,
            "endTime": 4290.765,
            "sug": [
                [
                    "Taaten cukaluni ruu’art’stun pita[lu]ni q’ceng’engarmi",
                    "Fast like an arrow he ran"
                ],
                [
                    "ar’ursulgem tunuanek anguluku,",
                    "as the whaler was catching up behind him,"
                ],
                [
                    "kiturluku una’ut ima",
                    "passing along as he headed down there, and wondering"
                ]
            ],
            "fullEnglish": "Fast like an arrow he ran as the whaler was catching up behind him, passing along as he headed down there, and wondering"
        },
        "338": {
            "startTime": 4290.765,
            "endTime": 4294.814,
            "sug": [
                [
                    "tarpiaq tamarluni",
                    "how he had he lost him"
                ],
                [
                    "qayam tungiinun.",
                    "behind the kayak."
                ]
            ],
            "fullEnglish": "how he had he lost him behind the kayak."
        },
        "339": {
            "startTime": 4294.814,
            "endTime": 4302.847,
            "sug": [
                [
                    "Tan’uraq qutmen una’ut tuc’ami qayaq nani elgnuq esgwarluni,",
                    "The boy headed down to the beach where the kayak had been,"
                ],
                [
                    "qayaq piinani.",
                    "but the kayak wasn’t there."
                ]
            ],
            "fullEnglish": "The boy headed down to the beach where the kayak had been, but the kayak wasn’t there."
        },
        "340": {
            "startTime": 4302.847,
            "endTime": 4310.18,
            "sug": [
                [
                    "Tawaken umyaali[nguarluni],",
                    "Then he wondered"
                ],
                [
                    "nat’en-mi ima una ar’ursulek agumaa?",
                    "where the whaler could have gone to?"
                ],
                [
                    "Taaten nitniqlluku.",
                    "He had paid such close attention."
                ]
            ],
            "fullEnglish": "Then he wondered where the whaler could have gone to? He had paid such close attention."
        },
        "341": {
            "startTime": 4310.18,
            "endTime": 4323.535,
            "sug": [
                [
                    "Kiarlluni,",
                    "He looked around,"
                ],
                [
                    "caqimek tang’rkunani,",
                    "he didn’t see anything,"
                ],
                [
                    "caqimek niit’gkunani cali.",
                    "and he didn’t hear anything."
                ],
                [
                    "Tawaken mululuni utaqakaalluni",
                    "And so he waited for a long time"
                ],
                [
                    "angitmen nunaminun angilluni.",
                    "before he turned to go back to the village."
                ]
            ],
            "fullEnglish": "He looked around, he didn’t see anything, and he didn’t hear anything. And so he waited for a long time before he turned to go back to the village."
        },
        "342": {
            "startTime": 4323.535,
            "endTime": 4337.951,
            "numberTitle": 74,
            "sug": [
                [
                    "Tawaken taug’um kingullrani,",
                    "From then on,"
                ],
                [
                    "ernerpamen pitaluku,",
                    "to this day,"
                ],
                [
                    "nallugaat",
                    "he doesn’t know"
                ],
                [
                    "natmen qimallria taugna ar’ursulek.",
                    "where that whaler ran away to."
                ]
            ],
            "fullEnglish": "From then on, he didn’t know what happened, to this day he doesn’t know where that whaler ran away to."
        },
        "343": {
            "startTime": 4337.951,
            "endTime": 4340.986,
            "sug": [
                [
                    "Awa’i piituq",
                    "He is gone"
                ],
                [
                    "nutaan.",
                    "now."
                ]
            ],
            "fullEnglish": "Now, he is gone."
        },
        "344": {
            "startTime": 4340.986,
            "endTime": 4344.78,
            "sug": [
                [
                    "Awa’i,",
                    "Enough,"
                ],
                [
                    "nang’uq quli’anguaqa.",
                    "my story is finished (used up)."
                ]
            ],
            "fullEnglish": "Enough, my story is finished (used up)."
        }
    },
    "2": {
        "1": {
            "startTime": 2.189,
            "endTime": 11.037,
            "sug": [
                [
                    "They used to talk about telling stories, you know, [for a] pastime.",
                    "They used to talk about telling stories, you know, [for a] pastime."
                ]
            ],
            "fullEnglish": "They used to talk about telling stories, you know, [for a] pastime."
        },
        "2": {
            "startTime": 11.037,
            "endTime": 15.494,
            "sug": [
                [
                    "Their pastime was telling stories.",
                    "Their pastime was telling stories."
                ]
            ],
            "fullEnglish": "Their pastime was telling stories."
        },
        "3": {
            "startTime": 15.494,
            "endTime": 22.324,
            "sug": [
                [
                    "Unigkua’at,",
                    "Legends,"
                ],
                [
                    "they called them, fairytales.",
                    "they call them, fairytales."
                ]
            ],
            "fullEnglish": "Legends, they call them, fairytales."
        },
        "4": {
            "startTime": 22.324,
            "endTime": 29.912,
            "sug": [
                [
                    "Ayaa,",
                    "On my,"
                ],
                [
                    "cali ukuk gwani quliyanguiskegka:",
                    "and then here is a story about these two that I was told:"
                ],
                [
                    "Macaq pettam Iraluq.",
                    "the Sun and the Moon."
                ]
            ],
            "fullEnglish": "On my, and then here is a story about these two that I was told: the Sun and the Moon."
        },
        "5": {
            "startTime": 42.017,
            "endTime": 46.138,
            "sug": [
                [
                    "Macaq,",
                    "This sun"
                ],
                [
                    "una gua’i arnaq.",
                    "here is a woman."
                ]
            ],
            "fullEnglish": "This sun here is a woman."
        },
        "6": {
            "startTime": 46.138,
            "endTime": 57.443,
            "sug": [
                [
                    "Arnaun’itaaqiit Macaq",
                    "They say the sun is a woman"
                ],
                [
                    "uqnarsaqlluku (laughter).",
                    "because it is hot."
                ]
            ],
            "fullEnglish": "They say the sun is a woman because it is hot."
        },
        "7": {
            "startTime": 57.443,
            "endTime": 63.338,
            "sug": [
                [
                    "Una Iraluq",
                    "This Moon"
                ],
                [
                    "nukallpiaq.",
                    "is a man."
                ]
            ],
            "fullEnglish": "This Moon is a man."
        },
        "8": {
            "startTime": 63.338,
            "endTime": 80.854,
            "sug": [
                [
                    "Kesiin",
                    "Except"
                ],
                [
                    "una Macaq...",
                    "this Sun..."
                ],
                [
                    "cestun Alutiit'stun...",
                    "how is it in Alutiiq..."
                ],
                [
                    "sister-ra.",
                    "is his sister."
                ],
                [
                    "Una Iraluq brother-ra.",
                    "This Moon is her brother."
                ]
            ],
            "fullEnglish": "Except this Sun... how is it in Alutiiq... is his sister. This Moon is her brother."
        },
        "9": {
            "startTime": 80.854,
            "endTime": 90.42,
            "sug": [
                [
                    "Brother and sister. Yeah, sister and brother.",
                    "Brother and sister. Yeah, sister and brother."
                ]
            ],
            "fullEnglish": "Brother and sister. Yeah, sister and brother."
        },
        "10": {
            "startTime": 91.356,
            "endTime": 98.594,
            "sug": [
                [
                    "Macaq is the sister;",
                    "The Sun is the sister;"
                ],
                [
                    "Iraluq is the brother.",
                    "the Moon is the brother."
                ]
            ],
            "fullEnglish": "The Sun is the sister; the Moon is the brother."
        },
        "11": {
            "startTime": 98.594,
            "endTime": 106.403,
            "sug": [
                [
                    "Una arya’aq",
                    "This girl"
                ],
                [
                    "cuumi elliin―",
                    "in the past―"
                ]
            ],
            "fullEnglish": "This girl in the past―"
        },
        "12": {
            "startTime": 106.403,
            "endTime": 114.468,
            "sug": [
                [
                    "suu’ut cuumi suu’utamallriit",
                    "the people before the way they used to live"
                ],
                [
                    "eprinateng.",
                    "they were very clean."
                ]
            ],
            "fullEnglish": "the people before the way they used to live they were very clean."
        },
        "13": {
            "startTime": 114.468,
            "endTime": 119.005,
            "sug": [
                [
                    "Una arya’aq",
                    "This girl"
                ],
                [
                    "aqumasau’uskan",
                    "when when she got her first menstruation (and was sitting in or sequestered)"
                ]
            ],
            "fullEnglish": "This girl when when she got her first menstruation (and was sitting in or sequestered)"
        },
        "14": {
            "startTime": 119.005,
            "endTime": 124.077,
            "sug": [
                [
                    "―I don’t know if you understand that, you know.",
                    "―I don’t know if you understand that, you know."
                ]
            ],
            "fullEnglish": "―I don’t know if you understand that, you know."
        },
        "15": {
            "startTime": 124.077,
            "endTime": 134.354,
            "sug": [
                [
                    "Patulluku",
                    "She would be sequestered"
                ],
                [
                    "arnauskan",
                    "when becoming a woman"
                ],
                [
                    "― you understand that ―",
                    "― you understand that ―"
                ],
                [
                    "patulluku petta.",
                    "like closed off."
                ]
            ],
            "fullEnglish": "When becoming a woman she would be sequestered ― you understand that ― like closed off."
        },
        "16": {
            "startTime": 134.354,
            "endTime": 141.057,
            "sug": [
                [
                    "Awa’i kiiyan et’slluku",
                    "And so she would be there alone"
                ],
                [
                    "epriyutnati.",
                    "until she was clean."
                ]
            ],
            "fullEnglish": "And so she would be there alone until she was clean."
        },
        "17": {
            "startTime": 141.057,
            "endTime": 144.815,
            "sug": [
                [
                    "Awa’i petta,",
                    "Now then,"
                ],
                [
                    "taugna arya’aq",
                    "that girl"
                ],
                [
                    "patulluku.",
                    "she was sequestered."
                ]
            ],
            "fullEnglish": "Now then, that girl she was sequestered."
        },
        "18": {
            "startTime": 144.815,
            "endTime": 152.497,
            "sug": [
                [
                    "Ciqllu’ami-naa et’aa’umaluteng.",
                    "They must have been in a sod house."
                ],
                [
                    "Ciqllu’ami allakaan",
                    "In the sod house by herself"
                ],
                [
                    "patulluku.",
                    "she was closed off."
                ]
            ],
            "fullEnglish": "They must have been in a sod house. In the sod house by herself she was closed off."
        },
        "19": {
            "startTime": 152.497,
            "endTime": 158.427,
            "sug": [
                [
                    "Ciqlluaq,",
                    "Sod house,"
                ],
                [
                    "barabara,",
                    "barabara,"
                ],
                [
                    "ciqlluaq.",
                    "sod house."
                ]
            ],
            "fullEnglish": "Sod house, barabara, sod house."
        },
        "20": {
            "startTime": 158.427,
            "endTime": 162.523,
            "sug": [
                [
                    "Patu'...",
                    "Closed off..."
                ],
                [
                    "kiiyan allakaan.",
                    "alone by herself."
                ]
            ],
            "fullEnglish": "Closed off... alone by herself."
        },
        "21": {
            "startTime": 162.523,
            "endTime": 164.874,
            "sug": [
                [
                    "Amlerluteng ciqllugait allrak.",
                    "I suppose there were lots of sod houses."
                ]
            ],
            "fullEnglish": "I suppose there were lots of sod houses."
        },
        "22": {
            "startTime": 164.874,
            "endTime": 173.165,
            "sug": [
                [
                    "Tawa’ut kiiyan patulluku",
                    "Alone she was shut off"
                ],
                [
                    "epriyutnati,",
                    "until she was clean,"
                ],
                [
                    "pettam neregkwarluku tawani,",
                    "and she could only eat there by herself,"
                ],
                [
                    "you know.",
                    "you know."
                ]
            ],
            "fullEnglish": "Alone she was shut off until she was clean, and she could only eat there by herself, you know."
        },
        "23": {
            "startTime": 173.165,
            "endTime": 176.252,
            "sug": [
                [
                    "Tawani",
                    "There"
                ],
                [
                    "maqirkuarluku.",
                    "she bathed."
                ]
            ],
            "fullEnglish": "There she bathed."
        },
        "24": {
            "startTime": 176.252,
            "endTime": 181.564,
            "sug": [
                [
                    "Kesiin aulirnatí",
                    "Only when she stopped (her cycle),"
                ],
                [
                    "anegkwarkunaku.",
                    "only then could she be let out."
                ]
            ],
            "fullEnglish": "Only when she stopped (her cycle), only then could she be let out."
        },
        "25": {
            "startTime": 181.564,
            "endTime": 185.195,
            "sug": [
                [
                    "Awa’i petta",
                    "And so"
                ],
                [
                    "una tan’uraq,",
                    "this boy,"
                ]
            ],
            "fullEnglish": "And so this boy,"
        },
        "26": {
            "startTime": 185.195,
            "endTime": 190.485,
            "sug": [
                [
                    "tan’urarem taugna sister-ni allrak tamarluku.",
                    "the boy maybe he had lost his sister."
                ]
            ],
            "fullEnglish": "the boy maybe he had lost his sister."
        },
        "27": {
            "startTime": 190.485,
            "endTime": 194.83,
            "sug": [
                [
                    "Niu’utegkunaku,",
                    "Nobody told him about her,"
                ],
                [
                    "cuumi ellin niu’utanillkait uswiillra’ateng.",
                    "because they didn’t tell children (those things)."
                ]
            ],
            "fullEnglish": "Nobody told him about her, because they didn’t tell children (those things)."
        },
        "28": {
            "startTime": 194.83,
            "endTime": 204.085,
            "sug": [
                [
                    "Tamarluku",
                    "He lost her"
                ],
                [
                    "niu’utegkunaku.",
                    "and he wasn’t told."
                ],
                [
                    "Kesiin,",
                    "Only,"
                ],
                [
                    "taugna tan’uraq nat-naama sister-ra (alqara).",
                    "that boy didn’t know where his sister was at."
                ]
            ],
            "fullEnglish": "He lost her and he wasn’t told. Only, that boy didn’t know where his sister was at."
        },
        "29": {
            "startTime": 204.085,
            "endTime": 211.767,
            "sug": [
                [
                    "Awa’i pettá kuingnermini allrak taugna tan’uraq,",
                    "And so perhaps that boy while he was walking,"
                ]
            ],
            "fullEnglish": "And so perhaps that boy while he was walking,"
        },
        "30": {
            "startTime": 213.621,
            "endTime": 221.39,
            "sug": [
                [
                    "taugna nallunriarlluku arya’aq",
                    "he found the girl"
                ],
                [
                    "tawani patusngauq.",
                    "who was closed off over there."
                ]
            ],
            "fullEnglish": "he found the girl who was closed off over there."
        },
        "31": {
            "startTime": 221.39,
            "endTime": 225.665,
            "sug": [
                [
                    "Kesiin",
                    "Only,"
                ],
                [
                    "nalluluku ellin sister-ra.",
                    "he did not know that she was his sister."
                ]
            ],
            "fullEnglish": "Only, he did not know that she was his sister."
        },
        "32": {
            "startTime": 225.665,
            "endTime": 228.805,
            "sug": [
                [
                    "Awa’i takutaarluku.",
                    "And so he would always go check on her."
                ]
            ],
            "fullEnglish": "And so he would always go check on her."
        },
        "33": {
            "startTime": 228.805,
            "endTime": 237.061,
            "sug": [
                [
                    "Nallugkuarluki suu’ut",
                    "He didn’t let people know"
                ],
                [
                    "unugmi, unugmi late,",
                    "at night, at night late,"
                ],
                [
                    "takularluku.",
                    "he would check on her."
                ]
            ],
            "fullEnglish": "He didn’t let people know he would check on her at night, at night late."
        },
        "34": {
            "startTime": 237.061,
            "endTime": 245.041,
            "sug": [
                [
                    "Kesiin nallullutek,",
                    "Although those two did not know,"
                ],
                [
                    "you know,",
                    "you know,"
                ],
                [
                    "sister-qullutek brother-qullutek.",
                    "they were sister and brother."
                ]
            ],
            "fullEnglish": "Although those two did not know they were sister and brother, you know."
        },
        "35": {
            "startTime": 245.041,
            "endTime": 249.645,
            "sug": [
                [
                    "Tang’rutegkunatek",
                    "They could not see each other"
                ],
                [
                    "tamlegluni,",
                    "in the darkness,"
                ],
                [
                    "tamlegmi.",
                    "in the dark."
                ]
            ],
            "fullEnglish": "They could not see each other in the darkness, in the dark."
        },
        "36": {
            "startTime": 249.645,
            "endTime": 254.224,
            "sug": [
                [
                    "Awa’i takutaarluku,",
                    "So he would check on her,"
                ],
                [
                    "caqimek pikarq’lluku.",
                    "and he would bring something for her."
                ]
            ],
            "fullEnglish": "So he would check on her, and he would bring something for her."
        },
        "37": {
            "startTime": 254.224,
            "endTime": 262.175,
            "sug": [
                [
                    "Awa’i atakuku petta",
                    "A little while later,"
                ],
                [
                    "tek’iullutek,",
                    "those two had a chance to do it"
                ],
                [
                    "asi’ingan.",
                    "when she was better (done menstruating)."
                ]
            ],
            "fullEnglish": "A little while later, those two had a chance to do it when she was better (done menstruating)."
        },
        "38": {
            "startTime": 262.175,
            "endTime": 271.633,
            "sug": [
                [
                    "Pettam,",
                    "And then,"
                ],
                [
                    "tekiut’kacamek",
                    "after they had a chance to do it (got together)"
                ],
                [
                    "aningan taugna anluni,",
                    "she went outside."
                ]
            ],
            "fullEnglish": "And then, after they had a chance to do it (got together) she went outside."
        },
        "39": {
            "startTime": 271.633,
            "endTime": 280.469,
            "sug": [
                [
                    "Awa’i, sister-ra pettam taugum tang’rluku,",
                    "And so then he sees she is his sister,"
                ],
                [
                    "you know,",
                    "you know,"
                ],
                [
                    "ellin wiiwani.",
                    "as he is circling [orbiting]."
                ]
            ],
            "fullEnglish": "And so then he sees she is his sister, you know, as he is circling [orbiting]."
        },
        "40": {
            "startTime": 280.469,
            "endTime": 289.199,
            "sug": [
                [
                    "Nalluluku",
                    "She is ignorant"
                ],
                [
                    "wiiwani",
                    "as he circles,"
                ],
                [
                    "tang’rurguimaluku taugum Iralum.",
                    "and then she sees that the Moon see her (for who she is)."
                ]
            ],
            "fullEnglish": "She is ignorant as he circles, and then she sees that the Moon see her (for who she is)."
        },
        "41": {
            "startTime": 289.199,
            "endTime": 292.112,
            "sug": [
                [
                    "Awa qikulutek.",
                    "Now they are ashamed."
                ]
            ],
            "fullEnglish": "Now they are ashamed."
        },
        "42": {
            "startTime": 292.112,
            "endTime": 295.75,
            "sug": [
                [
                    "Qikiwakarllutek",
                    "And they (two) are very ashamed"
                ],
                [
                    "uniyullutek.",
                    "and they separate from each other."
                ]
            ],
            "fullEnglish": "And they (two) are very ashamed and they separate from each other."
        },
        "43": {
            "startTime": 295.75,
            "endTime": 305.099,
            "sug": [
                [
                    "Allriluq east agluni,",
                    "One goes east,"
                ],
                [
                    "allriluq west",
                    "one goes west,"
                ],
                [
                    "taaten uniyullutek.",
                    "that is how they part from each other."
                ]
            ],
            "fullEnglish": "One goes east, one goes west, that is how they part from each other."
        },
        "44": {
            "startTime": 305.099,
            "endTime": 309.084,
            "sug": [
                [
                    "Qikilutek,",
                    "Those two are ashamed,"
                ],
                [
                    "ashamed of themselves.",
                    "ashamed of themselves."
                ]
            ],
            "fullEnglish": "Those two are ashamed, ashamed of themselves."
        },
        "45": {
            "startTime": 309.084,
            "endTime": 310.787,
            "sug": [
                [
                    "Qikilutek,",
                    "Those two are ashamed,"
                ],
                [
                    "aglutek.",
                    "and so they go."
                ]
            ],
            "fullEnglish": "Those two are ashamed, and so they go."
        },
        "46": {
            "startTime": 310.787,
            "endTime": 313.352,
            "sug": [
                [
                    "Tekiutan’ituq",
                    "They never get together"
                ],
                [
                    "[nerua?] taaten.",
                    "like that after that."
                ]
            ],
            "fullEnglish": "They never get together like that after that."
        },
        "47": {
            "startTime": 317.594,
            "endTime": 321.046,
            "sug": [
                [
                    "Tang’ruteriuq,",
                    "She sees,"
                ],
                [
                    "you know,",
                    "you know,"
                ],
                [
                    "nallullutek.",
                    "those two did not know it."
                ]
            ],
            "fullEnglish": "She sees, you know, those two did not know it."
        },
        "48": {
            "startTime": 321.046,
            "endTime": 325.889,
            "sug": [
                [
                    "Nallukuku",
                    "Because she did not know"
                ],
                [
                    "ellin brother-ra, sister-ra.",
                    "he was her brother, and she was his sister."
                ]
            ],
            "fullEnglish": "Because she did not know he was her brother, and she was his sister."
        },
        "49": {
            "startTime": 325.889,
            "endTime": 333.322,
            "sug": [
                [
                    "Pettam anngan,",
                    "So when he went out,"
                ],
                [
                    "tawaken",
                    "from there after"
                ],
                [
                    "arya’aq taugna",
                    "the girl"
                ],
                [
                    "litaqlluku ellin sister-ni.",
                    "learned that she was his sister."
                ]
            ],
            "fullEnglish": "So when he went out, from there after the girl learned that she was his sister."
        },
        "50": {
            "startTime": 333.322,
            "endTime": 336.689,
            "sug": [
                [
                    "Awa’i qikiwakarlutek",
                    "Now those two were very much ashamed"
                ],
                [
                    "uniyullutek.",
                    "and they separate from each other."
                ]
            ],
            "fullEnglish": "Now those two were very much ashamed and they separate from each other."
        },
        "51": {
            "startTime": 336.689,
            "endTime": 344.454,
            "sug": [
                [
                    "Macaq-gua arya’aq.",
                    "The sun here is a girl."
                ],
                [
                    "Una Iraluq tan’uraq.",
                    "The moon is a boy."
                ]
            ],
            "fullEnglish": "The sun here is a girl. The moon is a boy."
        },
        "52": {
            "startTime": 344.454,
            "endTime": 347.786,
            "sug": [
                [
                    "Yeah,",
                    "Yeah,"
                ],
                [
                    "unigkua’utaaqait’kut.",
                    "they always used to tell legends."
                ]
            ],
            "fullEnglish": "Yeah, they always used to tell legends."
        },
        "53": {
            "startTime": 347.786,
            "endTime": 352.166,
            "sug": [
                [
                    "That old man used to come...Geez, there was all kinds [of stories]!",
                    "That old man used to come...Geez, there was all kinds [of stories]!"
                ]
            ],
            "fullEnglish": "That old man used to come...Geez, there was all kinds [of stories]!"
        },
        "54": {
            "startTime": 352.166,
            "endTime": 354.656,
            "sug": [
                [
                    "Kesiin,",
                    "Except,"
                ],
                [
                    "nalluya’utanka-ruq ilait.",
                    "I forgot the other parts."
                ]
            ],
            "fullEnglish": "Except, I forgot the other parts."
        }
    },
    "3": {
        "1": {
            "startTime": 0.47,
            "endTime": 7.819,
            "sug": [
                [
                    "Augkut cali",
                    "These ones and"
                ],
                [
                    "leprechaun-ret,",
                    "leprechauns,"
                ],
                [
                    "cali.",
                    "also."
                ],
                [
                    "I got a story about that leprechaun.",
                    "I got a story about that leprechaun."
                ]
            ],
            "fullEnglish": "These ones and leprechauns, also. I got a story about that leprechaun."
        },
        "2": {
            "startTime": 7.819,
            "endTime": 12.479,
            "sug": [
                [
                    "Sungcut,",
                    "Little people,"
                ],
                [
                    "you know, remember?",
                    "you know, remember?"
                ]
            ],
            "fullEnglish": "Little people, you know, remember?"
        },
        "3": {
            "startTime": 12.479,
            "endTime": 24.086,
            "sug": [
                [
                    "Allriluq suk petta",
                    "So, one person"
                ],
                [
                    "pisuryarluni",
                    "went hunting"
                ],
                [
                    "Uyarmen—",
                    "toward Larsen Bay—"
                ],
                [
                    "Uyak, just imagine!—",
                    "Uyak, just imagine!—"
                ],
                [
                    "Uyarmen",
                    "to Larsen Bay"
                ],
                [
                    "Kal’unek.",
                    "from Karluk."
                ]
            ],
            "fullEnglish": "So, one person went hunting toward Larsen Bay—Uyak, just imagine!—to Larsen Bay from Karluk."
        },
        "4": {
            "startTime": 24.086,
            "endTime": 28.944,
            "sug": [
                [
                    "That must have been many, many years ago.",
                    "That must have been many, many years ago."
                ]
            ],
            "fullEnglish": "That must have been many, many years ago."
        },
        "5": {
            "startTime": 28.944,
            "endTime": 33.652,
            "sug": [
                [
                    "Maybe even before my mom was even born, you know.",
                    "Maybe even before my mom was even born, you know."
                ]
            ],
            "fullEnglish": "Maybe even before my mom was even born, you know."
        },
        "6": {
            "startTime": 33.652,
            "endTime": 42.889,
            "sug": [
                [
                    "Pisuryarluni",
                    "So, he went hunting"
                ],
                [
                    "qayagun",
                    "with his kayak"
                ],
                [
                    "petta Uyarmen agluni—",
                    "toward Larsen Bay as he went—"
                ],
                [
                    "pisuryarluni",
                    "hunting"
                ],
                [
                    "qayagun.",
                    "with his kayak."
                ]
            ],
            "fullEnglish": "So, he went hunting with his kayak toward Larsen Bay as he went—hunting with his kayak."
        },
        "7": {
            "startTime": 42.889,
            "endTime": 52.381,
            "sug": [
                [
                    "Akma petta nicimai cingiguamen",
                    "And then out from behind the point he hears them"
                ],
                [
                    "taaten",
                    "like that"
                ],
                [
                    "agkutarngami",
                    "as he goes"
                ],
                [
                    "Uyarmen—",
                    "toward Larsen Bay—"
                ]
            ],
            "fullEnglish": "And then out from behind the point he hears them like that as he goes toward Larsen Bay—"
        },
        "8": {
            "startTime": 52.381,
            "endTime": 54.831,
            "sug": [
                [
                    "in toward Parks, you know.",
                    "in toward Parks, you know."
                ]
            ],
            "fullEnglish": "in toward Parks, you know."
        },
        "9": {
            "startTime": 54.831,
            "endTime": 59.071,
            "sug": [
                [
                    "Ay’ya’ya,",
                    "Oh my, my,"
                ],
                [
                    "suu’ut",
                    "people"
                ],
                [
                    "niuwaluteng.",
                    "were talking."
                ]
            ],
            "fullEnglish": "Oh my, my, people were talking."
        },
        "10": {
            "startTime": 59.071,
            "endTime": 64.583,
            "sug": [
                [
                    "Emtuusinarluteng.",
                    "They were very loud."
                ],
                [
                    "Emtuunq’lluki",
                    "It sounded very loud"
                ],
                [
                    "guangkuta.",
                    "to us."
                ]
            ],
            "fullEnglish": "They were very loud. It sounded very loud to us."
        },
        "11": {
            "startTime": 64.583,
            "endTime": 66.607,
            "sug": [
                [
                    "Nani-llu",
                    "Where could"
                ],
                [
                    "suu’ut",
                    "the people be"
                ],
                [
                    "niuwata.",
                    "who were talking."
                ]
            ],
            "fullEnglish": "Where could the people be who were talking."
        },
        "12": {
            "startTime": 66.607,
            "endTime": 71.762,
            "sug": [
                [
                    "Tang’rkunani",
                    "He couldn’t see"
                ],
                [
                    "maakun qalagyarat",
                    "from where he was hollering"
                ],
                [
                    "agluni,",
                    "as he went,"
                ],
                [
                    "you know.",
                    "you know."
                ]
            ],
            "fullEnglish": "He couldn’t see from where he was hollering as he went, you know."
        },
        "13": {
            "startTime": 71.762,
            "endTime": 73.926,
            "sug": [
                [
                    "Sugmek tang’rkunani.",
                    "He couldn’t see a person."
                ]
            ],
            "fullEnglish": "He couldn’t see a person."
        },
        "14": {
            "startTime": 73.926,
            "endTime": 81.673,
            "sug": [
                [
                    "Atakuraku",
                    "A little later,"
                ],
                [
                    "ikaut-raq",
                    "way over there,"
                ],
                [
                    "agngami",
                    "when he was rowing"
                ],
                [
                    "qayangcuk tang’rluku—",
                    "he saw a little qayaq—"
                ],
                [
                    "mikt’sagnek qayangcuk.",
                    "a little, small kayak."
                ]
            ],
            "fullEnglish": "A little later, way over there, when he was rowing he saw a little qayaq—a little, small kayak."
        },
        "15": {
            "startTime": 81.673,
            "endTime": 87.926,
            "sug": [
                [
                    "Mal’ugnek,",
                    "Two,"
                ],
                [
                    "you know, a two hole kayak.",
                    "you know, a two hole kayak."
                ]
            ],
            "fullEnglish": "Two, you know, a two hole kayak."
        },
        "16": {
            "startTime": 87.926,
            "endTime": 92.09,
            "sug": [
                [
                    "Tawani petta,",
                    "And so there,"
                ],
                [
                    "tang’rluku",
                    "he saw it"
                ],
                [
                    "weg’et akuliitni.",
                    "amongst the grass."
                ]
            ],
            "fullEnglish": "And so there, he saw it amongst the grass."
        },
        "17": {
            "startTime": 92.09,
            "endTime": 95.372,
            "sug": [
                [
                    "Pettam",
                    "Then"
                ],
                [
                    "mal’ungcuk sungcuk tang’rlukek.",
                    "he sees two little people."
                ]
            ],
            "fullEnglish": "Then he sees two little people."
        },
        "18": {
            "startTime": 95.372,
            "endTime": 98.657,
            "sug": [
                [
                    "Ay’ya’ya,",
                    "Oh my, my,"
                ],
                [
                    "niugllutek",
                    "those two were talking"
                ],
                [
                    "emtuusinarlutek.",
                    "very loud."
                ]
            ],
            "fullEnglish": "Oh my, my, those two were talking very loud."
        },
        "19": {
            "startTime": 98.657,
            "endTime": 105.973,
            "sug": [
                [
                    "Tang’rainamegt’gu",
                    "When they saw"
                ],
                [
                    "taugna qayasinaq,",
                    "that big kayak,"
                ],
                [
                    "qayangcugtek tuqaqainarluku",
                    "they grabbed their little kayaks"
                ],
                [
                    "qecenglutek.",
                    "and ran."
                ]
            ],
            "fullEnglish": "When they saw that big kayak, they grabbed their little kayaks and ran."
        },
        "20": {
            "startTime": 105.973,
            "endTime": 110.74,
            "sug": [
                [
                    "Taugna pettam",
                    "And then,"
                ],
                [
                    "culurlluni",
                    "he went ashore"
                ],
                [
                    "malirqangnaqllukek.",
                    "and chased after them."
                ]
            ],
            "fullEnglish": "And then, he went ashore and chased after them."
        },
        "21": {
            "startTime": 110.74,
            "endTime": 113.363,
            "sug": [
                [
                    "(But he) didn’t find them.",
                    "(But he) didn’t find them."
                ]
            ],
            "fullEnglish": "(But he) didn’t find them."
        }
    },
    "4": {
        "1": {
            "startTime": 0.67,
            "endTime": 8.38,
            "sug": [
                [
                    "Nalluwaqa",
                    "I don’t know"
                ],
                [
                    "gui Kal’uni-qaa suullrianga,",
                    "if I was born in Karluk,"
                ],
                [
                    "ili-qaa Sturgeon River-mi,",
                    "or was it in Sturgeon River,"
                ],
                [
                    "nalluta’aqa.",
                    "I never knew."
                ]
            ],
            "fullEnglish": "I don’t know if I was born in Karluk, or was it in Sturgeon River, I never knew."
        },
        "2": {
            "startTime": 8.38,
            "endTime": 15.191,
            "sug": [
                [
                    "Allrak Kal’uni",
                    "Probably in Karluk"
                ],
                [
                    "suullrumaunga.",
                    "I must have been born."
                ],
                [
                    "In my birth records",
                    "In my birth records"
                ],
                [
                    "Kal’uni lliimauq.",
                    "she put in Karluk."
                ]
            ],
            "fullEnglish": "Probably in Karluk I must have been born. In my birth records she put in Karluk."
        },
        "3": {
            "startTime": 15.191,
            "endTime": 23.307,
            "sug": [
                [
                    "Kesiin Sturgeon River-mi",
                    "Only in Sturgeon River"
                ],
                [
                    "anglillriakut,",
                    "we all grew up,"
                ],
                [
                    "Kal’uni et’aanilngut pianeq.",
                    "they didn't live in Karluk right away."
                ]
            ],
            "fullEnglish": "Only in Sturgeon River we all grew up, they didn't live in Karluk right away."
        },
        "4": {
            "startTime": 23.307,
            "endTime": 35.618,
            "sug": [
                [
                    "Ikani,",
                    "Over there,"
                ],
                [
                    "guangkuta ap’rtakarpet",
                    "we call it"
                ],
                [
                    "Amani, Sturgeon River—Amawik.",
                    "Amani, Sturgeon River—The Pack Place."
                ],
                [
                    "Amawimen-llu agluta.",
                    "We would all go to Amani."
                ]
            ],
            "fullEnglish": "Over there, we call it Amani, Sturgeon River—The Pack Place. We would all go to Amani."
        },
        "5": {
            "startTime": 35.618,
            "endTime": 38.225,
            "sug": [
                [
                    "Tawa’i Sturgeon River.",
                    "That is Sturgeon River."
                ]
            ],
            "fullEnglish": "That is Sturgeon River."
        },
        "6": {
            "startTime": 38.225,
            "endTime": 47.705,
            "sug": [
                [
                    "Tawani englungq’rtaallriakut,",
                    "We always had a house there,"
                ],
                [
                    "kesiin el’aumaluni",
                    "but it was dug"
                ],
                [
                    "into the ground.",
                    "into the ground."
                ]
            ],
            "fullEnglish": "We always had a house there, but it was into the ground."
        },
        "7": {
            "startTime": 47.705,
            "endTime": 56.373,
            "sug": [
                [
                    "Patumaluni",
                    "It was covered"
                ],
                [
                    "with sod.",
                    "with sod."
                ],
                [
                    "Atama piliallraa.",
                    "My dad made it."
                ]
            ],
            "fullEnglish": "It was covered with sod. My dad made it."
        },
        "8": {
            "startTime": 56.373,
            "endTime": 61.316,
            "sug": [
                [
                    "Tawani,",
                    "Over there,"
                ],
                [
                    "llaang’llrianga gui",
                    "I came into my consciousness (grew up)"
                ],
                [
                    "Amani.",
                    "at the Pack Place (Sturgeon River)."
                ]
            ],
            "fullEnglish": "Over there, I came into my consciousness (grew up) at the Pack Place (Sturgeon River)."
        },
        "9": {
            "startTime": 61.316,
            "endTime": 65.576,
            "sug": [
                [
                    "Ciqlluat’stun canamaluni,",
                    "He made the house like sod houses,"
                ],
                [
                    "kesiin engluq,",
                    "but a (stick frame) house,"
                ]
            ],
            "fullEnglish": "He made the house like sod houses, but a (stick frame) house,"
        },
        "10": {
            "startTime": 65.576,
            "endTime": 73.234,
            "sug": [
                [
                    "kesiin patumaluni",
                    "only it is covered"
                ],
                [
                    "llaami",
                    "on the outside"
                ],
                [
                    "with the sod",
                    "with the sod"
                ],
                [
                    "maaken.",
                    "from around here."
                ]
            ],
            "fullEnglish": "only on the outside it is covered with the sod from around here."
        },
        "11": {
            "startTime": 74.131,
            "endTime": 79.986,
            "sug": [
                [
                    "Maqiwingq’rlluta",
                    "We had a banya"
                ],
                [
                    "cali makuciruamek.",
                    "like this kind, too."
                ]
            ],
            "fullEnglish": "We had a banya like this kind, too."
        },
        "12": {
            "startTime": 79.986,
            "endTime": 87.082,
            "sug": [
                [
                    "Pettam ungunguangq’rlluta,",
                    "So that's the way our lives were,"
                ],
                [
                    "you know,",
                    "you know."
                ],
                [
                    "ungunguaq.",
                    "[?]"
                ],
                [
                    "SaRayaq.",
                    "(And we had) a shed."
                ]
            ],
            "fullEnglish": "So that's the way our lives were, you know. (And we had) a shed."
        },
        "13": {
            "startTime": 87.082,
            "endTime": 93.466,
            "sug": [
                [
                    "Ungunguangq’rlluta",
                    "The life we had"
                ],
                [
                    "allanganaguarluni ungunguaq,",
                    "was sort of a different life,"
                ],
                [
                    "miknani.",
                    "but it wasn’t small."
                ]
            ],
            "fullEnglish": "The life we had was sort of a different life, but it wasn’t small."
        },
        "14": {
            "startTime": 93.466,
            "endTime": 106.028,
            "sug": [
                [
                    "Taaten uut’stun canamanguarluni palat’kaat’stun,",
                    "Like this one here kind of built tent-like,"
                ],
                [
                    "kesiin angsinarkunani,",
                    "only not very big,"
                ],
                [
                    "kenerkat elgwiat.",
                    "and the firewood storage buildings."
                ]
            ],
            "fullEnglish": "Like this one here kind of built tent-like, only not very big, and the firewood storage buildings."
        },
        "15": {
            "startTime": 106.028,
            "endTime": 112.828,
            "sug": [
                [
                    "Tawani,",
                    "Over there,"
                ],
                [
                    "gui llaang’llrianga",
                    "I came into consciousness"
                ],
                [
                    "Amani.",
                    "in the Pack Place."
                ],
                [
                    "Sturgeon River-mi.",
                    "In Sturgeon River."
                ]
            ],
            "fullEnglish": "Over there, I came into consciousness in the Pack Place. In Sturgeon River."
        },
        "16": {
            "startTime": 112.828,
            "endTime": 118.718,
            "sug": [
                [
                    "Tawaken pettam,",
                    "And so just like,"
                ],
                [
                    "qaugcuullrungat’sta?",
                    "how many were we?"
                ]
            ],
            "fullEnglish": "And so just like, how many were we?"
        },
        "17": {
            "startTime": 118.718,
            "endTime": 126.176,
            "sug": [
                [
                    "Gui sister-qa Mary,",
                    "My sister Mary,"
                ],
                [
                    "brother-qa Willie,",
                    "my brother Willie,"
                ]
            ],
            "fullEnglish": "My sister Mary, my brother Willie,"
        },
        "18": {
            "startTime": 126.176,
            "endTime": 132.048,
            "sug": [
                [
                    "pettam sister-qa Mini,",
                    "And then my sister Mini,"
                ],
                [
                    "brother-qa Martin,",
                    "my brother Martin,"
                ]
            ],
            "fullEnglish": "And then my sister Mini, my brother Martin,"
        },
        "19": {
            "startTime": 132.048,
            "endTime": 137.767,
            "sug": [
                [
                    "Alfred pipii’uluni,",
                    "Alfred was a baby,"
                ],
                [
                    "gui pettam.",
                    "and then me."
                ]
            ],
            "fullEnglish": "Alfred was a baby, and then me."
        },
        "20": {
            "startTime": 137.767,
            "endTime": 155.44,
            "sug": [
                [
                    "Martin pipii’uluni.",
                    "Martin was a baby."
                ],
                [
                    "Ellin paapaama high chair lillrumakikut,",
                    "My dad must have made him a high chair,"
                ],
                [
                    "his own, you know from the beach.",
                    "his own, you know from the beach."
                ]
            ],
            "fullEnglish": "Martin was a baby. My dad must have made him a high chair, his own, you know from the beach."
        },
        "21": {
            "startTime": 155.44,
            "endTime": 157.64,
            "sug": [
                [
                    "High chair lillrumaluni.",
                    "He made a high chair."
                ]
            ],
            "fullEnglish": "He made a high chair."
        },
        "22": {
            "startTime": 157.64,
            "endTime": 161.727,
            "sug": [
                [
                    "I always remember that,",
                    "I always remember that,"
                ],
                [
                    "gui nallutaan'itaqa.",
                    "I always know it."
                ]
            ],
            "fullEnglish": "I always remember that, I always know it."
        },
        "23": {
            "startTime": 161.727,
            "endTime": 165.898,
            "sug": [
                [
                    "Tawani pipiiq",
                    "There the baby"
                ],
                [
                    "aqumataarluni",
                    "would always sit"
                ],
                [
                    "high chair-mi.",
                    "in the high chair."
                ]
            ],
            "fullEnglish": "There the baby would always sit in the high chair."
        },
        "24": {
            "startTime": 165.898,
            "endTime": 173.971,
            "sug": [
                [
                    "A homemade one, from the beach you know, he made it himself.",
                    "A homemade one, from the beach you know, he made it himself."
                ]
            ],
            "fullEnglish": "A homemade one, from the beach you know, he made it himself."
        },
        "25": {
            "startTime": 173.971,
            "endTime": 184.268,
            "sug": [
                [
                    "Tawaken pettam",
                    "Just like that"
                ],
                [
                    "llaangluanga,",
                    "was how I came into my consciousness,"
                ],
                [
                    "llaangaars’piarlua",
                    "I really grew up"
                ],
                [
                    "tekicamta Kal’unun.",
                    "when we arrived in Karluk."
                ]
            ],
            "fullEnglish": "Just like that was how I came into my consciousness, when we arrived in Karluk I really grew up."
        },
        "26": {
            "startTime": 184.268,
            "endTime": 188.55,
            "sug": [
                [
                    "Ay’ya’ya,",
                    "Oh my, my!"
                ],
                [
                    "Kal’uk gui angitna",
                    "When we went back,"
                ],
                [
                    "angsinarluni.",
                    "Karluk was so big."
                ]
            ],
            "fullEnglish": "Oh my, my! When we went back, Karluk was so big."
        },
        "27": {
            "startTime": 188.55,
            "endTime": 191.809,
            "sug": [
                [
                    "Ellin kimta et’aallriakut",
                    "(It seemed really big) because we had lived just by ourselves in"
                ],
                [
                    "Amani.",
                    "Sturgeon River."
                ]
            ],
            "fullEnglish": "(It seemed really big) because we had lived just by ourselves in Sturgeon River."
        },
        "28": {
            "startTime": 191.809,
            "endTime": 193.995,
            "sug": [
                [
                    "Suinani.",
                    "Noone (was there)."
                ]
            ],
            "fullEnglish": "Noone (was there)."
        },
        "29": {
            "startTime": 193.995,
            "endTime": 199.863,
            "sug": [
                [
                    "Ikani akimi,",
                    "Far across the bay,"
                ],
                [
                    "across the bay-ruq,",
                    "way across the bay,"
                ],
                [
                    "you know how Sturgeon is?",
                    "you know how Sturgeon is?"
                ]
            ],
            "fullEnglish": "Far across the bay, way across the bay, you know how Sturgeon is?"
        },
        "30": {
            "startTime": 199.863,
            "endTime": 206.828,
            "sug": [
                [
                    "Nalluwaqa",
                    "I don’t know,"
                ],
                [
                    "elnguten-qaa",
                    "did you stay there"
                ],
                [
                    "Sturgeon-mi?",
                    "in Sturgeon?"
                ],
                [
                    "It’s like a bay, you know.",
                    "It’s like a bay, you know."
                ]
            ],
            "fullEnglish": "I don’t know, did you stay there in Sturgeon? It’s like a bay, you know."
        },
        "31": {
            "startTime": 206.828,
            "endTime": 212.925,
            "sug": [
                [
                    "Ikani",
                    "Over there"
                ],
                [
                    "allakat suu’ut",
                    "a bunch of strange people"
                ],
                [
                    "elluteng,",
                    "would stay,"
                ],
                [
                    "kaiwik,",
                    "an old woman"
                ],
                [
                    "angutek.",
                    "and two old men."
                ]
            ],
            "fullEnglish": "Over there a bunch of strange people would stay, an old woman and two old men."
        },
        "32": {
            "startTime": 212.925,
            "endTime": 217.689,
            "sug": [
                [
                    "Qamanisinaq cali",
                    "Way inside (the bay) and"
                ],
                [
                    "suu’ut",
                    "people"
                ],
                [
                    "elluteng",
                    "stayed"
                ],
                [
                    "qamani.",
                    "way up in there."
                ]
            ],
            "fullEnglish": "Way inside (the bay) and people stayed way up in there."
        },
        "33": {
            "startTime": 217.689,
            "endTime": 222.925,
            "sug": [
                [
                    "Awa, tekilluta",
                    "We arrived"
                ],
                [
                    "Kal’unun",
                    "in Karluk"
                ],
                [
                    "tauRagun.",
                    "by dory."
                ]
            ],
            "fullEnglish": "We arrived in Karluk by dory."
        },
        "34": {
            "startTime": 222.925,
            "endTime": 229.694,
            "sug": [
                [
                    "Ay-ya-ya,",
                    "On my, my,"
                ],
                [
                    "sugpakat",
                    "there were many people"
                ],
                [
                    "guangkuta mikt’saagluta.",
                    "as we were very small."
                ]
            ],
            "fullEnglish": "On my, my, there were many people as we were very small."
        },
        "35": {
            "startTime": 229.694,
            "endTime": 232.971,
            "sug": [
                [
                    "Awa’i Kal’uk gui angyuklluku.",
                    "And so I thought Karluk was big."
                ]
            ],
            "fullEnglish": "And so I thought Karluk was big."
        },
        "36": {
            "startTime": 235.352,
            "endTime": 237.92,
            "sug": [
                [
                    "Sugyagluni.",
                    "It had many people."
                ]
            ],
            "fullEnglish": "It had many people."
        },
        "37": {
            "startTime": 237.92,
            "endTime": 241.984,
            "sug": [
                [
                    "Na-a’i,",
                    "Wow,"
                ],
                [
                    "sugyagluni,",
                    "it had many people"
                ],
                [
                    "miknata.",
                    "when we were small."
                ]
            ],
            "fullEnglish": "Wow, when we were small it had many people."
        },
        "38": {
            "startTime": 241.984,
            "endTime": 248.141,
            "sug": [
                [
                    "Llanglua",
                    "As I grew up,"
                ],
                [
                    "nallutaan'itaqa",
                    "I remember"
                ],
                [
                    "iterluta",
                    "that we would enter"
                ],
                [
                    "englumen tawa’ut.",
                    "into the house (low) like that."
                ]
            ],
            "fullEnglish": "As I grew up, I remember that we would enter into the house (low) like that."
        },
        "39": {
            "startTime": 248.141,
            "endTime": 251.605,
            "sug": [
                [
                    "Kaiwik",
                    "The old lady"
                ],
                [
                    "aqumaluni",
                    "sat"
                ],
                [
                    "irugani.",
                    "on her two legs."
                ]
            ],
            "fullEnglish": "The old lady sat on her two legs."
        },
        "40": {
            "startTime": 251.605,
            "endTime": 260.5,
            "sug": [
                [
                    "You know how they used to,",
                    "You know how they used to,"
                ],
                [
                    "gwani",
                    "here"
                ],
                [
                    "on top",
                    "on top"
                ],
                [
                    "aqumaluni",
                    "she would sit"
                ],
                [
                    "like this on top of the chair.",
                    "like this on top of the chair."
                ]
            ],
            "fullEnglish": "You know how they used to, here on top she would sit like this on top of the chair."
        },
        "41": {
            "startTime": 260.5,
            "endTime": 268.152,
            "sug": [
                [
                    "Una,",
                    "This one,"
                ],
                [
                    "kina-llu una?",
                    "who could she be?"
                ],
                [
                    "Alutiit’stun kainaq-naa",
                    "Only in Alutiiq"
                ],
                [
                    "niuwataallriakut guangkuta,",
                    "we always used to talk with the old lady,"
                ],
                [
                    "aa’a.",
                    "yes."
                ]
            ],
            "fullEnglish": "This one, who could she be? We always used to talk with the old lady only in Alutiiq, yes."
        },
        "42": {
            "startTime": 268.152,
            "endTime": 274.854,
            "sug": [
                [
                    "Maamam",
                    "My mom"
                ],
                [
                    "niuwaqurluku",
                    "used to talk"
                ],
                [
                    "Alutiit’stun",
                    "in Alutiiq"
                ],
                [
                    "taugna kaiwik.",
                    "with that old lady."
                ]
            ],
            "fullEnglish": "My mom used to talk in Alutiiq with that old lady."
        },
        "43": {
            "startTime": 274.854,
            "endTime": 280.336,
            "sug": [
                [
                    "Nalluwaqa",
                    "I don't know,"
                ],
                [
                    "kesiin",
                    "except,"
                ],
                [
                    "naten ima",
                    "where"
                ],
                [
                    "sister-renka brother-renka",
                    "my sisters and brothers"
                ],
                [
                    "agluteng.",
                    "might have gone."
                ]
            ],
            "fullEnglish": "Except, I don't know where my sisters and brothers might have gone."
        },
        "44": {
            "startTime": 280.336,
            "endTime": 284.485,
            "sug": [
                [
                    "Gui kima allrak",
                    "I was the only one (she brought along), probably"
                ],
                [
                    "nitniqitaallrumaunga.",
                    "because I always paid attention."
                ]
            ],
            "fullEnglish": "I was the only one (she brought along), probably because I always paid attention."
        },
        "45": {
            "startTime": 284.485,
            "endTime": 289.631,
            "sug": [
                [
                    "Awa taugum kaiwim",
                    "And so the old woman"
                ],
                [
                    "sarsagkwarluta.",
                    "would serve us tea."
                ]
            ],
            "fullEnglish": "And so the old woman would serve us tea."
        },
        "46": {
            "startTime": 289.631,
            "endTime": 298.312,
            "sug": [
                [
                    "Sarsagkwarluku Maama,",
                    "She would serve tea to my Momma,"
                ],
                [
                    "pettam guangkuta caqingcugmek minarluta,",
                    "and then she would give us a little something,"
                ],
                [
                    "you know,",
                    "you know,"
                ],
                [
                    "neregkwarluta.",
                    "feed us."
                ]
            ],
            "fullEnglish": "She would serve tea to my Momma, and then she would give us a little something, you know, feed us."
        },
        "47": {
            "startTime": 298.312,
            "endTime": 305.307,
            "sug": [
                [
                    "Taugkuk tawa’i engluak guangkuta paapama yu’urpagtuq.",
                    "My dad got those two houses over there that we lived in."
                ]
            ],
            "fullEnglish": "My dad got those two houses over there that we lived in."
        },
        "48": {
            "startTime": 305.307,
            "endTime": 310.304,
            "sug": [
                [
                    "Fifty dollars (laugh)",
                    "With fifty dollar"
                ],
                [
                    "nall'irlukek!",
                    "we paid those two (houses)!"
                ]
            ],
            "fullEnglish": "For those two (houses) we paid fifty dollars!"
        },
        "49": {
            "startTime": 310.304,
            "endTime": 324.327,
            "sug": [
                [
                    "Engluak taugna yu’aarluku,",
                    "Those two houses he bought"
                ],
                [
                    "fifty dollars. He bought that house for fifty dollars.",
                    "for fifty dollars. He bought that house for fifty dollars."
                ]
            ],
            "fullEnglish": "Those two houses he bought for fifty dollars. He bought that house for fifty dollars."
        },
        "50": {
            "startTime": 327.426,
            "endTime": 333.371,
            "sug": [
                [
                    "Awa’i,",
                    "And so,"
                ],
                [
                    "that was our house after that;",
                    "that was our house after that;"
                ],
                [
                    "tawani enliyuta.",
                    "we made a home there."
                ]
            ],
            "fullEnglish": "And so, that was our house after that; we made a home there."
        },
        "51": {
            "startTime": 333.371,
            "endTime": 343.626,
            "sug": [
                [
                    "Brother-qa Willie Norell,",
                    "My brother Willie Norell,"
                ],
                [
                    "pettam naas’kaa sister-qa Mary.",
                    "and my oldest sister Mary."
                ],
                [
                    "Awa skaulurpagtak tawa’i.",
                    "So, they two went to school there."
                ]
            ],
            "fullEnglish": "My brother Willie Norell, and my oldest sister Mary. So, they two went to school there."
        },
        "52": {
            "startTime": 343.626,
            "endTime": 346.449,
            "sug": [
                [
                    "Gui mikqaascamaka.",
                    "I was too small then."
                ]
            ],
            "fullEnglish": "I was too small then."
        },
        "53": {
            "startTime": 346.449,
            "endTime": 354.183,
            "sug": [
                [
                    "Atakuraku cali cami",
                    "It wasn’t long until"
                ],
                [
                    "ellin my other sister Mini",
                    "my other sister Mini"
                ],
                [
                    "cali",
                    "too"
                ],
                [
                    "skaulurluni.",
                    "went to school."
                ]
            ],
            "fullEnglish": "It wasn’t long until my other sister Mini went to school, too."
        },
        "54": {
            "startTime": 354.183,
            "endTime": 357.665,
            "sug": [
                [
                    "Awa skaulurluteng tamarmeng.",
                    "So all of them would go to school."
                ]
            ],
            "fullEnglish": "So all of them would go to school."
        },
        "55": {
            "startTime": 357.665,
            "endTime": 364.522,
            "sug": [
                [
                    "Gui aularcaurpagcaa skaulumen",
                    "Then I started to want to go to school already"
                ],
                [
                    "awa’i ellin tamarmeng skauluraarluteng.",
                    "because they all were going to school."
                ]
            ],
            "fullEnglish": "Then I started to want to go to school already because they all were going to school."
        },
        "56": {
            "startTime": 364.522,
            "endTime": 367.069,
            "sug": [
                [
                    "Unuami-naa",
                    "In the morning,"
                ],
                [
                    "gui aularllua",
                    "I would start off"
                ],
                [
                    "skaulumen!",
                    "to school!"
                ]
            ],
            "fullEnglish": "In the morning, I would start off to school!"
        },
        "57": {
            "startTime": 367.069,
            "endTime": 371.351,
            "sug": [
                [
                    "Uciitilam...",
                    "The teacher..."
                ]
            ],
            "fullEnglish": "The teacher..."
        },
        "58": {
            "startTime": 371.351,
            "endTime": 376.279,
            "sug": [
                [
                    "Uciitilam-llu",
                    "The teacher"
                ],
                [
                    "angiyulluanga!",
                    "would take me back!"
                ]
            ],
            "fullEnglish": "The teacher would take me back!"
        },
        "59": {
            "startTime": 376.279,
            "endTime": 380.211,
            "sug": [
                [
                    "Paapaa",
                    "Dad,"
                ],
                [
                    "niu’uciqaa,",
                    "he will say,"
                ],
                [
                    "“She ran away to school.”",
                    "“She ran away to school.”"
                ]
            ],
            "fullEnglish": "Dad, he will say, “She ran away to school.”"
        },
        "60": {
            "startTime": 380.211,
            "endTime": 386.299,
            "sug": [
                [
                    "Ayaa,",
                    "On my,"
                ],
                [
                    "gui qialua-llu,",
                    "I would just cry,"
                ],
                [
                    "“I want to go to school.”",
                    "“I want to go to school.”"
                ]
            ],
            "fullEnglish": "On my, I would just cry, “I want to go to school.”"
        },
        "61": {
            "startTime": 386.299,
            "endTime": 389.999,
            "sug": [
                [
                    "Tawa’i",
                    "That is how"
                ],
                [
                    "anglillrianga",
                    "I (got big) grew up"
                ],
                [
                    "Kal’uni.",
                    "in Karluk."
                ]
            ],
            "fullEnglish": "That is how I (got big) grew up in Karluk."
        }
    },
    "5": {
        "1": {
            "startTime": 1.51,
            "endTime": 9.27,
            "sug": [
                [
                    "Oh,",
                    "Oh,"
                ],
                [
                    "Apaangcuk,",
                    "Little Grandfather,"
                ],
                [
                    "Apaangcuk.",
                    "Little Grandfather."
                ],
                [
                    "Una",
                    "This is"
                ],
                [
                    "Saint Herman.",
                    "Saint Herman."
                ]
            ],
            "fullEnglish": "Oh, Little Grandfather, Little Grandfather. This is Saint Herman."
        },
        "2": {
            "startTime": 9.27,
            "endTime": 28.538,
            "sug": [
                [
                    "Ta-ru,",
                    "See,"
                ],
                [
                    "miktpianamni gui.",
                    "when I was really little,"
                ],
                [
                    "Allrak-llu eight, seven-qaa uksunglua",
                    "maybe when I was eight or seven years old,"
                ],
                [
                    "maamaqa tuqugu’ilian.",
                    "before my mom died."
                ]
            ],
            "fullEnglish": "See, when I was really little, maybe when I was eight or seven years old, before my mom died."
        },
        "3": {
            "startTime": 28.538,
            "endTime": 41.792,
            "sug": [
                [
                    "Nitnirciqkanka",
                    "I would listen to them"
                ],
                [
                    "niuwakata",
                    "when they talked,"
                ],
                [
                    "maamama ellin makut friend-ni iwartakai.",
                    "my mom would send for her friends."
                ]
            ],
            "fullEnglish": "When they talked, I would listen to them with my mom and her friend would send for them."
        },
        "4": {
            "startTime": 41.792,
            "endTime": 45.37,
            "sug": [
                [
                    "Iwars’takai",
                    "She would send for them"
                ],
                [
                    "sarsaiyakst’luki.",
                    "so they could have tea."
                ]
            ],
            "fullEnglish": "She would send for them so they could have tea."
        },
        "5": {
            "startTime": 45.37,
            "endTime": 51.655,
            "sug": [
                [
                    "Sarsailuteng-llu",
                    "They would give us tea"
                ],
                [
                    "cestun gua’i aqumatsnguq",
                    "and this here is how they always sat"
                ],
                [
                    "niuwaluteng",
                    "and talked"
                ],
                [
                    "qulianguarluteng.",
                    "and would tell stories."
                ]
            ],
            "fullEnglish": "They would give us tea and this here is how they always sat and talked and would tell stories."
        },
        "6": {
            "startTime": 51.655,
            "endTime": 56.094,
            "sug": [
                [
                    "Qulianguarluteng.",
                    "They would tell stories."
                ],
                [
                    "Niuwaluteng.",
                    "They would talk about him."
                ]
            ],
            "fullEnglish": "They would tell stories. They would talk about him."
        },
        "7": {
            "startTime": 56.094,
            "endTime": 62.448,
            "sug": [
                [
                    "Awa-llu",
                    "As usual,"
                ],
                [
                    "taugna Apaangcuk niuwatektaqait.",
                    "they talked about that Little Grandfather (Saint Herman)."
                ]
            ],
            "fullEnglish": "As usual, they talked about that Little Grandfather (Saint Herman)."
        },
        "8": {
            "startTime": 62.448,
            "endTime": 66.053,
            "sug": [
                [
                    "Gui nalluluku",
                    "I didn't know"
                ],
                [
                    "Apaangcuk.",
                    "Little Grandfather (Saint Herman)."
                ]
            ],
            "fullEnglish": "I didn't know Little Grandfather (Saint Herman)."
        },
        "9": {
            "startTime": 66.053,
            "endTime": 76.742,
            "sug": [
                [
                    "Nallukunaku",
                    "I did not know"
                ],
                [
                    "Apaangcuk",
                    "Little Grandfather (Saint Herman)."
                ],
                [
                    "apaamek grampa tamartarait [?] apaa, apaamek.",
                    "They miss [?] grandfather."
                ]
            ],
            "fullEnglish": "I did not know Little Grandfather (Saint Herman). They miss grandfather."
        },
        "10": {
            "startTime": 76.742,
            "endTime": 79.354,
            "sug": [
                [
                    "Tawa.",
                    "Like that."
                ]
            ],
            "fullEnglish": "Like that."
        },
        "11": {
            "startTime": 79.354,
            "endTime": 84.827,
            "sug": [
                [
                    "Taaten anglilua",
                    "As I grew up like that,"
                ],
                [
                    "gui niitaarluku Apaangcuk ta-ruq.",
                    "I always would hear about Little Grandfather."
                ]
            ],
            "fullEnglish": "As I grew up I always would hear about Little Grandfather, like that."
        },
        "12": {
            "startTime": 84.827,
            "endTime": 88.435,
            "sug": [
                [
                    "Suumallria",
                    "He was born"
                ],
                [
                    "nani.",
                    "somewhere."
                ]
            ],
            "fullEnglish": "He was born somewhere."
        },
        "13": {
            "startTime": 88.435,
            "endTime": 94.334,
            "sug": [
                [
                    "Nani kesiin, gui nalluluku nani.",
                    "Only where, I don't know."
                ],
                [
                    "Nani Uusenkaaq et’a,",
                    "He is at somewhere near Ouzinkie,"
                ],
                [
                    "you know.",
                    "you know."
                ]
            ],
            "fullEnglish": "Only where, I don't know. He is at somewhere near Ouzinkie, you know."
        },
        "14": {
            "startTime": 94.334,
            "endTime": 98.549,
            "sug": [
                [
                    "Nallutakagpet",
                    "We didn’t know"
                ],
                [
                    "cuumi aiwitanilngukut,",
                    "before how they would travel,"
                ],
                [
                    "you know.",
                    "you know,"
                ]
            ],
            "fullEnglish": "We didn’t know before how they would travel, you know,"
        },
        "15": {
            "startTime": 98.549,
            "endTime": 104.722,
            "sug": [
                [
                    "Tuʀatgun",
                    "By dory"
                ],
                [
                    "aiwiluteng",
                    "they would go"
                ],
                [
                    "anguarluteng",
                    "rowing"
                ],
                [
                    "and qayatgun",
                    "and by kayak,"
                ],
                [
                    "you know.",
                    "you know."
                ]
            ],
            "fullEnglish": "They would go rowing by dory and by kayak, you know."
        },
        "16": {
            "startTime": 104.722,
            "endTime": 109.132,
            "sug": [
                [
                    "Qayatgun",
                    "By kayak,"
                ],
                [
                    "cuumi",
                    "in the past,"
                ],
                [
                    "aiwiraartaallriat.",
                    "they always used to go."
                ]
            ],
            "fullEnglish": "Before, they always used to go by kayak."
        },
        "17": {
            "startTime": 109.132,
            "endTime": 116.303,
            "sug": [
                [
                    "Pettam qayatgun aiwinarnameng.",
                    "And then they would go by kayak."
                ],
                [
                    "Tuʀatgun anguarluteng.",
                    "They would row by dory."
                ]
            ],
            "fullEnglish": "And then they would go by kayak. They would row by dory."
        },
        "18": {
            "startTime": 120.299,
            "endTime": 126.739,
            "sug": [
                [
                    "Awa",
                    "And so,"
                ],
                [
                    "niitaarparcenka",
                    "I listened to them"
                ],
                [
                    "una Apaangcuk-ruq!",
                    "about this Little Grandfather!"
                ]
            ],
            "fullEnglish": "And so, I listened to them about this Little Grandfather!"
        },
        "19": {
            "startTime": 126.739,
            "endTime": 129.938,
            "sug": [
                [
                    "Cestun",
                    "That’s the way"
                ],
                [
                    "niuwataamallria.",
                    "he would always talk."
                ]
            ],
            "fullEnglish": "That’s the way he would always talk."
        },
        "20": {
            "startTime": 129.938,
            "endTime": 134.374,
            "sug": [
                [
                    "Uswilraarat-ruq petta carlialuki.",
                    "He would take care of the children."
                ]
            ],
            "fullEnglish": "He would take care of the children."
        },
        "21": {
            "startTime": 134.374,
            "endTime": 142.238,
            "sug": [
                [
                    "Akaʀautaliluni",
                    "He would garden"
                ],
                [
                    "kiagmi",
                    "in the summer"
                ],
                [
                    "uswiillra’araat piteklluki.",
                    "on account of the children."
                ]
            ],
            "fullEnglish": "He would garden in the summer on account of the children."
        },
        "22": {
            "startTime": 142.238,
            "endTime": 149.813,
            "sug": [
                [
                    "Vegtable-nek",
                    "Vegetables,"
                ],
                [
                    "naut'staarluni,",
                    "he always grew,"
                ],
                [
                    "kaʀtauranek,",
                    "potatoes,"
                ],
                [
                    "caqinek.",
                    "and things."
                ]
            ],
            "fullEnglish": "He always grew vegetables, potatoes, and things."
        },
        "23": {
            "startTime": 149.813,
            "endTime": 154.635,
            "sug": [
                [
                    "Caqiq kainaq nautciqaa",
                    "Whatever would grow,"
                ],
                [
                    "naut'starluni",
                    "he would grow it."
                ]
            ],
            "fullEnglish": "Whatever would grow, he would grow it."
        },
        "24": {
            "startTime": 154.635,
            "endTime": 164.603,
            "sug": [
                [
                    "Awa-llu",
                    "And then"
                ],
                [
                    "uksumi",
                    "in winter"
                ],
                [
                    "ununguangq’rluni [?]",
                    "he would have life [?]"
                ],
                [
                    "under the, you know, under the ground.",
                    "under the, you know, under the ground (in a root cellar)."
                ]
            ],
            "fullEnglish": "And then in winter he would have life under the, you know, under the ground (in a root cellar)."
        },
        "25": {
            "startTime": 164.603,
            "endTime": 175.732,
            "sug": [
                [
                    "Tamaa’ut-llu petta lliiluki makut",
                    "It could be around there then that he put them there"
                ],
                [
                    "uswiillra’araat piteklluki",
                    "because of the children"
                ],
                [
                    "tamani Uusenkaami.",
                    "there in Ouzinkie."
                ]
            ],
            "fullEnglish": "It could be around there then that he put them there because of the children in Ouzinkie."
        },
        "26": {
            "startTime": 175.732,
            "endTime": 195.997,
            "sug": [
                [
                    "Uusenkaami",
                    "In Ouzinkie"
                ],
                [
                    "litnaurtamaluki",
                    "he taught"
                ],
                [
                    "Agayutmek.",
                    "about God."
                ],
                [
                    "Nani,",
                    "Somewhere,"
                ],
                [
                    "you know,",
                    "you know,"
                ],
                [
                    "agayunata",
                    "we had no church"
                ],
                [
                    "taaten",
                    "like that"
                ],
                [
                    "gua’i maani.",
                    "around here."
                ]
            ],
            "fullEnglish": "In Ouzinkie he taught about God. Somewhere, you know, we had no church like that around here."
        },
        "27": {
            "startTime": 195.997,
            "endTime": 204.991,
            "sug": [
                [
                    "On Kodiak Island he came around that Orthodox Church.",
                    "On Kodiak Island he came around that Orthodox Church."
                ]
            ],
            "fullEnglish": "On Kodiak Island he came around that Orthodox Church."
        },
        "28": {
            "startTime": 204.991,
            "endTime": 209.231,
            "sug": [
                [
                    "Everybody started getting baptized to Orthodox Church.",
                    "Everybody started getting baptized to Orthodox Church."
                ]
            ],
            "fullEnglish": "Everybody started getting baptized to Orthodox Church."
        },
        "29": {
            "startTime": 209.231,
            "endTime": 213.233,
            "sug": [
                [
                    "Apaangcuk taugum",
                    "Little Grandfather"
                ],
                [
                    "litnaurluki.",
                    "would teach it to them."
                ]
            ],
            "fullEnglish": "Little Grandfather would teach it to them."
        },
        "30": {
            "startTime": 213.233,
            "endTime": 224.317,
            "sug": [
                [
                    "Agayugkwarluki",
                    "He let them pray"
                ],
                [
                    "ikani Uusenkaami",
                    "over there in Ouzinikie"
                ],
                [
                    "tawaken pettam kas’aq",
                    "like that and priest"
                ],
                [
                    "taisaurluteng.",
                    "started to come."
                ]
            ],
            "fullEnglish": "He let them pray over there in Ouzinikie like that and priest started to come."
        },
        "31": {
            "startTime": 224.317,
            "endTime": 232.118,
            "sug": [
                [
                    "Maan’a",
                    "Around here"
                ],
                [
                    "Miʀikaan’saat",
                    "when the Americans"
                ],
                [
                    "piksautkaacau",
                    "obtained"
                ],
                [
                    "Alaas'kaaq.",
                    "Alaska."
                ]
            ],
            "fullEnglish": "Around here when the Americans obtained Alaska."
        },
        "32": {
            "startTime": 233.623,
            "endTime": 239.565,
            "sug": [
                [
                    "Kas’aq taisaurpagtat",
                    "Except when the priest would come"
                ],
                [
                    "amlertanilngut kesiin.",
                    "there weren't many people."
                ]
            ],
            "fullEnglish": "Except when the priest would come there weren't many people."
        },
        "33": {
            "startTime": 239.565,
            "endTime": 250.316,
            "sug": [
                [
                    "Kaʀyaasam pettam",
                    "And Father Gerasim"
                ],
                [
                    "maani gua’i.",
                    "around here."
                ],
                [
                    "Father King,",
                    "Father King,"
                ],
                [
                    "nallun'itaqa.",
                    "I know him."
                ]
            ],
            "fullEnglish": "And Father Gerasim around here. Father King, I know him."
        },
        "34": {
            "startTime": 250.316,
            "endTime": 254.675,
            "sug": [
                [
                    "Father King",
                    "Father King"
                ],
                [
                    "maaken taitallraat",
                    "came from here"
                ],
                [
                    "cali Kal’unun.",
                    "and (went) to Karluk."
                ]
            ],
            "fullEnglish": "Father King came from here and (went) to Karluk."
        },
        "35": {
            "startTime": 254.675,
            "endTime": 261.315,
            "sug": [
                [
                    "Pettam Kaʀyaasam tailuni.",
                    "And then Gerasim came."
                ],
                [
                    "Kaʀyaasam-rem gui agayugkaumakinga",
                    "Gerasim would pray for me"
                ],
                [
                    "agayuwigmi.",
                    "in the church."
                ]
            ],
            "fullEnglish": "And then Gerasim came. Gerasim would pray for me in the church."
        },
        "36": {
            "startTime": 261.315,
            "endTime": 270.708,
            "sug": [
                [
                    "Ikani,",
                    "Over there,"
                ],
                [
                    "takumaunga et’aartuq",
                    "I went to see where he lived"
                ],
                [
                    "Spruce Island.",
                    "on Spruce Island."
                ]
            ],
            "fullEnglish": "Over there, I went to see where he lived on Spruce Island."
        },
        "37": {
            "startTime": 270.708,
            "endTime": 273.959,
            "sug": [
                [
                    "Qungumauq",
                    "He is buried"
                ],
                [
                    "tawani.",
                    "there."
                ]
            ],
            "fullEnglish": "He is buried there."
        },
        "38": {
            "startTime": 277.985,
            "endTime": 291.375,
            "sug": [
                [
                    "Tawa'i",
                    "There"
                ],
                [
                    "angutem taugum litnaurluki suu’ut",
                    "that old man he taught the people"
                ],
                [
                    "kenineremek,",
                    "to cook"
                ],
                [
                    "[qaik salirlluki] caqit.",
                    "and [split the surface] of things."
                ]
            ],
            "fullEnglish": "There that old man he taught the people to cook and [split the surface] of things."
        },
        "39": {
            "startTime": 291.375,
            "endTime": 301.366,
            "sug": [
                [
                    "Caqiq tamarkian nallugkunaku,",
                    "He knew everything about it,"
                ],
                [
                    "you know,",
                    "you know,"
                ],
                [
                    "cestun canaluku neq’rkaq.",
                    "how to make food."
                ]
            ],
            "fullEnglish": "He knew everything about it, you know, how to make food."
        },
        "40": {
            "startTime": 301.366,
            "endTime": 308.396,
            "sug": [
                [
                    "Liitnaurluki suu’ut",
                    "He would teach the people"
                ],
                [
                    "ikani.",
                    "over there."
                ]
            ],
            "fullEnglish": "He would teach the people over there."
        },
        "41": {
            "startTime": 308.396,
            "endTime": 316.506,
            "sug": [
                [
                    "Aulakacan",
                    "As the earthquake came"
                ],
                [
                    "tidal wave,",
                    "and tidal wave,"
                ],
                [
                    "petangan taangaq.",
                    "then the water started to move."
                ]
            ],
            "fullEnglish": "As the earthquake and tidal wave came, then the water started to move."
        },
        "42": {
            "startTime": 316.506,
            "endTime": 329.61,
            "sug": [
                [
                    "Taangaq petta tagkutarnan,",
                    "And then the water was going to come up,"
                ],
                [
                    "pausinkaq et’a lliiluku",
                    "he put a holy icon,"
                ],
                [
                    "Pausinkam Aani lliiluku",
                    "he put an icon of Christ’s mother"
                ],
                [
                    "qutmen.",
                    "on the beach."
                ]
            ],
            "fullEnglish": "And then the water was going to come up, he put an icon of Christ’s mother on the beach."
        },
        "43": {
            "startTime": 329.61,
            "endTime": 332.843,
            "sug": [
                [
                    "Suu'ut pimaluki",
                    "He told the people"
                ],
                [
                    "alinill’kunaki.",
                    "that they didn’t need to be afraid."
                ]
            ],
            "fullEnglish": "He told the people that they didn’t need to be afraid."
        },
        "44": {
            "startTime": 332.843,
            "endTime": 336.171,
            "sug": [
                [
                    "Una-ruq,",
                    "This one (icon)"
                ],
                [
                    "taangam cipningaita.",
                    "the water wouldn’t go beyond it."
                ]
            ],
            "fullEnglish": "This one (icon) the water wouldn’t go beyond it."
        },
        "45": {
            "startTime": 336.171,
            "endTime": 346.522,
            "sug": [
                [
                    "Awa’i,",
                    "Already,"
                ],
                [
                    "cipllurkunaku taang-",
                    "the water didn’t go beyond it,"
                ],
                [
                    "tidal wave, tidal wave -ngarmi.",
                    "the tidal wave, the tidal wave didn't."
                ]
            ],
            "fullEnglish": "Already, the water, the tidal wave, the tidal wave didn’t go beyond it."
        },
        "46": {
            "startTime": 346.522,
            "endTime": 355.376,
            "sug": [
                [
                    "Taugna cipllurkunaku.",
                    "It didn’t go beyond it."
                ],
                [
                    "Taangagtaarnamni angitmen",
                    "The water would come back"
                ],
                [
                    "taangaq angillqut.",
                    "and then the water would go away again."
                ]
            ],
            "fullEnglish": "It didn’t go beyond it. The water would come back and then the water would go away again."
        },
        "47": {
            "startTime": 355.376,
            "endTime": 364.56,
            "sug": [
                [
                    "Cali qua’inata nani ellin",
                    "And it didn’t burn where he was at"
                ],
                [
                    "Spruce Island-mi qua’iluteng.",
                    "even though Spruce Island was burning."
                ]
            ],
            "fullEnglish": "And it didn’t burn where he was at even though Spruce Island was burning."
        },
        "48": {
            "startTime": 364.56,
            "endTime": 368.22,
            "sug": [
                [
                    "Qua’inata pettam.",
                    "And so we didn’t burn."
                ]
            ],
            "fullEnglish": "And so we didn’t burn."
        },
        "49": {
            "startTime": 368.22,
            "endTime": 376.211,
            "sug": [
                [
                    "Apaangcuk pimaluki,",
                    "Little Grandfather (Saint Herman) told them (how to stop the fire),"
                ],
                [
                    "to be,",
                    "to be,"
                ],
                [
                    "una ellminek lagluku.",
                    "by digging (a border) himself."
                ]
            ],
            "fullEnglish": "Little Grandfather (Saint Herman) told them (how to stop the fire) by digging (a border) himself."
        },
        "50": {
            "startTime": 376.211,
            "endTime": 382.55,
            "sug": [
                [
                    "Ukani",
                    "Over there,"
                ],
                [
                    "Spruce-raat ukani akiani cali",
                    "Spruce over there on the other side"
                ],
                [
                    "Spruce-raat et’lluteng.",
                    "is where they are located."
                ]
            ],
            "fullEnglish": "Over there, Spruce over there on the other side is where they are located."
        },
        "51": {
            "startTime": 382.55,
            "endTime": 388.512,
            "sug": [
                [
                    "Taugna lagluku ellminek",
                    "He dug it himself"
                ],
                [
                    "pimaluki suu’ut.",
                    "and then he told the people."
                ]
            ],
            "fullEnglish": "He dug it himself and then he told the people."
        },
        "52": {
            "startTime": 388.512,
            "endTime": 394.348,
            "sug": [
                [
                    "Una-ruq cipningaita kenrem, awa’i.",
                    "The fire won’t go beyond this (ditch)."
                ]
            ],
            "fullEnglish": "The fire won’t go beyond this (ditch)."
        },
        "53": {
            "startTime": 394.348,
            "endTime": 399.25,
            "sug": [
                [
                    "Quta pitekuniru awa’i",
                    "When it reached the beach"
                ],
                [
                    "angitciquq.",
                    "it will go back."
                ]
            ],
            "fullEnglish": "When it reached the beach it will go back."
        },
        "54": {
            "startTime": 399.25,
            "endTime": 403.152,
            "sug": [
                [
                    "Niuyugluki piicinek awa’i.",
                    "He wanted to say the reason for the right way."
                ]
            ],
            "fullEnglish": "He wanted to say the reason for the right way."
        },
        "55": {
            "startTime": 403.152,
            "endTime": 411.402,
            "sug": [
                [
                    "Tamaut llaigngami",
                    "He knew what he was talking about,"
                ],
                [
                    "angitmen kenrem angilluni.",
                    "as when it reached there it went back."
                ]
            ],
            "fullEnglish": "He knew what he was talking about, as when it reached there it went back."
        },
        "56": {
            "startTime": 411.402,
            "endTime": 421.456,
            "sug": [
                [
                    "Amlesqat ilait nallyutanka qulianguat.",
                    "Many stories I know only parts of."
                ],
                [
                    "Kesiin",
                    "But"
                ],
                [
                    "it was...it is very true, very, very true.",
                    "(all this) was...it is very true, very, very true."
                ]
            ],
            "fullEnglish": "Many stories I know only parts of. But (all this) was...it is very true, very, very true."
        },
        "57": {
            "startTime": 421.456,
            "endTime": 438.855,
            "sug": [
                [
                    "Uksumi petta,",
                    "Then in the winter,"
                ],
                [
                    "qawarluni",
                    "he would sleep"
                ],
                [
                    "engluginani.",
                    "without a house."
                ],
                [
                    "Englengq’rluni makucimek kemerkamaq englengq’rta.",
                    "He kind of had a bed made of firewood."
                ]
            ],
            "fullEnglish": "Then in the winter, he would sleep without a house. He kind of had a bed made of firewood."
        },
        "58": {
            "startTime": 438.855,
            "endTime": 456.284,
            "sug": [
                [
                    "Makucim qaingani",
                    "On top it"
                ],
                [
                    "taquka’arem, taquka’arem, you know, the skin, amia.",
                    "was kind of a bear’s, bear’s, you know, the skin, its skin."
                ]
            ],
            "fullEnglish": "On top it was kind of a bear’s, bear’s, you know, the skin, its skin."
        },
        "59": {
            "startTime": 456.284,
            "endTime": 460.649,
            "sug": [
                [
                    "Taquka’aq keningcirluni allrak.",
                    "He had a way of drying a bear (skin) perhaps."
                ]
            ],
            "fullEnglish": "He had a way of drying a bear (skin) perhaps."
        },
        "60": {
            "startTime": 460.649,
            "endTime": 471.142,
            "sug": [
                [
                    "Taugna englelluku,",
                    "One he used as a house,"
                ],
                [
                    "taugna tawa englellra.",
                    "and that one was his former house."
                ]
            ],
            "fullEnglish": "One he used as a house, and that one was his former house."
        },
        "61": {
            "startTime": 471.142,
            "endTime": 486.211,
            "sug": [
                [
                    "Pettam allamek taquka’armek uksumi",
                    "And so in the winter he used another a bear skin"
                ],
                [
                    "ulingq’rlluni,",
                    "as a blanket"
                ],
                [
                    "putuskangq’rlluni",
                    "and he had a pillow"
                ],
                [
                    "kenerkaq, kenerkaq.",
                    "of firewood, firewood."
                ]
            ],
            "fullEnglish": "And so in the winter he used another a bear skin as a blanket and he had a pillow of firewood."
        },
        "62": {
            "startTime": 486.211,
            "endTime": 498.248,
            "sug": [
                [
                    "Patukainarluku",
                    "He would cover it"
                ],
                [
                    "cali tawa’i putuskangq’rlluku",
                    "and there he would have a pillow"
                ],
                [
                    "taugna caqimek patuluku.",
                    "with something to cover it."
                ]
            ],
            "fullEnglish": "He would cover it and there he would have a pillow with something to cover it."
        },
        "63": {
            "startTime": 498.248,
            "endTime": 510.155,
            "sug": [
                [
                    "Caqim caqimek caqingq’r...patukainarluku",
                    "He would just cover it with something"
                ],
                [
                    "taqukaram iquanek.",
                    "such as the bear’s end."
                ]
            ],
            "fullEnglish": "He would just cover it with something such as the bear’s end."
        },
        "64": {
            "startTime": 510.155,
            "endTime": 516.417,
            "sug": [
                [
                    "Ika,",
                    "Over there,"
                ],
                [
                    "tang’rk’ka englellra",
                    "I saw his former house,"
                ],
                [
                    "et’uq cali ikani.",
                    "it's still over there."
                ]
            ],
            "fullEnglish": "Over there, I saw his former house over there."
        },
        "65": {
            "startTime": 516.417,
            "endTime": 519.256,
            "sug": [
                [
                    "El’nguten-qaa Spruce Island-mi?",
                    "Were you at Spruce Island?"
                ]
            ],
            "fullEnglish": "Were you at Spruce Island?"
        },
        "66": {
            "startTime": 519.256,
            "endTime": 532.186,
            "sug": [
                [
                    "Et’uq cali englugtaallra",
                    "His former house that is"
                ],
                [
                    "tang’rkauwan",
                    "where you can see it"
                ],
                [
                    "tawani agkut",
                    "over there if you will go"
                ],
                [
                    "tang’rciqan.",
                    "you will see it."
                ]
            ],
            "fullEnglish": "His former house that is where you can see it over there if you will go you will see it."
        },
        "67": {
            "startTime": 532.186,
            "endTime": 535.289,
            "sug": [
                [
                    "Kaʀyaasam tawani et’amallria.",
                    "Gerasim must have stayed over there."
                ]
            ],
            "fullEnglish": "Gerasim must have stayed over there."
        },
        "68": {
            "startTime": 535.289,
            "endTime": 545.874,
            "sug": [
                [
                    "Carliagnamiu angun taugna tuquka’acan, awa’i suu’ut.",
                    "After the old man (Saint Herman died), (Father Gerasim) took care of the place."
                ]
            ],
            "fullEnglish": "After the old man (Saint Herman died), (Father Gerasim) took care of the place."
        },
        "69": {
            "startTime": 545.874,
            "endTime": 553.83,
            "sug": [
                [
                    "Suu’ut pettam qenakuneng ikaken agkaskuneng.",
                    "And then after the people go there they are no longer sick."
                ]
            ],
            "fullEnglish": "And then after the people go there they are no longer sick."
        },
        "70": {
            "startTime": 553.83,
            "endTime": 558.63,
            "sug": [
                [
                    "Agayuyaturluteng",
                    "They would go to pray"
                ],
                [
                    "iqam suanek tuulluteng.",
                    "and take his soil (from his grave)."
                ]
            ],
            "fullEnglish": "They would go to pray and take his soil (from his grave)."
        },
        "71": {
            "startTime": 558.63,
            "endTime": 571.019,
            "sug": [
                [
                    "Iqanek, iqanek,",
                    "The soil, the soil"
                ],
                [
                    "camani agayuwim acaani",
                    "under his chapel,"
                ],
                [
                    "qungumaluni.",
                    "where he is buried."
                ]
            ],
            "fullEnglish": "The soil, the soil under his chapel, where he is buried."
        },
        "72": {
            "startTime": 571.019,
            "endTime": 574.733,
            "sug": [
                [
                    "Tawaut-llu et’arluteng",
                    "From there they would stay for a little while"
                ],
                [
                    "iqanek tuuklluteng.",
                    "and then take the soil."
                ]
            ],
            "fullEnglish": "From there they would stay for a little while and then take the soil."
        },
        "73": {
            "startTime": 577.545,
            "endTime": 585.129,
            "sug": [
                [
                    "Sung’cautkamek, sung’cautkamek tuulluteng,",
                    "They would take it for healing, for healing,"
                ],
                [
                    "just a little bit",
                    "just a little bit"
                ],
                [
                    "tuulluteng.",
                    "they would take."
                ]
            ],
            "fullEnglish": "They would take it for healing, for healing, just a little bit they would take."
        },
        "74": {
            "startTime": 585.129,
            "endTime": 594.791,
            "sug": [
                [
                    "Suu’ut tuyuwiitaallriit",
                    "The people always send it"
                ],
                [
                    "Kal’unun",
                    "to Karluk"
                ],
                [
                    "Uusenkaamek",
                    "from Ouzinkie,"
                ],
                [
                    "ellmangcugmek.",
                    "a little bit of it."
                ]
            ],
            "fullEnglish": "The people always send a little bit of it to Karluk from Ouzinkie."
        },
        "75": {
            "startTime": 594.791,
            "endTime": 598.238,
            "sug": [
                [
                    "Apaangcum iqanek",
                    "Little Grandfather’s soil,"
                ],
                [
                    "aparluku ellaita.",
                    "they would call it."
                ]
            ],
            "fullEnglish": "Little Grandfather’s soil, they would call it."
        },
        "76": {
            "startTime": 598.238,
            "endTime": 605.978,
            "sug": [
                [
                    "Apaangcum-ruq iqanek",
                    "With Little Grandfather’s soil"
                ],
                [
                    "sung’caun nitarluki ellmitsniq.",
                    "they would heal themselves."
                ]
            ],
            "fullEnglish": "With Little Grandfather’s soil they would heal themselves."
        },
        "77": {
            "startTime": 605.978,
            "endTime": 616.883,
            "sug": [
                [
                    "Uma petta wikacama",
                    "After I had a husband,"
                ],
                [
                    "qenawakartua",
                    "I was so very ill"
                ],
                [
                    "nalluluku caqingq-... qai-llu qenasaa.",
                    "and don’t know what I had or why I was so sick."
                ]
            ],
            "fullEnglish": "After I had a husband, I was so very ill and don’t know what I had or why I was so sick."
        },
        "78": {
            "startTime": 616.883,
            "endTime": 626.698,
            "sug": [
                [
                    "Uksumi,",
                    "It was in the winter"
                ],
                [
                    "nani nuta’an nuta’at englut.",
                    "now where there are new houses."
                ]
            ],
            "fullEnglish": "It was in the winter now where there are new houses."
        },
        "79": {
            "startTime": 626.698,
            "endTime": 632.028,
            "sug": [
                [
                    "Kaiwim englullrani brother-ma taugna.",
                    "At my brother's old lady's house."
                ]
            ],
            "fullEnglish": "At my brother's old lady's house."
        }
    },
    "6": {
        "1": {
            "startTime": 4.54,
            "endTime": 8.862,
            "sug": [
                [
                    "Allringumek,",
                    "One time,"
                ],
                [
                    "pisuryartukut.",
                    "we all went hunting (at a prearranged place)."
                ]
            ],
            "fullEnglish": "One time, we all went hunting (at a prearranged place)."
        },
        "2": {
            "startTime": 8.862,
            "endTime": 13.291,
            "sug": [
                [
                    "They are all",
                    "They are all"
                ],
                [
                    "pisuryat-ing.",
                    "would go hunting."
                ]
            ],
            "fullEnglish": "They are all would go hunting."
        },
        "3": {
            "startTime": 16.277,
            "endTime": 21.482,
            "sug": [
                [
                    "Cestun-llu",
                    "How do"
                ],
                [
                    "ap’rtaaraat...",
                    "they call it (the place)..."
                ]
            ],
            "fullEnglish": "How do they call it (the place)..."
        },
        "4": {
            "startTime": 21.482,
            "endTime": 38.362,
            "sug": [
                [
                    "Nalluya’utaar-...",
                    "I always forget..."
                ],
                [
                    "Nalluya’utaiwarlua...",
                    "What I forgot will probably come to me..."
                ],
                [
                    "Anyhow.",
                    "Anyhow."
                ],
                [
                    "Ay,",
                    "Ah,"
                ],
                [
                    "natmen nalluya’uten?",
                    "do you know where to?"
                ]
            ],
            "fullEnglish": "I always forget... What I forgot will probably come to me... Anyhow. Ah, do you know where to?"
        },
        "5": {
            "startTime": 38.362,
            "endTime": 42.844,
            "sug": [
                [
                    "Nanwarnamen-qaa? (Jeff Leer)",
                    "To the lagoon?"
                ]
            ],
            "fullEnglish": "To the lagoon?"
        },
        "6": {
            "startTime": 42.844,
            "endTime": 44.887,
            "sug": [
                [
                    "Angaluganun...",
                    "To Angaluk (cove north of King Cove on Tonki Cape Peninsula across from Marmot Island)."
                ]
            ],
            "fullEnglish": "To Angaluk (cove north of King Cove on Tonki Cape Peninsula across from Marmot Island)."
        },
        "7": {
            "startTime": 44.887,
            "endTime": 47.654,
            "sug": [
                [
                    "Angaluganun",
                    "To Angaluk"
                ],
                [
                    "pisuryartut.",
                    "they all would go hunting."
                ]
            ],
            "fullEnglish": "To Angaluk they all would go hunting."
        },
        "8": {
            "startTime": 47.654,
            "endTime": 54.119,
            "sug": [
                [
                    "When they remember...",
                    "When they remember"
                ],
                [
                    "piyugyakugtura nallukunaku.",
                    "(anyone) knew they would want tour it."
                ]
            ],
            "fullEnglish": "When they remember (anyone) knew they would want tour it."
        },
        "9": {
            "startTime": 54.119,
            "endTime": 72.609,
            "sug": [
                [
                    "And then his devil feels bad, you know — a shaman. When they leave, they have a trick, you see. They try to trick you.",
                    "And then his devil feels bad, you know — a shaman. When they leave, they have a trick, you see. They try to trick you."
                ]
            ],
            "fullEnglish": "And then his devil feels bad, you know — a shaman. When they leave, they have a trick, you see. They try to trick you."
        },
        "10": {
            "startTime": 72.609,
            "endTime": 87.351,
            "sug": [
                [
                    "Something you touch will probably affect your body, you know. Then they’ll know that someone was there. And...",
                    "Something you touch will probably affect your body, you know. Then they’ll know that someone was there. And..."
                ]
            ],
            "fullEnglish": "Something you touch will probably affect your body, you know. Then they’ll know that someone was there. And..."
        },
        "11": {
            "startTime": 87.351,
            "endTime": 97.396,
            "sug": [
                [
                    "So that guy if he touches (it), whatever he (the shaman) told to do what (would happen), and it could...",
                    "So that guy if he touches (it), whatever he (the shaman) told to do what (would happen), and it could..."
                ]
            ],
            "fullEnglish": "So that guy if he touches (it), whatever he (the shaman) told to do what (would happen), and it could..."
        },
        "12": {
            "startTime": 97.396,
            "endTime": 102.723,
            "sug": [
                [
                    "...Nallukunaku",
                    "...He knew"
                ],
                [
                    "kina elnguq.",
                    "who was there."
                ]
            ],
            "fullEnglish": "...He knew who was there."
        },
        "13": {
            "startTime": 102.723,
            "endTime": 111.218,
            "sug": [
                [
                    "Then when we stopped there; but like there was barabari there.",
                    "Then when we stopped there; but like there was barabari there."
                ]
            ],
            "fullEnglish": "Then when we stopped there; but like there was barabari there."
        },
        "14": {
            "startTime": 111.218,
            "endTime": 122.185,
            "sug": [
                [
                    "Taaten,",
                    "So,"
                ],
                [
                    "kenllertuq.",
                    "it was no longer low tide."
                ],
                [
                    "Ay kenllerumaluni.",
                    "Oh, because it must have been no longer low tide."
                ]
            ],
            "fullEnglish": "So, it was no longer low tide. Oh, because it must have been no longer low tide."
        },
        "15": {
            "startTime": 122.185,
            "endTime": 125.044,
            "sug": [
                [
                    "“Taugna maani gua,”",
                    "“Is it around here?”"
                ],
                [
                    "ap’rtanga.",
                    "then he asked me"
                ]
            ],
            "fullEnglish": "Then he asked me, “Is it around here?”"
        },
        "16": {
            "startTime": 125.044,
            "endTime": 131.358,
            "sug": [
                [
                    "Ikani",
                    "Over there"
                ],
                [
                    "legtengq’rtuq,",
                    "it has its den,"
                ],
                [
                    "aaquya’at legtet.",
                    "land otters’ dens."
                ]
            ],
            "fullEnglish": "Over there it has its den, land otters’ dens."
        },
        "17": {
            "startTime": 131.358,
            "endTime": 134.886,
            "sug": [
                [
                    "Takuciqapek...",
                    "We will go see..."
                ]
            ],
            "fullEnglish": "We will go see..."
        },
        "18": {
            "startTime": 134.886,
            "endTime": 148.817,
            "sug": [
                [
                    "...to see if their tracks are leading into the hole. If, not maybe...When they run in, their tracks are leading into the hole.",
                    "...to see if their tracks are leading into the hole. If, not maybe...When they run in, their tracks are leading into the hole."
                ]
            ],
            "fullEnglish": "...to see if their tracks are leading into the hole. If, not maybe...When they run in, their tracks are leading into the hole."
        },
        "19": {
            "startTime": 148.817,
            "endTime": 150.976,
            "sug": [
                [
                    "Ag’uartuq",
                    "He went to go"
                ],
                [
                    "takuluku.",
                    "to kind of go check on it."
                ]
            ],
            "fullEnglish": "He went to go to kind of go check on it."
        },
        "20": {
            "startTime": 150.976,
            "endTime": 163.913,
            "sug": [
                [
                    "It was high tide. Above, we walked above like that there. We knew where the hole. Where they hide, our dens were.",
                    "It was high tide. Above, we walked above like that there. We knew where the hole. Where they hide, our dens were."
                ]
            ],
            "fullEnglish": "It was high tide. Above, we walked above like that there. We knew where the hole. Where they hide, our dens were."
        },
        "21": {
            "startTime": 163.913,
            "endTime": 167.523,
            "sug": [
                [
                    "So,",
                    "So,"
                ],
                [
                    "tawani...",
                    "there..."
                ]
            ],
            "fullEnglish": "So, there..."
        },
        "22": {
            "startTime": 167.523,
            "endTime": 181.164,
            "sug": [
                [
                    "...we knew just by golly, there was a game here that leads up to the hole. They must be in there. So, we had to wait ‘til low tide.",
                    "...we knew just by golly, there was a game here that leads up to the hole. They must be in there. So, we had to wait ‘til low tide."
                ]
            ],
            "fullEnglish": "...we knew just by golly, there was a game here that leads up to the hole. They must be in there. So, we had to wait ‘til low tide."
        },
        "23": {
            "startTime": 181.164,
            "endTime": 185.905,
            "sug": [
                [
                    "“Kenskan",
                    "“When it is low tide,"
                ],
                [
                    "taiciqua.",
                    "I will come."
                ],
                [
                    "Kenskan...”",
                    "When it is low tide...”"
                ]
            ],
            "fullEnglish": "“When it is low tide, I will come. When it is low tide...”"
        },
        "24": {
            "startTime": 185.905,
            "endTime": 191.266,
            "sug": [
                [
                    "...we walked the beach.",
                    "...we walked the beach."
                ],
                [
                    "Kensqaq.",
                    "Low tide."
                ],
                [
                    "Tide is low enough.",
                    "Tide is low enough."
                ]
            ],
            "fullEnglish": "...we walked the beach. Low tide. Tide is low enough."
        },
        "25": {
            "startTime": 193.698,
            "endTime": 204.947,
            "sug": [
                [
                    "Then it was nice day. Just like yesterday. It was beautiful day. Sun shining after the storm, you know.",
                    "Then it was nice day. Just like yesterday. It was beautiful day. Sun shining after the storm, you know."
                ]
            ],
            "fullEnglish": "Then it was nice day. Just like yesterday. It was beautiful day. Sun shining after the storm, you know."
        },
        "26": {
            "startTime": 204.947,
            "endTime": 206.946,
            "sug": [
                [
                    "Agllugtuq.",
                    "(The sea) is rough."
                ]
            ],
            "fullEnglish": "(The sea) is rough."
        },
        "27": {
            "startTime": 206.946,
            "endTime": 239.098,
            "sug": [
                [
                    "The way they [the waves] used to come and hit the bluff and out again. We waited and we watched the wave that break and hit the bluff. When it was more out there, then we take a chance to run across, ya. It’s only say about...oh, maybe less than 100 feet, away from where it splashed against the bluff.",
                    "The way they [the waves] used to come and hit the bluff and out again. We waited and we watched the wave that break and hit the bluff. When it was more out there, then we take a chance to run across, ya. It’s only say about...oh, maybe less than 100 feet, away from where it splashed against the bluff."
                ]
            ],
            "fullEnglish": "The way they [the waves] used to come and hit the bluff and out again. We waited and we watched the wave that break and hit the bluff. When it was more out there, then we take a chance to run across, ya. It’s only say about...oh, maybe less than 100 feet, away from where it splashed against the bluff."
        },
        "28": {
            "startTime": 239.098,
            "endTime": 272.858,
            "sug": [
                [
                    "We were waiting for the waves to get smaller, and pretty soon... Well, now let’s run. Let’s run the waves will get smaller. Oh, we both, we both made it, one behind each other, you know. We just made it in there...big rock slid down. Why would that? We could have felt if it was earthquake. Nothing, just sunshine...",
                    "We were waiting for the waves to get smaller, and pretty soon... Well, now let’s run. Let’s run the waves will get smaller. Oh, we both, we both made it, one behind each other, you know. We just made it in there...big rock slid down. Why would that? We could have felt if it was earthquake. Nothing, just sunshine..."
                ]
            ],
            "fullEnglish": "We were waiting for the waves to get smaller, and pretty soon... Well, now let’s run. Let’s run the waves will get smaller. Oh, we both, we both made it, one behind each other, you know. We just made it in there...big rock slid down. Why would that? We could have felt if it was earthquake. Nothing, just sunshine..."
        },
        "29": {
            "startTime": 272.858,
            "endTime": 286.257,
            "sug": [
                [
                    "That big rock slid down. If it hitted us we would have been pieces of bone down there. Big, big one. Smoke even come out. It (was) that big.",
                    "That big rock slid down. If it hitted us we would have been pieces of bone down there. Big, big one. Smoke even come out. It (was) that big."
                ]
            ],
            "fullEnglish": "That big rock slid down. If it hitted us we would have been pieces of bone down there. Big, big one. Smoke even come out. It (was) that big."
        },
        "30": {
            "startTime": 286.257,
            "endTime": 300.066,
            "sug": [
                [
                    "It was laying like this and slid down, you know. I just made it. My partner was a little ahead of me, you know.",
                    "It was laying like this and slid down, you know. I just made it. My partner was a little ahead of me, you know."
                ]
            ],
            "fullEnglish": "It was laying like this and slid down, you know. I just made it. My partner was a little ahead of me, you know."
        },
        "31": {
            "startTime": 300.066,
            "endTime": 312.434,
            "sug": [
                [
                    "Then I told my partner. “See, that guy what he did. He didn’t catch us. His devils didn’t work.” Ya.",
                    "Then I told my partner. “See, that guy what he did. He didn’t catch us. His devils didn’t work.” Ya."
                ]
            ],
            "fullEnglish": "Then I told my partner. “See, that guy what he did. He didn’t catch us. His devils didn’t work.” Ya."
        },
        "32": {
            "startTime": 312.434,
            "endTime": 325.486,
            "sug": [
                [
                    "I kind of figured because I told him when you get into the barabari, don’t even touch the stretchers. The game stretchers, you know, parka stretchers, land otter stretchers.",
                    "I kind of figured because I told him when you get into the barabari, don’t even touch the stretchers. The game stretchers, you know, parka stretchers, land otter stretchers."
                ]
            ],
            "fullEnglish": "I kind of figured because I told him when you get into the barabari, don’t even touch the stretchers. The game stretchers, you know, parka stretchers, land otter stretchers."
        },
        "33": {
            "startTime": 325.486,
            "endTime": 347.121,
            "sug": [
                [
                    "Don’t even touch that because you’re liable to get sores on your hands. You see, he left his spirit working there, you see. That’s how much the devils love their hunting grounds. Hunting grounds. They were very important to them.",
                    "Don’t even touch that because you’re liable to get sores on your hands. You see, he left his spirit working there, you see. That’s how much the devils love their hunting grounds. Hunting grounds. They were very important to them."
                ]
            ],
            "fullEnglish": "Don’t even touch that because you’re liable to get sores on your hands. You see, he left his spirit working there, you see. That’s how much the devils love their hunting grounds. Hunting grounds. They were very important to them."
        },
        "34": {
            "startTime": 347.121,
            "endTime": 350.071,
            "sug": [
                [
                    "Ayaa,",
                    "Oh,"
                ],
                [
                    "tawa maani",
                    "that’s enough around here"
                ],
                [
                    "gua apcanga.",
                    "when he asked me."
                ]
            ],
            "fullEnglish": "Oh, that’s enough around here when he asked me."
        },
        "35": {
            "startTime": 350.071,
            "endTime": 352.116,
            "sug": [
                [
                    "That’s how the devil works.",
                    "That’s how the devil works."
                ]
            ],
            "fullEnglish": "That’s how the devil works."
        }
    },
    "7": {
        "1": {
            "startTime": 0.94,
            "endTime": 3.02,
            "sug": [
                [
                    "Cisllat",
                    "Calendar"
                ]
            ],
            "fullEnglish": "Calendar"
        },
        "2": {
            "startTime": 3.02,
            "endTime": 6.725,
            "sug": [
                [
                    "Naliyat",
                    "What"
                ],
                [
                    "Iraluq",
                    "Month"
                ],
                [
                    "Nutaan?",
                    "is it Now?"
                ]
            ],
            "fullEnglish": "What Month is it Now?"
        },
        "3": {
            "startTime": 10.955,
            "endTime": 14.023,
            "sug": [
                [
                    "Cuqllirpaaq",
                    "January (The First"
                ],
                [
                    "Iraluq",
                    "Moon)."
                ]
            ],
            "fullEnglish": "January (The First Moon)."
        },
        "4": {
            "startTime": 14.023,
            "endTime": 19.42,
            "sug": [
                [
                    "Rausistuataartut / Aʀausistuataartut*",
                    "They have a Christmas,"
                ],
                [
                    "Kaasakat",
                    "the Russians,"
                ],
                [
                    "iraluani.",
                    "in this month."
                ]
            ],
            "fullEnglish": "The Russians have a Christmas in this month."
        },
        "5": {
            "startTime": 19.42,
            "endTime": 23.095,
            "sug": [
                [
                    "Nanic’qaaq",
                    "February (The Short"
                ],
                [
                    "Iraluq",
                    "Moon)."
                ]
            ],
            "fullEnglish": "February (The Short Moon)."
        },
        "6": {
            "startTime": 23.095,
            "endTime": 29.178,
            "sug": [
                [
                    "Unguwatem Ernera",
                    "Valentine’s Day"
                ],
                [
                    "taitaartuq",
                    "comes"
                ],
                [
                    "iraluani.",
                    "in this month."
                ]
            ],
            "fullEnglish": "Valentine’s Day comes in this month."
        },
        "7": {
            "startTime": 33.196,
            "endTime": 36.126,
            "sug": [
                [
                    "Kaignasqaq",
                    "March (The Hungersome"
                ],
                [
                    "Iraluq",
                    "Moon)."
                ]
            ],
            "fullEnglish": "March (The Hungersome Moon)."
        },
        "8": {
            "startTime": 36.126,
            "endTime": 41.765,
            "sug": [
                [
                    "Neq’rkarsurtaartukut",
                    "We always hunt for food"
                ],
                [
                    "kaignaskam iraluani.",
                    "in this month."
                ]
            ],
            "fullEnglish": "We always hunt for food in this month."
        },
        "9": {
            "startTime": 41.765,
            "endTime": 45.095,
            "sug": [
                [
                    "Uqna’isurt’sqaaq",
                    "April (The Warming"
                ],
                [
                    "Iraluq",
                    "Moon)."
                ]
            ],
            "fullEnglish": "April (The Warming Moon)."
        },
        "10": {
            "startTime": 45.095,
            "endTime": 49.904,
            "sug": [
                [
                    "Macaq",
                    "The sun"
                ],
                [
                    "suarnirtaartuq",
                    "comes up earlier"
                ],
                [
                    "iraluani.",
                    "in this month."
                ]
            ],
            "fullEnglish": "The sun comes up earlier in this month."
        },
        "11": {
            "startTime": 53.876,
            "endTime": 56.727,
            "sug": [
                [
                    "Nikllit",
                    "May (The Red Salmon’s"
                ],
                [
                    "Iraluat",
                    "Moon)."
                ]
            ],
            "fullEnglish": "May (The Red Salmon’s Moon)."
        },
        "12": {
            "startTime": 56.727,
            "endTime": 61.852,
            "sug": [
                [
                    "Nikllit",
                    "Red salmon"
                ],
                [
                    "aq’alartaartut",
                    "jump"
                ],
                [
                    "iraluani.",
                    "in this month."
                ]
            ],
            "fullEnglish": "Red salmon jump in this month."
        },
        "13": {
            "startTime": 61.852,
            "endTime": 64.377,
            "sug": [
                [
                    "Naut’staat",
                    "June (The Plant’s"
                ],
                [
                    "Iraluat",
                    "Moon)."
                ]
            ],
            "fullEnglish": "June (The Plant’s Moon)."
        },
        "14": {
            "startTime": 64.377,
            "endTime": 68.796,
            "sug": [
                [
                    "Suit’kaat",
                    "Flowers"
                ],
                [
                    "nautaartut",
                    "grow"
                ],
                [
                    "iraluani.",
                    "in this month."
                ]
            ],
            "fullEnglish": "Flowers grow in this month."
        },
        "15": {
            "startTime": 72.777,
            "endTime": 75.437,
            "sug": [
                [
                    "Amartut",
                    "July (The Pink Salmon’s"
                ],
                [
                    "Iraluat",
                    "Moon)."
                ]
            ],
            "fullEnglish": "July (The Pink Salmon’s Moon)."
        },
        "16": {
            "startTime": 75.437,
            "endTime": 81.862,
            "sug": [
                [
                    "Amlesqat",
                    "Lots of"
                ],
                [
                    "amartut",
                    "pink salmon"
                ],
                [
                    "qetgautaartut",
                    "jump"
                ],
                [
                    "iraluani.",
                    "in this month."
                ]
            ],
            "fullEnglish": "Lots of pink salmon jump in this month."
        },
        "17": {
            "startTime": 81.862,
            "endTime": 85.221,
            "sug": [
                [
                    "Alagnat",
                    "August (The Berries’"
                ],
                [
                    "Iraluat",
                    "Moon)."
                ]
            ],
            "fullEnglish": "August (The Berries’ Moon)."
        },
        "18": {
            "startTime": 85.221,
            "endTime": 89.927,
            "sug": [
                [
                    "Alagnat",
                    "Salmonberries"
                ],
                [
                    "nautartut",
                    "grow"
                ],
                [
                    "iraluani.",
                    "in this month."
                ]
            ],
            "fullEnglish": "Salmonberries grow in this month."
        },
        "19": {
            "startTime": 93.917,
            "endTime": 97.159,
            "sug": [
                [
                    "Qakiiyat",
                    "September (The Silver Salmon’s"
                ],
                [
                    "Iraluat",
                    "Moon)."
                ]
            ],
            "fullEnglish": "September (The Silver Salmon’s Moon)."
        },
        "20": {
            "startTime": 97.159,
            "endTime": 102.428,
            "sug": [
                [
                    "Qakiiyanek palkalitaartukut",
                    "We make smoke silver salmon"
                ],
                [
                    "iraluani.",
                    "in this month."
                ]
            ],
            "fullEnglish": "We make smoke silver salmon in this month."
        },
        "21": {
            "startTime": 102.428,
            "endTime": 105.316,
            "sug": [
                [
                    "Kakegllum",
                    "October (The Moon of Runny"
                ],
                [
                    "Iralua",
                    "Nose)."
                ]
            ],
            "fullEnglish": "October (The Moon of Runny Nose)."
        },
        "22": {
            "startTime": 105.316,
            "endTime": 109.536,
            "sug": [
                [
                    "Piciruataartukut",
                    "We usually get a cold"
                ],
                [
                    "iraluani.",
                    "in this month."
                ]
            ],
            "fullEnglish": "We usually get a cold in this month."
        },
        "23": {
            "startTime": 113.712,
            "endTime": 116.468,
            "sug": [
                [
                    "Quyawim",
                    "November (The Thanksgiving"
                ],
                [
                    "Iralua",
                    "Moon)."
                ]
            ],
            "fullEnglish": "November (The Thanksgiving Moon)."
        },
        "24": {
            "startTime": 116.468,
            "endTime": 121.111,
            "sug": [
                [
                    "Quyataartukut",
                    "We are always thankful"
                ],
                [
                    "quyawim iraluani.",
                    "in this month."
                ]
            ],
            "fullEnglish": "We are always thankful in this month."
        },
        "25": {
            "startTime": 121.111,
            "endTime": 123.695,
            "sug": [
                [
                    "Qanim",
                    "December (The Snow’s"
                ],
                [
                    "Iralua",
                    "Moon)."
                ]
            ],
            "fullEnglish": "December (The Snow’s Moon)."
        },
        "26": {
            "startTime": 123.695,
            "endTime": 128.028,
            "sug": [
                [
                    "Rausistuartaartukut / Aʀausistuartaartukut*",
                    "We have Christmas"
                ],
                [
                    "iraluani.",
                    "in this month."
                ]
            ],
            "fullEnglish": "We have Christmas in this month."
        }
    }
};